var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import axios from "axios";
import striptags from "striptags";
import { XmlEntities } from "html-entities";
import isEqual from "lodash.isequal";
import { MD5 } from "object-hash";
import * as Sentry from "@sentry/vue";
import { createGtm, useGtm } from "@gtm-support/vue-gtm";
import Plausible from "plausible-tracker";
function trimTrailingSlash(url) {
  return url != null && url.endsWith("/") ? url.substring(0, url.length - 1) : url;
}
__name(trimTrailingSlash, "trimTrailingSlash");
function addTrailingSlash$1(url) {
  return url != null && url.endsWith("/") == !1 ? url + "/" : url;
}
__name(addTrailingSlash$1, "addTrailingSlash$1");
const AXIOS_ERROR_RETRY_LIMIT = 0, AXIOS_ERROR_RETRY_LIST = "500;502;503;504", AXIOS_ERROR_CODE_RETRY_LIST = "ECONNRESET", AXIOS_GET_TIMEOUT = 0, AAT_URL = "https://data.getty.edu/vocab/aat/", TGN_URL = "https://data.getty.edu/vocab/tgn/", ULAN_URL = "https://data.getty.edu/vocab/ulan/", AAT_SUFFIX = "", ID_MANAGER_URL = "https://services.getty.edu/id-management", DEFAULT_ALLOWED_ENV_VARS = ["ID_MANAGER_BASE_URL", "ID_MANAGER_DATA_URL"];
function getEnv(process_value, default_value) {
  return process_value != null && process_value.trim() != "" ? process_value : default_value;
}
__name(getEnv, "getEnv");
function getBooleanEnv(process_value, default_value) {
  return process_value == null ? default_value : typeof process_value == "boolean" ? process_value : process_value.trim() != "" ? process_value.toLowerCase().indexOf("t") > -1 : default_value;
}
__name(getBooleanEnv, "getBooleanEnv");
function getIntEnv(process_value, default_value) {
  if (process_value != null && process_value.trim() != "") {
    const intProcessValue = parseInt(process_value);
    return typeof intProcessValue != "number" ? (console.error(
      `Environment Variable value ${process_value} is not a number (default used instead)`
    ), parseInt(default_value)) : intProcessValue;
  }
  return parseInt(default_value);
}
__name(getIntEnv, "getIntEnv");
function getConfig(configId) {
  let configElement = document.getElementById(configId);
  if (configElement == null)
    return;
  let txt = configElement.innerText;
  if (txt != null)
    try {
      return JSON.parse(txt);
    } catch (e) {
      console.error(e);
    }
}
__name(getConfig, "getConfig");
let isNode$1 = new Function("try {return this===global;}catch(e){return false;}"), getProcessEnv = new Function(
  "try {return process?.env || {};} catch(e){return {};}"
);
function getConfigValue(key, configId = "appConfig", defaultValue) {
  let config;
  if (isNode$1()) {
    config = {};
    const env = getProcessEnv();
    let allowed = env.NODE_ENV_ALLOWED_LIST?.split(",") || [];
    allowed = allowed.concat(DEFAULT_ALLOWED_ENV_VARS), allowed.forEach((key2) => {
      config[key2] = env[key2];
    });
  } else
    config = getConfig(configId);
  return config != null && config[key] != null ? config[key] : defaultValue;
}
__name(getConfigValue, "getConfigValue");
function getBooleanConfigValue(key, id, defaultValue) {
  let val = getConfigValue(key, id, defaultValue);
  return getBooleanEnv(val, defaultValue);
}
__name(getBooleanConfigValue, "getBooleanConfigValue");
function getIntConfigValue(key, id, defaultValue) {
  let val = getConfigValue(key, id, defaultValue);
  return getIntEnv(val, defaultValue);
}
__name(getIntConfigValue, "getIntConfigValue");
function getAxiosGetTimeout() {
  return getIntEnv(process.env.AXIOS_GET_TIMEOUT, AXIOS_GET_TIMEOUT);
}
__name(getAxiosGetTimeout, "getAxiosGetTimeout");
function getAxiosRetryLimit() {
  return getIntEnv(
    process.env.AXIOS_ERROR_RETRY_LIMIT,
    AXIOS_ERROR_RETRY_LIMIT
  );
}
__name(getAxiosRetryLimit, "getAxiosRetryLimit");
function getAxiosErrorCodeRetryList() {
  return getEnv(
    process.env.AXIOS_ERROR_CODE_RETRY_LIST,
    AXIOS_ERROR_CODE_RETRY_LIST
  ).split(";");
}
__name(getAxiosErrorCodeRetryList, "getAxiosErrorCodeRetryList");
function getAxiosRetryList() {
  return getEnv(
    process.env.AXIOS_ERROR_RETRY_LIST,
    AXIOS_ERROR_RETRY_LIST
  ).split(";").map((x) => parseInt(x));
}
__name(getAxiosRetryList, "getAxiosRetryList");
function getSentryId(logger) {
  let res;
  try {
    document != null && (res = getConfigValue("SENTRY_ID"));
  } catch (e) {
    logger && logger.trace(e);
  }
  return res;
}
__name(getSentryId, "getSentryId");
function getEnvironment(logger) {
  let res;
  try {
    document != null && (res = getConfigValue("APP_ENVIRONMENT", void 0, "dev"));
  } catch (e) {
    logger && logger.trace(e);
  }
  return res;
}
__name(getEnvironment, "getEnvironment");
function getFilteredBrowsers(logger) {
  let res = "None";
  try {
    document != null && (res = getConfigValue("SENTRY_BROWSERS", void 0, "yeti"));
  } catch (e) {
    logger && logger.trace(e);
  }
  return res.split(",");
}
__name(getFilteredBrowsers, "getFilteredBrowsers");
function getGoogleAnalyticsId(logger) {
  let res;
  try {
    document != null && (res = getConfigValue("GOOGLE_ANALYTICS_ID"));
  } catch (e) {
    logger && logger.trace(e);
  }
  return res;
}
__name(getGoogleAnalyticsId, "getGoogleAnalyticsId");
function getIgnoreVocabList(logger) {
  let res = "None";
  try {
    document != null && (res = getConfigValue("IGNORE_VOCAB_LIST", void 0, res));
  } catch (e) {
    logger && logger.trace(e);
  }
  return res = getEnv(process.env.IGNORE_VOCAB_LIST, res), res.split(";");
}
__name(getIgnoreVocabList, "getIgnoreVocabList");
function getAATUrl(logger) {
  try {
    if (document != null)
      return getConfigValue("AAT_URL", void 0, AAT_URL);
  } catch (e) {
    logger && logger.trace(e);
  }
  return process.env.AAT_URL != null && process.env.AAT_URL.indexOf("http") > -1 ? process.env.AAT_URL : AAT_URL;
}
__name(getAATUrl, "getAATUrl");
function getAATSuffix(logger) {
  try {
    if (document != null)
      return getConfigValue("AAT_SUFFIX", void 0, AAT_SUFFIX);
  } catch (e) {
    logger && logger.trace(e);
  }
  return process.env.AAT_SUFFIX != null ? process.env.AAT_SUFFIX : AAT_SUFFIX;
}
__name(getAATSuffix, "getAATSuffix");
function getTGNUrl(logger) {
  try {
    if (document != null)
      return getConfigValue("TGN_URL", void 0, TGN_URL);
  } catch (e) {
    logger && logger.trace(e);
  }
  return process.env.TGN_URL != null && process.env.TGN_URL.indexOf("http") > -1 ? process.env.TGN_URL : TGN_URL;
}
__name(getTGNUrl, "getTGNUrl");
function getULANUrl(logger) {
  try {
    if (document != null)
      return getConfigValue("ULAN_URL", void 0, ULAN_URL);
  } catch (e) {
    logger && logger.trace(e);
  }
  return process.env.ULAN_URL != null && process.env.ULAN_URL.indexOf("http") > -1 ? process.env.ULAN_URL : ULAN_URL;
}
__name(getULANUrl, "getULANUrl");
function getLocationBanner() {
  return getConfigValue("LOCATION_BANNER_LOCATION");
}
__name(getLocationBanner, "getLocationBanner");
function getIiifImageBaseUrl() {
  return getConfigValue(
    "IIIF_IMAGE_BASE_URL",
    void 0,
    "https://media.getty.edu/iiif/image"
  );
}
__name(getIiifImageBaseUrl, "getIiifImageBaseUrl");
function logDeprecationWarnings() {
  return getConfigValue("LOG_DEPRECATION_WARNINGS");
}
__name(logDeprecationWarnings, "logDeprecationWarnings");
function getIdManagerUrl$1(logger, defaultValue = ID_MANAGER_URL) {
  try {
    if (isNode$1() == !1 && document != null)
      return getConfigValue("ID_MANAGER_URL", void 0, defaultValue);
  } catch (e) {
    logger && logger.trace(e);
  }
  return getEnv(process.env.ID_MANAGER_URL, defaultValue);
}
__name(getIdManagerUrl$1, "getIdManagerUrl$1");
function getIdManagerDataUrl(defaultValue = getDataUrl()) {
  return addTrailingSlash(
    getConfigValue("ID_MANAGER_DATA_URL", void 0, defaultValue)
  );
}
__name(getIdManagerDataUrl, "getIdManagerDataUrl");
function getIIIFBaseUrl() {
  return getConfigValue(
    "IIIF_BASE_URL",
    void 0,
    "https://media.getty.edu/iiif/image"
  );
}
__name(getIIIFBaseUrl, "getIIIFBaseUrl");
function getIIIFImageUrlPart() {
  return getConfigValue("IIIF_IMAGE_URL_PART", void 0, "image");
}
__name(getIIIFImageUrlPart, "getIIIFImageUrlPart");
function getIdManagerUsername() {
  return getEnv(process.env.ID_MANAGER_USERNAME, "dummy");
}
__name(getIdManagerUsername, "getIdManagerUsername");
function getIdManagerPassword$1() {
  return getEnv(process.env.ID_MANAGER_PASSWORD, "MAGIC_KEY");
}
__name(getIdManagerPassword$1, "getIdManagerPassword$1");
function getBaseUrlForIdManager(defaultValue) {
  let url = getConfigValue(
    "ID_MANAGER_BASE_URL",
    void 0,
    getAppUrl()
  );
  return trimTrailingSlash(url);
}
__name(getBaseUrlForIdManager, "getBaseUrlForIdManager");
function getContentStackApiKey() {
  return getConfigValue("CONTENTSTACK_API_KEY");
}
__name(getContentStackApiKey, "getContentStackApiKey");
function getContentStackDeliveryToken() {
  return getConfigValue("CONTENTSTACK_DELIVERY_TOKEN");
}
__name(getContentStackDeliveryToken, "getContentStackDeliveryToken");
function getContentStackEnvironment() {
  return getConfigValue("CONTENTSTACK_ENVIRONMENT");
}
__name(getContentStackEnvironment, "getContentStackEnvironment");
function getDataUrl(defaultValue) {
  return getConfigValue("DATA_URL", void 0, defaultValue);
}
__name(getDataUrl, "getDataUrl");
function getMediaGatewayUrl() {
  return getConfigValue(
    "MEDIA_DATA_URL",
    void 0,
    "https://data.getty.edu/media/"
  );
}
__name(getMediaGatewayUrl, "getMediaGatewayUrl");
function stripPunctuationFromQuery() {
  return getBooleanConfigValue(
    "STRIP_PUNCTUATION_FROM_QUERY_STRING",
    void 0,
    !0
  );
}
__name(stripPunctuationFromQuery, "stripPunctuationFromQuery");
function getAppUrl() {
  return getConfigValue("APP_URL", void 0, "https://www.getty.edu/");
}
__name(getAppUrl, "getAppUrl");
function getApiPath() {
  return getConfigValue("API_PATH", void 0, getAppUrl());
}
__name(getApiPath, "getApiPath");
function getAlertInfo() {
  const urgent = getBooleanConfigValue("ALERT_IS_URGENT", void 0, !0), title = getConfigValue("ALERT_TYPE", void 0, ""), content = getConfigValue("ALERT_MESSAGE", void 0, "");
  if (content != null && content.trim() != "")
    return {
      active: !0,
      content,
      title,
      uid: "5FHi8FDXBzBOzhdNAjuZMK",
      urgent
    };
}
__name(getAlertInfo, "getAlertInfo");
function getMiradorUrl() {
  return getConfigValue(
    "MIRADOR_URL",
    void 0,
    "https://staging-tools.aws.getty.edu/iiifviewer/"
  );
}
__name(getMiradorUrl, "getMiradorUrl");
function getGettyUIBaseUrl() {
  return getConfigValue(
    "GETTY_UI_BASE_URL",
    void 0,
    "https://www.getty.edu"
  );
}
__name(getGettyUIBaseUrl, "getGettyUIBaseUrl");
const settings = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getAATSuffix,
  getAATUrl,
  getAlertInfo,
  getApiPath,
  getAppUrl,
  getAxiosErrorCodeRetryList,
  getAxiosGetTimeout,
  getAxiosRetryLimit,
  getAxiosRetryList,
  getBaseUrlForIdManager,
  getBooleanConfigValue,
  getBooleanEnv,
  getConfig,
  getConfigValue,
  getContentStackApiKey,
  getContentStackDeliveryToken,
  getContentStackEnvironment,
  getDataUrl,
  getEnv,
  getEnvironment,
  getFilteredBrowsers,
  getGettyUIBaseUrl,
  getGoogleAnalyticsId,
  getIIIFBaseUrl,
  getIIIFImageUrlPart,
  getIdManagerDataUrl,
  getIdManagerPassword: getIdManagerPassword$1,
  getIdManagerUrl: getIdManagerUrl$1,
  getIdManagerUsername,
  getIgnoreVocabList,
  getIiifImageBaseUrl,
  getIntConfigValue,
  getIntEnv,
  getLocationBanner,
  getMediaGatewayUrl,
  getMiradorUrl,
  getSentryId,
  getTGNUrl,
  getULANUrl,
  logDeprecationWarnings,
  stripPunctuationFromQuery
}, Symbol.toStringTag, { value: "Module" }));
function constructUrl(_baseUrl, type, id) {
  let url = "/";
  return _baseUrl != null && (url = _baseUrl), url = addTrailingSlash$1(url), type != null && (url += type + "/"), url += id, url;
}
__name(constructUrl, "constructUrl");
const DataServiceUtils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  constructUrl
}, Symbol.toStringTag, { value: "Module" }));
function getObjId(object) {
  if (object == null)
    return;
  let url = object.id;
  if (url != null)
    return getIndexedId(url);
}
__name(getObjId, "getObjId");
function getIndexedId(url) {
  if (url == null || typeof url != "string")
    return url;
  url = url.replace("urn:uuid:", ""), url = trimTrailingSlash(url);
  const urlParts = url.split("/");
  return urlParts.length == 1 ? urlParts[0] : urlParts[urlParts.length - 2] + "/" + urlParts[urlParts.length - 1];
}
__name(getIndexedId, "getIndexedId");
let isNode = new Function("try {return this===global;}catch(e){return false;}"), axiosCallCount = 0;
const axiosInstance = axios.create({
  timeout: getAxiosGetTimeout()
});
function getCount() {
  return axiosCallCount;
}
__name(getCount, "getCount");
function incrementCount() {
  axiosCallCount = axiosCallCount + 1, isNode() == !1 && (window.axiosCallCount = axiosCallCount);
}
__name(incrementCount, "incrementCount");
function resetCount() {
  axiosCallCount = 0, isNode() == !1 && (window.axiosCallCount = axiosCallCount);
}
__name(resetCount, "resetCount");
async function axiosGet(url_, requestParams = void 0, searchParams = {}) {
  incrementCount();
  let url = url_, sp;
  if (searchParams) {
    if (sp = searchParams, sp && sp.constructor != URLSearchParams) {
      sp = new URLSearchParams();
      for (const key in searchParams)
        Array.isArray(searchParams[key]) ? searchParams[key].forEach((entry) => {
          sp.append(key, entry);
        }) : sp.append(key, searchParams[key]);
    }
    const query = sp.toString();
    query && query.length > 0 && (url.indexOf("?") == -1 && (url += "?"), url += query);
  }
  return axiosInstance.get(url, requestParams).catch((err) => {
    if (axios.isCancel(err))
      console.warn("Request canceled", `${url}/${sp.toString()}`);
    else if (getBooleanConfigValue("THROW_AXIOSGET_ERROR", void 0, !0))
      throw err;
  });
}
__name(axiosGet, "axiosGet");
async function axiosPost(url, requestParams, axiosConfig) {
  return incrementCount(), axiosInstance.post(url, requestParams, axiosConfig);
}
__name(axiosPost, "axiosPost");
function get(_baseUrl, type, id) {
  incrementCount();
  let url = _baseUrl;
  type != null && id != null && (url = constructUrl(_baseUrl, type, id));
  try {
    return axiosGet(url);
  } catch (err) {
    return err;
  }
}
__name(get, "get");
function injectLastUpdated(result) {
  if (!(result?.data == null || result?.headers == null)) {
    if (result.headers && result.headers["last-modified"])
      result.data.last_updated = result.headers["last-modified"];
    else if (result.headers && result.headers["content-length"]) {
      const re = /last-modified: (.*)/;
      let lastUpdated = result.headers["content-length"].match(re);
      lastUpdated && (result.data.last_updated = lastUpdated[1]);
    }
  }
}
__name(injectLastUpdated, "injectLastUpdated");
async function getAllById(ids_, baseUrl, filterBadRequests = !0) {
  let ids = ids_;
  Array.isArray(ids_) == !1 && (ids = [ids_]);
  let requests = [];
  ids.forEach((id) => {
    let url = id;
    typeof id != "string" && "id" in id && (url = id.id), baseUrl && (url = constructUrl(baseUrl, void 0, getIndexedId(id))), requests.push(axiosGet(url));
  });
  let results = await Promise.allSettled(requests);
  return results = results.map((obj) => (injectLastUpdated(obj?.value), obj?.value?.data)), Array.isArray(ids_) == !1 ? results[0] : (filterBadRequests && (results = results.filter((result) => result != null)), results);
}
__name(getAllById, "getAllById");
function getFromObject(obj) {
  incrementCount();
  let { baseUrl, id } = obj, url = id;
  baseUrl != null && (url = constructUrl(baseUrl, void 0, id));
  try {
    return axiosGet(url);
  } catch (err) {
    return err;
  }
}
__name(getFromObject, "getFromObject");
function constructVocabUrl(id_, type) {
  let id = id_;
  id = trimTrailingSlash(id), id = id.substring(id.lastIndexOf("/") + 1);
  let typeUrl = getAATUrl(), fullUrl;
  return type == "ULAN" && (typeUrl = getULANUrl()), type == "TGN" && (typeUrl = getTGNUrl()), fullUrl = typeUrl + id, fullUrl;
}
__name(constructVocabUrl, "constructVocabUrl");
function getVocabObject(id_, type, logger) {
  let fullUrl = constructVocabUrl(id_, type);
  return logger && logger.trace("request::vocab: " + fullUrl), axiosGet(fullUrl, {
    crossDomain: !0,
    crossOrigin: !0,
    headers: { "Access-Control-Allow-Origin": "*" }
  });
}
__name(getVocabObject, "getVocabObject");
function facetSearch({
  facet,
  query,
  size,
  filters,
  root = getApiPath(),
  extra = {}
}) {
  const url = root + "api/facets";
  extra.facet = facet;
  let params = buildSearchParams({ from: 0, size, filters, query, extra });
  return axiosGet(url, void 0, params);
}
__name(facetSearch, "facetSearch");
function buildSearchParams({
  from,
  size,
  filters,
  query = [],
  sort,
  extra = {}
}) {
  let params = new URLSearchParams({ from, size });
  sort != null && params.append("sort", sort), query.forEach((term) => {
    params.append("q", term);
  });
  for (let key in filters)
    filters[key].forEach((filter) => {
      params.append(key, filter);
    });
  for (let key in extra)
    Array.isArray(extra[key]) ? extra[key].forEach((val) => {
      params.append(key, val);
    }) : extra[key] != null && params.append(key, extra[key]);
  return params;
}
__name(buildSearchParams, "buildSearchParams");
function keywordSearch({
  query,
  from,
  size,
  filters,
  sort = void 0,
  extra = {},
  root = getApiPath(),
  path = "api/search"
}) {
  const url = root + path;
  let params = buildSearchParams({ from, size, filters, query, sort, extra });
  return axiosGet(url, void 0, params);
}
__name(keywordSearch, "keywordSearch");
function paramsSearch({
  query,
  from,
  size,
  filters,
  sort = void 0,
  extra = {},
  root = getApiPath(),
  path = "api/search",
  requestParams = void 0
}) {
  const params = buildSearchParams({ from, size, filters, query, sort, extra }), url = root + path;
  return axiosGet(url, requestParams, params);
}
__name(paramsSearch, "paramsSearch");
function relationshipSearch(id, rel, from, size, query, root = getApiPath()) {
  const url = root + "api/relationships";
  let actionParams = {
    id,
    from,
    size
  };
  return rel && (actionParams.rel = rel), query && (actionParams.q = query), axiosGet(url, void 0, actionParams);
}
__name(relationshipSearch, "relationshipSearch");
function typeAhead(root = getApiPath()) {
  return root + "api/typeahead?prefix=:keyword&auto=true";
}
__name(typeAhead, "typeAhead");
async function getSlugs(lookupObjects, baseDataUrl, bodyGenerator, targetGenerator, resultMap = {}) {
  const idManagerParams = {
    bodyGenerator,
    targetGenerator
  };
  let objectFullIds = [];
  for (let obj of lookupObjects) {
    const indexedId = getIndexedId(obj.id);
    resultMap[indexedId] || objectFullIds.push(`${trimTrailingSlash(baseDataUrl)}/${indexedId}`);
  }
  let lookupResults = await lookupUrlFromUuid(
    objectFullIds,
    idManagerParams.bodyGenerator,
    idManagerParams.targetGenerator,
    !0,
    void 0
  );
  for (let group of lookupResults)
    for (let item of group) {
      let parts = getIndexedId(item.body.id).split("/");
      resultMap[getIndexedId(item.target.id)] = {
        path: parts[0],
        slug: parts[1]
      };
    }
  return resultMap;
}
__name(getSlugs, "getSlugs");
async function getElasticObject(id, root = getApiPath()) {
  let result = await fetchElasticSearchObjects([id], root);
  if (result?.length > 0)
    return result[0];
}
__name(getElasticObject, "getElasticObject");
async function fetchElasticSearchObjects(ids, root = getApiPath()) {
  let results;
  if (ids.length == 0)
    return [];
  try {
    return results = await axiosGet(`${root}api/get`, void 0, {
      id: ids
    }), results?.data?.data;
  } catch (e) {
    console.error(e);
  }
  return [];
}
__name(fetchElasticSearchObjects, "fetchElasticSearchObjects");
async function fetchAutocompleteSuggestions(params, root = getApiPath()) {
  return (await paramsSearch({
    from: params.from || 0,
    size: params.size || 100,
    filters: { prefix: [params.prefix] },
    extra: { auto: !0 },
    root,
    path: "api/typeahead",
    requestParams: { signal: params.signal }
  }))?.data?.result;
}
__name(fetchAutocompleteSuggestions, "fetchAutocompleteSuggestions");
async function fetchFacets(params, root = getApiPath()) {
  let extra = { facet: params.facet };
  return params.filter_prefix && (extra.filter_prefix = params.filter_prefix), (await paramsSearch({
    query: params.query,
    from: 0,
    size: params.size || 500,
    filters: params.filters,
    sort: params.sort,
    extra,
    root,
    path: "api/facets"
  }))?.data;
}
__name(fetchFacets, "fetchFacets");
async function fetchSearch(params, root = getApiPath()) {
  let _params = JSON.parse(JSON.stringify(params)), extra = {};
  return (params.debug || params.source || params._source) && (extra.debug = params.debug, extra.source = params.source, extra._source = params._source), (await paramsSearch({
    query: _params.query,
    from: _params.from || 0,
    size: _params.size || 48,
    sort: _params.sort,
    filters: _params.filters,
    extra,
    root
  }))?.data;
}
__name(fetchSearch, "fetchSearch");
const DataService = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  axiosGet,
  axiosInstance,
  axiosPost,
  buildSearchParams,
  constructVocabUrl,
  facetSearch,
  fetchAutocompleteSuggestions,
  fetchElasticSearchObjects,
  fetchFacets,
  fetchSearch,
  get,
  getAllById,
  getCount,
  getElasticObject,
  getFromObject,
  getSlugs,
  getVocabObject,
  injectLastUpdated,
  keywordSearch,
  paramsSearch,
  relationshipSearch,
  resetCount,
  typeAhead
}, Symbol.toStringTag, { value: "Module" })), _IdManagerError = class _IdManagerError extends Error {
  constructor(message, cause) {
    super(message), this.cause = cause, cause && (this.initialMessage = cause.message, this.initialCause = cause.stack), this.name = "IDManagerError", Error.captureStackTrace && Error.captureStackTrace(this, _IdManagerError);
  }
};
__name(_IdManagerError, "IdManagerError");
let IdManagerError = _IdManagerError;
const MOTIVATION = "https://data.getty.edu/local/thesaurus/motivations/related_to";
function getIdManagerUrl() {
  let url = getIdManagerUrl$1();
  return url = trimTrailingSlash(url), url;
}
__name(getIdManagerUrl, "getIdManagerUrl");
function getIdManagerUser() {
  return getIdManagerUsername();
}
__name(getIdManagerUser, "getIdManagerUser");
function getIdManagerPassword() {
  return getIdManagerPassword$1();
}
__name(getIdManagerPassword, "getIdManagerPassword");
let TOKEN;
async function login(logger) {
  logger && logger.debug("idmanager::login");
  let result;
  try {
    result = await axiosPost(
      getIdManagerUrl() + "/auth",
      {
        username: getIdManagerUser(),
        password: getIdManagerPassword()
      },
      { headers: { "Content-Type": "application/json" } }
    ), TOKEN = result.data.access_token;
  } catch (e) {
    throw logger && logger.error("%s", e.message), new IdManagerError(e.message, e);
  }
  return TOKEN;
}
__name(login, "login");
function logout() {
  TOKEN = void 0;
}
__name(logout, "logout");
function getAndAppend(url, query, field_name) {
  if (!(url == null || query == null || field_name == null)) {
    if (query[field_name] != null && query[field_name] != "") {
      if (!Array.isArray(query[field_name]))
        url += "&" + field_name + "=" + query[field_name];
      else if (Array.isArray(query[field_name]) && query[field_name].length != 0)
        for (let i = 0; i < query[field_name].length; i++)
          query[field_name][i] && (url += "&" + field_name + "=" + query[field_name][i]);
    }
    return url;
  }
}
__name(getAndAppend, "getAndAppend");
async function queryIdManager(query, dataService = DataService, logger) {
  let url = getIdManagerUrl();
  return url = addTrailingSlash$1(url), url += "links/?page=1", url = getAndAppend(url, query, "target_id"), url = getAndAppend(url, query, "target_generator"), url = getAndAppend(url, query, "body_id"), url = getAndAppend(url, query, "body_generator"), url = getAndAppend(url, query, "motivation"), logger && logger.debug(`idmanager::query: ${url}`), await dataService.axiosGet(url);
}
__name(queryIdManager, "queryIdManager");
async function lookupUuidFromUrl(id, target_generator, logger, dataService = DataService) {
  logger && logger.debug("idmanager::lookupUuidFromUrl %s", id);
  let result, query = { body_id: id };
  try {
    result = await queryIdManager(query, dataService, logger), logger && logger.debug(
      "idmanager::lookupUuidFromUrl::Results: (%s)",
      result.data.length
    );
  } catch (e) {
    throw new IdManagerError(e.message, e);
  }
  let match = evaluateResults(
    result,
    function(item, id2) {
      return item.motivation == MOTIVATION && item.target.generator == target_generator && item.body.id == id2;
    },
    query,
    logger
  );
  if (match[id] && match[id].target)
    return match[id].target.id;
}
__name(lookupUuidFromUrl, "lookupUuidFromUrl");
function checkFilterMatch(id, filters, key) {
  let lookup = filters[key];
  return lookup == null || id == null ? !1 : !!(Array.isArray(lookup) && lookup.includes(id) || lookup == id);
}
__name(checkFilterMatch, "checkFilterMatch");
function appendToResult(idMatches, id, item, isValidCallback, logger) {
  isValidCallback(item, id) != !1 && (logger && logger.debug("idmanager::lookupId::FoundMatch: %o", item.target), (idMatches[id] == null || compareDates(idMatches[id], item) == !1) && (idMatches[id] = item));
}
__name(appendToResult, "appendToResult");
function compareDates(a, b) {
  return a.modified == b.modified ? 0 : Date.parse(a.modified) < Date.parse(b.modified) ? 1 : -1;
}
__name(compareDates, "compareDates");
function evaluateResults(result, isValidCallback, filters, logger) {
  let items = [];
  if (result && result.data && result.data.first && result.data.first.items && result.data.first.items.length > 0 && (items = result.data.first.items), result && result.data && result.data.items && result.data.items.length > 0 && (items = result.data.items), items.length < 1)
    return {};
  let idMatches = {};
  for (let item of items)
    item.target && checkFilterMatch(item.target.id, filters, "target_id") && appendToResult(idMatches, item.target.id, item, isValidCallback, logger), item.body && checkFilterMatch(item.body.id, filters, "body_id") && appendToResult(idMatches, item.body.id, item, isValidCallback, logger);
  return idMatches;
}
__name(evaluateResults, "evaluateResults");
async function confirmUrlFromUuid(id, computedUrl, target_generator, logger, dataService = DataService) {
  logger && logger.debug("idmanager::lookupId %s ==> %s", id, computedUrl);
  let result, query = { body_id: computedUrl, target_id: id };
  try {
    result = await queryIdManager(query, dataService, logger), logger && logger.debug("idmanager::lookupId::Results: (%s)", result.data.length);
  } catch (e) {
    throw new IdManagerError(e.message, e);
  }
  let match = evaluateResults(
    result,
    function(item, computedUrl2) {
      return item.motivation == MOTIVATION && item.target.generator == target_generator && item.body.id == computedUrl2;
    },
    query,
    logger
  );
  if (match[computedUrl] && match[computedUrl].body)
    return match[computedUrl].body.id;
}
__name(confirmUrlFromUuid, "confirmUrlFromUuid");
async function lookupUrlFromUuid(ids, body_generator, target_generator, idManagerBatchRequests, logger, dataService = DataService) {
  if (logger && logger.debug("idmanager::lookupUrlFromUuid %s ==> %s", ids, body_generator), !ids || ids.length == 0)
    return;
  let query = {
    body_generator,
    target_id: ids
  }, batches = [], size = idManagerBatchRequests ? 15 : 1, idsToBatch = [...ids];
  for (; idsToBatch.length >= size; )
    batches.push(idsToBatch.splice(0, size));
  return idsToBatch.length > 0 && batches.push(idsToBatch), (await Promise.allSettled(
    batches.map(async (batch2) => {
      let result;
      try {
        return result = await queryIdManager({
          body_generator,
          target_id: batch2
        }, dataService, logger), logger && logger.debug(
          "idmanager::lookupUrlFromUuid::Results: (%s)",
          result.data.length
        ), result;
      } catch (e) {
        throw new IdManagerError(e.message, e);
      }
    })
  )).map((request) => evaluateResults(
    request.value,
    function(item) {
      return item.motivation == MOTIVATION && item.target.generator == target_generator && item.body.generator == body_generator;
    },
    query,
    logger
  )).map((results) => Object.keys(results).map((key) => {
    if (ids.includes(key) && results[key] && results[key].body)
      return results[key];
  }));
}
__name(lookupUrlFromUuid, "lookupUrlFromUuid");
async function lookupUrlFromUuidOrMint(id, computedUrl, body_generator, target_generator, logger, dataService = DataService) {
  let existingId = await confirmUrlFromUuid(
    id,
    computedUrl,
    target_generator,
    logger,
    dataService
  );
  return logger && logger.debug(
    `idmanager::lookupAndMint: ${id} -> ${computedUrl} == ${existingId}`
  ), existingId != null && existingId == computedUrl ? existingId : (await createId(id, computedUrl, body_generator, target_generator, logger), computedUrl);
}
__name(lookupUrlFromUuidOrMint, "lookupUrlFromUuidOrMint");
async function createId(id, computedUrl, body_generator, target_generator, logger) {
  TOKEN == null && (TOKEN = await login());
  let result, req = [id, computedUrl, body_generator, target_generator, logger];
  try {
    result = await create$1(...req);
  } catch (e) {
    if (parseInt(e.status) == 403) {
      logger.debug("trying to login AGAIN"), TOKEN = await login();
      try {
        result = await create$1(...req);
      } catch (e2) {
        throw new IdManagerError(e2.message, {
          message: e2.message,
          stack: e2.stack,
          config: {
            url: e2.config.url,
            method: e2.config.method,
            headers: e2.config.headers
          },
          response: {
            status: e2.response.status,
            statusText: e2.response.statusText,
            headers: e2.response.headers,
            data: e2.response.data
          }
        });
      }
    }
  }
  return result;
}
__name(createId, "createId");
async function create$1(id, computedUrl, body_generator, target_generator, logger) {
  logger && logger.debug(`idmanager::createId: ${id} -> ${computedUrl}`);
  let template = {
    motivation: MOTIVATION,
    body: {
      id: computedUrl,
      generator: body_generator
    },
    target: {
      id,
      generator: target_generator
    }
  }, headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + TOKEN
  };
  return await axiosPost(
    getIdManagerUrl() + "/links/",
    template,
    {
      headers
    }
  );
}
__name(create$1, "create$1");
const idManagerService = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  confirmUrlFromUuid,
  createId,
  getAndAppend,
  login,
  logout,
  lookupUrlFromUuid,
  lookupUrlFromUuidOrMint,
  lookupUuidFromUrl,
  queryIdManager
}, Symbol.toStringTag, { value: "Module" }));
function getStack(Contentstack, API_KEY = getContentStackApiKey(), DELIVERY_TOKEN = (void 0)(), ENVIRONMENT = getContentStackEnvironment()) {
  if (API_KEY == null) {
    console.error("Content Stack API Key is undefined");
    return;
  }
  if (DELIVERY_TOKEN == null) {
    console.error("Content Stack Delivery Token is undefined");
    return;
  }
  if (ENVIRONMENT == null && (console.log("Content Stack Environment is undefined"), error = !0), Contentstack == null) {
    console.error("ContentStack not provided");
    return;
  }
  return Contentstack.Stack(API_KEY, DELIVERY_TOKEN, ENVIRONMENT);
}
__name(getStack, "getStack");
async function getContentStackEntry(Stack, contentType, entryId, references = []) {
  if (contentType == null)
    throw new Error("Content Type is undefined");
  if (entryId == null)
    throw new Error("Entry Id is undefined");
  if (Stack == null)
    throw new Error("ContentStack not provided or initialized properly");
  try {
    let Query = Stack.ContentType(contentType).Entry(entryId);
    return references.length && (Query = Query.includeReference(references)), Query = Query.toJSON(), await Query.fetch();
  } catch (e) {
    console.error(`could not retrieve ${contentType} from ContentStack`, e);
  }
}
__name(getContentStackEntry, "getContentStackEntry");
const ContentStackUtils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getContentStackEntry,
  getStack
}, Symbol.toStringTag, { value: "Module" })), entities = new XmlEntities();
function sanitize(value, _config) {
  if (_config == null)
    return value;
  let config;
  _config && _config.allowedTags && _config.allowedTags.length > 0 && (config = _config.allowedTags);
  let clean = striptags(value, config);
  return clean = entities.decode(clean), clean;
}
__name(sanitize, "sanitize");
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function makeMap(str) {
  const map2 = /* @__PURE__ */ Object.create(null);
  for (const key of str.split(",")) map2[key] = 1;
  return (val) => val in map2;
}
__name(makeMap, "makeMap");
const EMPTY_OBJ = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
process.env.NODE_ENV !== "production" && Object.freeze([]);
const NOOP = /* @__PURE__ */ __name(() => {
}, "NOOP"), isOn = /* @__PURE__ */ __name((key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
(key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97), "isOn"), extend = Object.assign, remove = /* @__PURE__ */ __name((arr, el) => {
  const i = arr.indexOf(el);
  i > -1 && arr.splice(i, 1);
}, "remove"), hasOwnProperty$2 = Object.prototype.hasOwnProperty, hasOwn$1 = /* @__PURE__ */ __name((val, key) => hasOwnProperty$2.call(val, key), "hasOwn$1"), isArray$1 = Array.isArray, isMap = /* @__PURE__ */ __name((val) => toTypeString$1(val) === "[object Map]", "isMap"), isSet = /* @__PURE__ */ __name((val) => toTypeString$1(val) === "[object Set]", "isSet"), isFunction$1 = /* @__PURE__ */ __name((val) => typeof val == "function", "isFunction$1"), isString$1 = /* @__PURE__ */ __name((val) => typeof val == "string", "isString$1"), isSymbol = /* @__PURE__ */ __name((val) => typeof val == "symbol", "isSymbol"), isObject$1 = /* @__PURE__ */ __name((val) => val !== null && typeof val == "object", "isObject$1"), isPromise$1 = /* @__PURE__ */ __name((val) => (isObject$1(val) || isFunction$1(val)) && isFunction$1(val.then) && isFunction$1(val.catch), "isPromise$1"), objectToString$1 = Object.prototype.toString, toTypeString$1 = /* @__PURE__ */ __name((value) => objectToString$1.call(value), "toTypeString$1"), toRawType = /* @__PURE__ */ __name((value) => toTypeString$1(value).slice(8, -1), "toRawType"), isPlainObject$1 = /* @__PURE__ */ __name((val) => toTypeString$1(val) === "[object Object]", "isPlainObject$1"), isIntegerKey = /* @__PURE__ */ __name((key) => isString$1(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key, "isIntegerKey"), cacheStringFunction = /* @__PURE__ */ __name((fn) => {
  const cache2 = /* @__PURE__ */ Object.create(null);
  return (str) => cache2[str] || (cache2[str] = fn(str));
}, "cacheStringFunction"), capitalize$1 = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1)), toHandlerKey = cacheStringFunction(
  (str) => str ? `on${capitalize$1(str)}` : ""
), hasChanged = /* @__PURE__ */ __name((value, oldValue) => !Object.is(value, oldValue), "hasChanged");
let _globalThis$1;
const getGlobalThis$1 = /* @__PURE__ */ __name(() => _globalThis$1 || (_globalThis$1 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), "getGlobalThis$1");
function normalizeStyle(value) {
  if (isArray$1(value)) {
    const res = {};
    for (let i = 0; i < value.length; i++) {
      const item = value[i], normalized = isString$1(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized)
        for (const key in normalized)
          res[key] = normalized[key];
    }
    return res;
  } else if (isString$1(value) || isObject$1(value))
    return value;
}
__name(normalizeStyle, "normalizeStyle");
const listDelimiterRE = /;(?![^(]*\))/g, propertyDelimiterRE = /:([^]+)/, styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
  const ret = {};
  return cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  }), ret;
}
__name(parseStringStyle, "parseStringStyle");
function normalizeClass(value) {
  let res = "";
  if (isString$1(value))
    res = value;
  else if (isArray$1(value))
    for (let i = 0; i < value.length; i++) {
      const normalized = normalizeClass(value[i]);
      normalized && (res += normalized + " ");
    }
  else if (isObject$1(value))
    for (const name in value)
      value[name] && (res += name + " ");
  return res.trim();
}
__name(normalizeClass, "normalizeClass");
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function warn$2(msg, ...args) {
  console.warn(`[Vue warn] ${msg}`, ...args);
}
__name(warn$2, "warn$2");
let activeEffectScope;
const _EffectScope = class _EffectScope {
  constructor(detached = !1) {
    this.detached = detached, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = activeEffectScope, !detached && activeEffectScope && (this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let i, l;
      if (this.scopes)
        for (i = 0, l = this.scopes.length; i < l; i++)
          this.scopes[i].pause();
      for (i = 0, l = this.effects.length; i < l; i++)
        this.effects[i].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let i, l;
      if (this.scopes)
        for (i = 0, l = this.scopes.length; i < l; i++)
          this.scopes[i].resume();
      for (i = 0, l = this.effects.length; i < l; i++)
        this.effects[i].resume();
    }
  }
  run(fn) {
    if (this._active) {
      const currentEffectScope = activeEffectScope;
      try {
        return activeEffectScope = this, fn();
      } finally {
        activeEffectScope = currentEffectScope;
      }
    } else process.env.NODE_ENV !== "production" && warn$2("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    activeEffectScope = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    activeEffectScope = this.parent;
  }
  stop(fromParent) {
    if (this._active) {
      this._active = !1;
      let i, l;
      for (i = 0, l = this.effects.length; i < l; i++)
        this.effects[i].stop();
      for (this.effects.length = 0, i = 0, l = this.cleanups.length; i < l; i++)
        this.cleanups[i]();
      if (this.cleanups.length = 0, this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++)
          this.scopes[i].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !fromParent) {
        const last = this.parent.scopes.pop();
        last && last !== this && (this.parent.scopes[this.index] = last, last.index = this.index);
      }
      this.parent = void 0;
    }
  }
};
__name(_EffectScope, "EffectScope");
let EffectScope = _EffectScope;
function effectScope(detached) {
  return new EffectScope(detached);
}
__name(effectScope, "effectScope");
function getCurrentScope() {
  return activeEffectScope;
}
__name(getCurrentScope, "getCurrentScope");
let activeSub;
const pausedQueueEffects = /* @__PURE__ */ new WeakSet(), _ReactiveEffect = class _ReactiveEffect {
  constructor(fn) {
    this.fn = fn, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, activeEffectScope && activeEffectScope.active && activeEffectScope.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, pausedQueueEffects.has(this) && (pausedQueueEffects.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || batch(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, cleanupEffect(this), prepareDeps(this);
    const prevEffect = activeSub, prevShouldTrack = shouldTrack;
    activeSub = this, shouldTrack = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && activeSub !== this && warn$2(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), cleanupDeps(this), activeSub = prevEffect, shouldTrack = prevShouldTrack, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let link = this.deps; link; link = link.nextDep)
        removeSub(link);
      this.deps = this.depsTail = void 0, cleanupEffect(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? pausedQueueEffects.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    isDirty(this) && this.run();
  }
  get dirty() {
    return isDirty(this);
  }
};
__name(_ReactiveEffect, "ReactiveEffect");
let ReactiveEffect = _ReactiveEffect, batchDepth = 0, batchedSub, batchedComputed;
function batch(sub, isComputed = !1) {
  if (sub.flags |= 8, isComputed) {
    sub.next = batchedComputed, batchedComputed = sub;
    return;
  }
  sub.next = batchedSub, batchedSub = sub;
}
__name(batch, "batch");
function startBatch() {
  batchDepth++;
}
__name(startBatch, "startBatch");
function endBatch() {
  if (--batchDepth > 0)
    return;
  if (batchedComputed) {
    let e = batchedComputed;
    for (batchedComputed = void 0; e; ) {
      const next = e.next;
      e.next = void 0, e.flags &= -9, e = next;
    }
  }
  let error2;
  for (; batchedSub; ) {
    let e = batchedSub;
    for (batchedSub = void 0; e; ) {
      const next = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (err) {
          error2 || (error2 = err);
        }
      e = next;
    }
  }
  if (error2) throw error2;
}
__name(endBatch, "endBatch");
function prepareDeps(sub) {
  for (let link = sub.deps; link; link = link.nextDep)
    link.version = -1, link.prevActiveLink = link.dep.activeLink, link.dep.activeLink = link;
}
__name(prepareDeps, "prepareDeps");
function cleanupDeps(sub) {
  let head, tail = sub.depsTail, link = tail;
  for (; link; ) {
    const prev = link.prevDep;
    link.version === -1 ? (link === tail && (tail = prev), removeSub(link), removeDep(link)) : head = link, link.dep.activeLink = link.prevActiveLink, link.prevActiveLink = void 0, link = prev;
  }
  sub.deps = head, sub.depsTail = tail;
}
__name(cleanupDeps, "cleanupDeps");
function isDirty(sub) {
  for (let link = sub.deps; link; link = link.nextDep)
    if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version))
      return !0;
  return !!sub._dirty;
}
__name(isDirty, "isDirty");
function refreshComputed(computed2) {
  if (computed2.flags & 4 && !(computed2.flags & 16) || (computed2.flags &= -17, computed2.globalVersion === globalVersion))
    return;
  computed2.globalVersion = globalVersion;
  const dep = computed2.dep;
  if (computed2.flags |= 2, dep.version > 0 && !computed2.isSSR && computed2.deps && !isDirty(computed2)) {
    computed2.flags &= -3;
    return;
  }
  const prevSub = activeSub, prevShouldTrack = shouldTrack;
  activeSub = computed2, shouldTrack = !0;
  try {
    prepareDeps(computed2);
    const value = computed2.fn(computed2._value);
    (dep.version === 0 || hasChanged(value, computed2._value)) && (computed2._value = value, dep.version++);
  } catch (err) {
    throw dep.version++, err;
  } finally {
    activeSub = prevSub, shouldTrack = prevShouldTrack, cleanupDeps(computed2), computed2.flags &= -3;
  }
}
__name(refreshComputed, "refreshComputed");
function removeSub(link, soft = !1) {
  const { dep, prevSub, nextSub } = link;
  if (prevSub && (prevSub.nextSub = nextSub, link.prevSub = void 0), nextSub && (nextSub.prevSub = prevSub, link.nextSub = void 0), process.env.NODE_ENV !== "production" && dep.subsHead === link && (dep.subsHead = nextSub), dep.subs === link && (dep.subs = prevSub, !prevSub && dep.computed)) {
    dep.computed.flags &= -5;
    for (let l = dep.computed.deps; l; l = l.nextDep)
      removeSub(l, !0);
  }
  !soft && !--dep.sc && dep.map && dep.map.delete(dep.key);
}
__name(removeSub, "removeSub");
function removeDep(link) {
  const { prevDep, nextDep } = link;
  prevDep && (prevDep.nextDep = nextDep, link.prevDep = void 0), nextDep && (nextDep.prevDep = prevDep, link.nextDep = void 0);
}
__name(removeDep, "removeDep");
let shouldTrack = !0;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack), shouldTrack = !1;
}
__name(pauseTracking, "pauseTracking");
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? !0 : last;
}
__name(resetTracking, "resetTracking");
function cleanupEffect(e) {
  const { cleanup } = e;
  if (e.cleanup = void 0, cleanup) {
    const prevSub = activeSub;
    activeSub = void 0;
    try {
      cleanup();
    } finally {
      activeSub = prevSub;
    }
  }
}
__name(cleanupEffect, "cleanupEffect");
let globalVersion = 0;
const _Link = class _Link {
  constructor(sub, dep) {
    this.sub = sub, this.dep = dep, this.version = dep.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
};
__name(_Link, "Link");
let Link = _Link;
const _Dep = class _Dep {
  constructor(computed2) {
    this.computed = computed2, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(debugInfo) {
    if (!activeSub || !shouldTrack || activeSub === this.computed)
      return;
    let link = this.activeLink;
    if (link === void 0 || link.sub !== activeSub)
      link = this.activeLink = new Link(activeSub, this), activeSub.deps ? (link.prevDep = activeSub.depsTail, activeSub.depsTail.nextDep = link, activeSub.depsTail = link) : activeSub.deps = activeSub.depsTail = link, addSub(link);
    else if (link.version === -1 && (link.version = this.version, link.nextDep)) {
      const next = link.nextDep;
      next.prevDep = link.prevDep, link.prevDep && (link.prevDep.nextDep = next), link.prevDep = activeSub.depsTail, link.nextDep = void 0, activeSub.depsTail.nextDep = link, activeSub.depsTail = link, activeSub.deps === link && (activeSub.deps = next);
    }
    return process.env.NODE_ENV !== "production" && activeSub.onTrack && activeSub.onTrack(
      extend(
        {
          effect: activeSub
        },
        debugInfo
      )
    ), link;
  }
  trigger(debugInfo) {
    this.version++, globalVersion++, this.notify(debugInfo);
  }
  notify(debugInfo) {
    startBatch();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let head = this.subsHead; head; head = head.nextSub)
          head.sub.onTrigger && !(head.sub.flags & 8) && head.sub.onTrigger(
            extend(
              {
                effect: head.sub
              },
              debugInfo
            )
          );
      for (let link = this.subs; link; link = link.prevSub)
        link.sub.notify() && link.sub.dep.notify();
    } finally {
      endBatch();
    }
  }
};
__name(_Dep, "Dep");
let Dep = _Dep;
function addSub(link) {
  if (link.dep.sc++, link.sub.flags & 4) {
    const computed2 = link.dep.computed;
    if (computed2 && !link.dep.subs) {
      computed2.flags |= 20;
      for (let l = computed2.deps; l; l = l.nextDep)
        addSub(l);
    }
    const currentTail = link.dep.subs;
    currentTail !== link && (link.prevSub = currentTail, currentTail && (currentTail.nextSub = link)), process.env.NODE_ENV !== "production" && link.dep.subsHead === void 0 && (link.dep.subsHead = link), link.dep.subs = link;
  }
}
__name(addSub, "addSub");
const targetMap = /* @__PURE__ */ new WeakMap(), ITERATE_KEY = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), MAP_KEY_ITERATE_KEY = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), ARRAY_ITERATE_KEY = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function track(target, type, key) {
  if (shouldTrack && activeSub) {
    let depsMap = targetMap.get(target);
    depsMap || targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    dep || (depsMap.set(key, dep = new Dep()), dep.map = depsMap, dep.key = key), process.env.NODE_ENV !== "production" ? dep.track({
      target,
      type,
      key
    }) : dep.track();
  }
}
__name(track, "track");
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    globalVersion++;
    return;
  }
  const run = /* @__PURE__ */ __name((dep) => {
    dep && (process.env.NODE_ENV !== "production" ? dep.trigger({
      target,
      type,
      key,
      newValue,
      oldValue,
      oldTarget
    }) : dep.trigger());
  }, "run");
  if (startBatch(), type === "clear")
    depsMap.forEach(run);
  else {
    const targetIsArray = isArray$1(target), isArrayIndex = targetIsArray && isIntegerKey(key);
    if (targetIsArray && key === "length") {
      const newLength = Number(newValue);
      depsMap.forEach((dep, key2) => {
        (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) && run(dep);
      });
    } else
      switch ((key !== void 0 || depsMap.has(void 0)) && run(depsMap.get(key)), isArrayIndex && run(depsMap.get(ARRAY_ITERATE_KEY)), type) {
        case "add":
          targetIsArray ? isArrayIndex && run(depsMap.get("length")) : (run(depsMap.get(ITERATE_KEY)), isMap(target) && run(depsMap.get(MAP_KEY_ITERATE_KEY)));
          break;
        case "delete":
          targetIsArray || (run(depsMap.get(ITERATE_KEY)), isMap(target) && run(depsMap.get(MAP_KEY_ITERATE_KEY)));
          break;
        case "set":
          isMap(target) && run(depsMap.get(ITERATE_KEY));
          break;
      }
  }
  endBatch();
}
__name(trigger, "trigger");
function reactiveReadArray(array) {
  const raw = toRaw(array);
  return raw === array ? raw : (track(raw, "iterate", ARRAY_ITERATE_KEY), isShallow(array) ? raw : raw.map(toReactive));
}
__name(reactiveReadArray, "reactiveReadArray");
function shallowReadArray(arr) {
  return track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY), arr;
}
__name(shallowReadArray, "shallowReadArray");
const arrayInstrumentations = {
  __proto__: null,
  [Symbol.iterator]() {
    return iterator(this, Symbol.iterator, toReactive);
  },
  concat(...args) {
    return reactiveReadArray(this).concat(
      ...args.map((x) => isArray$1(x) ? reactiveReadArray(x) : x)
    );
  },
  entries() {
    return iterator(this, "entries", (value) => (value[1] = toReactive(value[1]), value));
  },
  every(fn, thisArg) {
    return apply$1(this, "every", fn, thisArg, void 0, arguments);
  },
  filter(fn, thisArg) {
    return apply$1(this, "filter", fn, thisArg, (v) => v.map(toReactive), arguments);
  },
  find(fn, thisArg) {
    return apply$1(this, "find", fn, thisArg, toReactive, arguments);
  },
  findIndex(fn, thisArg) {
    return apply$1(this, "findIndex", fn, thisArg, void 0, arguments);
  },
  findLast(fn, thisArg) {
    return apply$1(this, "findLast", fn, thisArg, toReactive, arguments);
  },
  findLastIndex(fn, thisArg) {
    return apply$1(this, "findLastIndex", fn, thisArg, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(fn, thisArg) {
    return apply$1(this, "forEach", fn, thisArg, void 0, arguments);
  },
  includes(...args) {
    return searchProxy(this, "includes", args);
  },
  indexOf(...args) {
    return searchProxy(this, "indexOf", args);
  },
  join(separator) {
    return reactiveReadArray(this).join(separator);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...args) {
    return searchProxy(this, "lastIndexOf", args);
  },
  map(fn, thisArg) {
    return apply$1(this, "map", fn, thisArg, void 0, arguments);
  },
  pop() {
    return noTracking(this, "pop");
  },
  push(...args) {
    return noTracking(this, "push", args);
  },
  reduce(fn, ...args) {
    return reduce(this, "reduce", fn, args);
  },
  reduceRight(fn, ...args) {
    return reduce(this, "reduceRight", fn, args);
  },
  shift() {
    return noTracking(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(fn, thisArg) {
    return apply$1(this, "some", fn, thisArg, void 0, arguments);
  },
  splice(...args) {
    return noTracking(this, "splice", args);
  },
  toReversed() {
    return reactiveReadArray(this).toReversed();
  },
  toSorted(comparer) {
    return reactiveReadArray(this).toSorted(comparer);
  },
  toSpliced(...args) {
    return reactiveReadArray(this).toSpliced(...args);
  },
  unshift(...args) {
    return noTracking(this, "unshift", args);
  },
  values() {
    return iterator(this, "values", toReactive);
  }
};
function iterator(self2, method, wrapValue) {
  const arr = shallowReadArray(self2), iter = arr[method]();
  return arr !== self2 && !isShallow(self2) && (iter._next = iter.next, iter.next = () => {
    const result = iter._next();
    return result.value && (result.value = wrapValue(result.value)), result;
  }), iter;
}
__name(iterator, "iterator");
const arrayProto = Array.prototype;
function apply$1(self2, method, fn, thisArg, wrappedRetFn, args) {
  const arr = shallowReadArray(self2), needsWrap = arr !== self2 && !isShallow(self2), methodFn = arr[method];
  if (methodFn !== arrayProto[method]) {
    const result2 = methodFn.apply(self2, args);
    return needsWrap ? toReactive(result2) : result2;
  }
  let wrappedFn = fn;
  arr !== self2 && (needsWrap ? wrappedFn = /* @__PURE__ */ __name(function(item, index) {
    return fn.call(this, toReactive(item), index, self2);
  }, "wrappedFn") : fn.length > 2 && (wrappedFn = /* @__PURE__ */ __name(function(item, index) {
    return fn.call(this, item, index, self2);
  }, "wrappedFn")));
  const result = methodFn.call(arr, wrappedFn, thisArg);
  return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
__name(apply$1, "apply$1");
function reduce(self2, method, fn, args) {
  const arr = shallowReadArray(self2);
  let wrappedFn = fn;
  return arr !== self2 && (isShallow(self2) ? fn.length > 3 && (wrappedFn = /* @__PURE__ */ __name(function(acc, item, index) {
    return fn.call(this, acc, item, index, self2);
  }, "wrappedFn")) : wrappedFn = /* @__PURE__ */ __name(function(acc, item, index) {
    return fn.call(this, acc, toReactive(item), index, self2);
  }, "wrappedFn")), arr[method](wrappedFn, ...args);
}
__name(reduce, "reduce");
function searchProxy(self2, method, args) {
  const arr = toRaw(self2);
  track(arr, "iterate", ARRAY_ITERATE_KEY);
  const res = arr[method](...args);
  return (res === -1 || res === !1) && isProxy(args[0]) ? (args[0] = toRaw(args[0]), arr[method](...args)) : res;
}
__name(searchProxy, "searchProxy");
function noTracking(self2, method, args = []) {
  pauseTracking(), startBatch();
  const res = toRaw(self2)[method].apply(self2, args);
  return endBatch(), resetTracking(), res;
}
__name(noTracking, "noTracking");
const isNonTrackableKeys = /* @__PURE__ */ makeMap("__proto__,__v_isRef,__isVue"), builtInSymbols = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
);
function hasOwnProperty$1(key) {
  isSymbol(key) || (key = String(key));
  const obj = toRaw(this);
  return track(obj, "has", key), obj.hasOwnProperty(key);
}
__name(hasOwnProperty$1, "hasOwnProperty$1");
const _BaseReactiveHandler = class _BaseReactiveHandler {
  constructor(_isReadonly = !1, _isShallow = !1) {
    this._isReadonly = _isReadonly, this._isShallow = _isShallow;
  }
  get(target, key, receiver) {
    if (key === "__v_skip") return target.__v_skip;
    const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
    if (key === "__v_isReactive")
      return !isReadonly2;
    if (key === "__v_isReadonly")
      return isReadonly2;
    if (key === "__v_isShallow")
      return isShallow2;
    if (key === "__v_raw")
      return receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver) ? target : void 0;
    const targetIsArray = isArray$1(target);
    if (!isReadonly2) {
      let fn;
      if (targetIsArray && (fn = arrayInstrumentations[key]))
        return fn;
      if (key === "hasOwnProperty")
        return hasOwnProperty$1;
    }
    const res = Reflect.get(
      target,
      key,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      isRef(target) ? target : receiver
    );
    return (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) || (isReadonly2 || track(target, "get", key), isShallow2) ? res : isRef(res) ? targetIsArray && isIntegerKey(key) ? res : res.value : isObject$1(res) ? isReadonly2 ? readonly(res) : reactive(res) : res;
  }
};
__name(_BaseReactiveHandler, "BaseReactiveHandler");
let BaseReactiveHandler = _BaseReactiveHandler;
const _MutableReactiveHandler = class _MutableReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = !1) {
    super(!1, isShallow2);
  }
  set(target, key, value, receiver) {
    let oldValue = target[key];
    if (!this._isShallow) {
      const isOldValueReadonly = isReadonly(oldValue);
      if (!isShallow(value) && !isReadonly(value) && (oldValue = toRaw(oldValue), value = toRaw(value)), !isArray$1(target) && isRef(oldValue) && !isRef(value))
        return isOldValueReadonly ? !1 : (oldValue.value = value, !0);
    }
    const hadKey = isArray$1(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn$1(target, key), result = Reflect.set(
      target,
      key,
      value,
      isRef(target) ? target : receiver
    );
    return target === toRaw(receiver) && (hadKey ? hasChanged(value, oldValue) && trigger(target, "set", key, value, oldValue) : trigger(target, "add", key, value)), result;
  }
  deleteProperty(target, key) {
    const hadKey = hasOwn$1(target, key), oldValue = target[key], result = Reflect.deleteProperty(target, key);
    return result && hadKey && trigger(target, "delete", key, void 0, oldValue), result;
  }
  has(target, key) {
    const result = Reflect.has(target, key);
    return (!isSymbol(key) || !builtInSymbols.has(key)) && track(target, "has", key), result;
  }
  ownKeys(target) {
    return track(
      target,
      "iterate",
      isArray$1(target) ? "length" : ITERATE_KEY
    ), Reflect.ownKeys(target);
  }
};
__name(_MutableReactiveHandler, "MutableReactiveHandler");
let MutableReactiveHandler = _MutableReactiveHandler;
const _ReadonlyReactiveHandler = class _ReadonlyReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = !1) {
    super(!0, isShallow2);
  }
  set(target, key) {
    return process.env.NODE_ENV !== "production" && warn$2(
      `Set operation on key "${String(key)}" failed: target is readonly.`,
      target
    ), !0;
  }
  deleteProperty(target, key) {
    return process.env.NODE_ENV !== "production" && warn$2(
      `Delete operation on key "${String(key)}" failed: target is readonly.`,
      target
    ), !0;
  }
};
__name(_ReadonlyReactiveHandler, "ReadonlyReactiveHandler");
let ReadonlyReactiveHandler = _ReadonlyReactiveHandler;
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler(), readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(), toShallow = /* @__PURE__ */ __name((value) => value, "toShallow"), getProto = /* @__PURE__ */ __name((v) => Reflect.getPrototypeOf(v), "getProto");
function createIterableMethod(method, isReadonly2, isShallow2) {
  return function(...args) {
    const target = this.__v_raw, rawTarget = toRaw(target), targetIsMap = isMap(rawTarget), isPair = method === "entries" || method === Symbol.iterator && targetIsMap, isKeyOnly = method === "keys" && targetIsMap, innerIterator = target[method](...args), wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    return !isReadonly2 && track(
      rawTarget,
      "iterate",
      isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
    ), {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
__name(createIterableMethod, "createIterableMethod");
function createReadonlyMethod(type) {
  return function(...args) {
    if (process.env.NODE_ENV !== "production") {
      const key = args[0] ? `on key "${args[0]}" ` : "";
      warn$2(
        `${capitalize$1(type)} operation ${key}failed: target is readonly.`,
        toRaw(this)
      );
    }
    return type === "delete" ? !1 : type === "clear" ? void 0 : this;
  };
}
__name(createReadonlyMethod, "createReadonlyMethod");
function createInstrumentations(readonly2, shallow) {
  const instrumentations = {
    get(key) {
      const target = this.__v_raw, rawTarget = toRaw(target), rawKey = toRaw(key);
      readonly2 || (hasChanged(key, rawKey) && track(rawTarget, "get", key), track(rawTarget, "get", rawKey));
      const { has } = getProto(rawTarget), wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      if (has.call(rawTarget, key))
        return wrap(target.get(key));
      if (has.call(rawTarget, rawKey))
        return wrap(target.get(rawKey));
      target !== rawTarget && target.get(key);
    },
    get size() {
      const target = this.__v_raw;
      return !readonly2 && track(toRaw(target), "iterate", ITERATE_KEY), Reflect.get(target, "size", target);
    },
    has(key) {
      const target = this.__v_raw, rawTarget = toRaw(target), rawKey = toRaw(key);
      return readonly2 || (hasChanged(key, rawKey) && track(rawTarget, "has", key), track(rawTarget, "has", rawKey)), key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
    },
    forEach(callback, thisArg) {
      const observed = this, target = observed.__v_raw, rawTarget = toRaw(target), wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      return !readonly2 && track(rawTarget, "iterate", ITERATE_KEY), target.forEach((value, key) => callback.call(thisArg, wrap(value), wrap(key), observed));
    }
  };
  return extend(
    instrumentations,
    readonly2 ? {
      add: createReadonlyMethod("add"),
      set: createReadonlyMethod("set"),
      delete: createReadonlyMethod("delete"),
      clear: createReadonlyMethod("clear")
    } : {
      add(value) {
        !shallow && !isShallow(value) && !isReadonly(value) && (value = toRaw(value));
        const target = toRaw(this);
        return getProto(target).has.call(target, value) || (target.add(value), trigger(target, "add", value, value)), this;
      },
      set(key, value) {
        !shallow && !isShallow(value) && !isReadonly(value) && (value = toRaw(value));
        const target = toRaw(this), { has, get: get2 } = getProto(target);
        let hadKey = has.call(target, key);
        hadKey ? process.env.NODE_ENV !== "production" && checkIdentityKeys(target, has, key) : (key = toRaw(key), hadKey = has.call(target, key));
        const oldValue = get2.call(target, key);
        return target.set(key, value), hadKey ? hasChanged(value, oldValue) && trigger(target, "set", key, value, oldValue) : trigger(target, "add", key, value), this;
      },
      delete(key) {
        const target = toRaw(this), { has, get: get2 } = getProto(target);
        let hadKey = has.call(target, key);
        hadKey ? process.env.NODE_ENV !== "production" && checkIdentityKeys(target, has, key) : (key = toRaw(key), hadKey = has.call(target, key));
        const oldValue = get2 ? get2.call(target, key) : void 0, result = target.delete(key);
        return hadKey && trigger(target, "delete", key, void 0, oldValue), result;
      },
      clear() {
        const target = toRaw(this), hadItems = target.size !== 0, oldTarget = process.env.NODE_ENV !== "production" ? isMap(target) ? new Map(target) : new Set(target) : void 0, result = target.clear();
        return hadItems && trigger(
          target,
          "clear",
          void 0,
          void 0,
          oldTarget
        ), result;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((method) => {
    instrumentations[method] = createIterableMethod(method, readonly2, shallow);
  }), instrumentations;
}
__name(createInstrumentations, "createInstrumentations");
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = createInstrumentations(isReadonly2, shallow);
  return (target, key, receiver) => key === "__v_isReactive" ? !isReadonly2 : key === "__v_isReadonly" ? isReadonly2 : key === "__v_raw" ? target : Reflect.get(
    hasOwn$1(instrumentations, key) && key in target ? instrumentations : target,
    key,
    receiver
  );
}
__name(createInstrumentationGetter, "createInstrumentationGetter");
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(!1, !1)
}, readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(!0, !1)
};
function checkIdentityKeys(target, has, key) {
  const rawKey = toRaw(key);
  if (rawKey !== key && has.call(target, rawKey)) {
    const type = toRawType(target);
    warn$2(
      `Reactive ${type} contains both the raw and reactive versions of the same object${type === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
__name(checkIdentityKeys, "checkIdentityKeys");
const reactiveMap = /* @__PURE__ */ new WeakMap(), shallowReactiveMap = /* @__PURE__ */ new WeakMap(), readonlyMap = /* @__PURE__ */ new WeakMap(), shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
__name(targetTypeMap, "targetTypeMap");
function getTargetType(value) {
  return value.__v_skip || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
__name(getTargetType, "getTargetType");
function reactive(target) {
  return isReadonly(target) ? target : createReactiveObject(
    target,
    !1,
    mutableHandlers,
    mutableCollectionHandlers,
    reactiveMap
  );
}
__name(reactive, "reactive");
function readonly(target) {
  return createReactiveObject(
    target,
    !0,
    readonlyHandlers,
    readonlyCollectionHandlers,
    readonlyMap
  );
}
__name(readonly, "readonly");
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject$1(target))
    return process.env.NODE_ENV !== "production" && warn$2(
      `value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(
        target
      )}`
    ), target;
  if (target.__v_raw && !(isReadonly2 && target.__v_isReactive))
    return target;
  const existingProxy = proxyMap.get(target);
  if (existingProxy)
    return existingProxy;
  const targetType = getTargetType(target);
  if (targetType === 0)
    return target;
  const proxy = new Proxy(
    target,
    targetType === 2 ? collectionHandlers : baseHandlers
  );
  return proxyMap.set(target, proxy), proxy;
}
__name(createReactiveObject, "createReactiveObject");
function isReactive(value) {
  return isReadonly(value) ? isReactive(value.__v_raw) : !!(value && value.__v_isReactive);
}
__name(isReactive, "isReactive");
function isReadonly(value) {
  return !!(value && value.__v_isReadonly);
}
__name(isReadonly, "isReadonly");
function isShallow(value) {
  return !!(value && value.__v_isShallow);
}
__name(isShallow, "isShallow");
function isProxy(value) {
  return value ? !!value.__v_raw : !1;
}
__name(isProxy, "isProxy");
function toRaw(observed) {
  const raw = observed && observed.__v_raw;
  return raw ? toRaw(raw) : observed;
}
__name(toRaw, "toRaw");
const toReactive = /* @__PURE__ */ __name((value) => isObject$1(value) ? reactive(value) : value, "toReactive"), toReadonly = /* @__PURE__ */ __name((value) => isObject$1(value) ? readonly(value) : value, "toReadonly");
function isRef(r) {
  return r ? r.__v_isRef === !0 : !1;
}
__name(isRef, "isRef");
function ref(value) {
  return createRef(value, !1);
}
__name(ref, "ref");
function shallowRef(value) {
  return createRef(value, !0);
}
__name(shallowRef, "shallowRef");
function createRef(rawValue, shallow) {
  return isRef(rawValue) ? rawValue : new RefImpl(rawValue, shallow);
}
__name(createRef, "createRef");
const _RefImpl = class _RefImpl {
  constructor(value, isShallow2) {
    this.dep = new Dep(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = isShallow2 ? value : toRaw(value), this._value = isShallow2 ? value : toReactive(value), this.__v_isShallow = isShallow2;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(newValue) {
    const oldValue = this._rawValue, useDirectValue = this.__v_isShallow || isShallow(newValue) || isReadonly(newValue);
    newValue = useDirectValue ? newValue : toRaw(newValue), hasChanged(newValue, oldValue) && (this._rawValue = newValue, this._value = useDirectValue ? newValue : toReactive(newValue), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue,
      oldValue
    }) : this.dep.trigger());
  }
};
__name(_RefImpl, "RefImpl");
let RefImpl = _RefImpl;
const _ComputedRefImpl = class _ComputedRefImpl {
  constructor(fn, setter, isSSR) {
    this.fn = fn, this.setter = setter, this._value = void 0, this.dep = new Dep(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = globalVersion - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !setter, this.isSSR = isSSR;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    activeSub !== this)
      return batch(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const link = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return refreshComputed(this), link && (link.version = this.dep.version), this._value;
  }
  set value(newValue) {
    this.setter ? this.setter(newValue) : process.env.NODE_ENV !== "production" && warn$2("Write operation failed: computed value is readonly");
  }
};
__name(_ComputedRefImpl, "ComputedRefImpl");
let ComputedRefImpl = _ComputedRefImpl;
function computed$1(getterOrOptions, debugOptions, isSSR = !1) {
  let getter, setter;
  isFunction$1(getterOrOptions) ? getter = getterOrOptions : (getter = getterOrOptions.get, setter = getterOrOptions.set);
  const cRef = new ComputedRefImpl(getter, setter, isSSR);
  return process.env.NODE_ENV, cRef;
}
__name(computed$1, "computed$1");
const INITIAL_WATCHER_VALUE = {}, cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher;
function onWatcherCleanup(cleanupFn, failSilently = !1, owner = activeWatcher) {
  if (owner) {
    let cleanups = cleanupMap.get(owner);
    cleanups || cleanupMap.set(owner, cleanups = []), cleanups.push(cleanupFn);
  } else process.env.NODE_ENV !== "production" && !failSilently && warn$2(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
__name(onWatcherCleanup, "onWatcherCleanup");
function watch$1(source, cb, options = EMPTY_OBJ) {
  const { immediate, deep, once, scheduler, augmentJob, call } = options, warnInvalidSource = /* @__PURE__ */ __name((s) => {
    (options.onWarn || warn$2)(
      "Invalid watch source: ",
      s,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, "warnInvalidSource"), reactiveGetter = /* @__PURE__ */ __name((source2) => deep ? source2 : isShallow(source2) || deep === !1 || deep === 0 ? traverse(source2, 1) : traverse(source2), "reactiveGetter");
  let effect, getter, cleanup, boundCleanup, forceTrigger = !1, isMultiSource = !1;
  if (isRef(source) ? (getter = /* @__PURE__ */ __name(() => source.value, "getter"), forceTrigger = isShallow(source)) : isReactive(source) ? (getter = /* @__PURE__ */ __name(() => reactiveGetter(source), "getter"), forceTrigger = !0) : isArray$1(source) ? (isMultiSource = !0, forceTrigger = source.some((s) => isReactive(s) || isShallow(s)), getter = /* @__PURE__ */ __name(() => source.map((s) => {
    if (isRef(s))
      return s.value;
    if (isReactive(s))
      return reactiveGetter(s);
    if (isFunction$1(s))
      return call ? call(s, 2) : s();
    process.env.NODE_ENV !== "production" && warnInvalidSource(s);
  }), "getter")) : isFunction$1(source) ? cb ? getter = call ? () => call(source, 2) : source : getter = /* @__PURE__ */ __name(() => {
    if (cleanup) {
      pauseTracking();
      try {
        cleanup();
      } finally {
        resetTracking();
      }
    }
    const currentEffect = activeWatcher;
    activeWatcher = effect;
    try {
      return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
    } finally {
      activeWatcher = currentEffect;
    }
  }, "getter") : (getter = NOOP, process.env.NODE_ENV !== "production" && warnInvalidSource(source)), cb && deep) {
    const baseGetter = getter, depth = deep === !0 ? 1 / 0 : deep;
    getter = /* @__PURE__ */ __name(() => traverse(baseGetter(), depth), "getter");
  }
  const scope = getCurrentScope(), watchHandle = /* @__PURE__ */ __name(() => {
    effect.stop(), scope && scope.active && remove(scope.effects, effect);
  }, "watchHandle");
  if (once && cb) {
    const _cb = cb;
    cb = /* @__PURE__ */ __name((...args) => {
      _cb(...args), watchHandle();
    }, "cb");
  }
  let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
  const job = /* @__PURE__ */ __name((immediateFirstRun) => {
    if (!(!(effect.flags & 1) || !effect.dirty && !immediateFirstRun))
      if (cb) {
        const newValue = effect.run();
        if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
          cleanup && cleanup();
          const currentWatcher = activeWatcher;
          activeWatcher = effect;
          try {
            const args = [
              newValue,
              // pass undefined as the old value when it's changed for the first time
              oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
              boundCleanup
            ];
            call ? call(cb, 3, args) : (
              // @ts-expect-error
              cb(...args)
            ), oldValue = newValue;
          } finally {
            activeWatcher = currentWatcher;
          }
        }
      } else
        effect.run();
  }, "job");
  return augmentJob && augmentJob(job), effect = new ReactiveEffect(getter), effect.scheduler = scheduler ? () => scheduler(job, !1) : job, boundCleanup = /* @__PURE__ */ __name((fn) => onWatcherCleanup(fn, !1, effect), "boundCleanup"), cleanup = effect.onStop = () => {
    const cleanups = cleanupMap.get(effect);
    if (cleanups) {
      if (call)
        call(cleanups, 4);
      else
        for (const cleanup2 of cleanups) cleanup2();
      cleanupMap.delete(effect);
    }
  }, process.env.NODE_ENV !== "production" && (effect.onTrack = options.onTrack, effect.onTrigger = options.onTrigger), cb ? immediate ? job(!0) : oldValue = effect.run() : scheduler ? scheduler(job.bind(null, !0), !0) : effect.run(), watchHandle.pause = effect.pause.bind(effect), watchHandle.resume = effect.resume.bind(effect), watchHandle.stop = watchHandle, watchHandle;
}
__name(watch$1, "watch$1");
function traverse(value, depth = 1 / 0, seen) {
  if (depth <= 0 || !isObject$1(value) || value.__v_skip || (seen = seen || /* @__PURE__ */ new Set(), seen.has(value)))
    return value;
  if (seen.add(value), depth--, isRef(value))
    traverse(value.value, depth, seen);
  else if (isArray$1(value))
    for (let i = 0; i < value.length; i++)
      traverse(value[i], depth, seen);
  else if (isSet(value) || isMap(value))
    value.forEach((v) => {
      traverse(v, depth, seen);
    });
  else if (isPlainObject$1(value)) {
    for (const key in value)
      traverse(value[key], depth, seen);
    for (const key of Object.getOwnPropertySymbols(value))
      Object.prototype.propertyIsEnumerable.call(value, key) && traverse(value[key], depth, seen);
  }
  return value;
}
__name(traverse, "traverse");
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const stack = [];
function pushWarningContext(vnode) {
  stack.push(vnode);
}
__name(pushWarningContext, "pushWarningContext");
function popWarningContext() {
  stack.pop();
}
__name(popWarningContext, "popWarningContext");
let isWarning = !1;
function warn$1(msg, ...args) {
  if (isWarning) return;
  isWarning = !0, pauseTracking();
  const instance = stack.length ? stack[stack.length - 1].component : null, appWarnHandler = instance && instance.appContext.config.warnHandler, trace = getComponentTrace();
  if (appWarnHandler)
    callWithErrorHandling(
      appWarnHandler,
      instance,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a) => {
          var _a, _b;
          return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(
          ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
        ).join(`
`),
        trace
      ]
    );
  else {
    const warnArgs = [`[Vue warn]: ${msg}`, ...args];
    trace.length && warnArgs.push(`
`, ...formatTrace(trace)), console.warn(...warnArgs);
  }
  resetTracking(), isWarning = !1;
}
__name(warn$1, "warn$1");
function getComponentTrace() {
  let currentVNode = stack[stack.length - 1];
  if (!currentVNode)
    return [];
  const normalizedStack = [];
  for (; currentVNode; ) {
    const last = normalizedStack[0];
    last && last.vnode === currentVNode ? last.recurseCount++ : normalizedStack.push({
      vnode: currentVNode,
      recurseCount: 0
    });
    const parentInstance = currentVNode.component && currentVNode.component.parent;
    currentVNode = parentInstance && parentInstance.vnode;
  }
  return normalizedStack;
}
__name(getComponentTrace, "getComponentTrace");
function formatTrace(trace) {
  const logs = [];
  return trace.forEach((entry, i) => {
    logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
  }), logs;
}
__name(formatTrace, "formatTrace");
function formatTraceEntry({ vnode, recurseCount }) {
  const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : "", isRoot = vnode.component ? vnode.component.parent == null : !1, open = ` at <${formatComponentName(
    vnode.component,
    vnode.type,
    isRoot
  )}`, close = ">" + postfix;
  return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
}
__name(formatTraceEntry, "formatTraceEntry");
function formatProps(props) {
  const res = [], keys = Object.keys(props);
  return keys.slice(0, 3).forEach((key) => {
    res.push(...formatProp(key, props[key]));
  }), keys.length > 3 && res.push(" ..."), res;
}
__name(formatProps, "formatProps");
function formatProp(key, value, raw) {
  return isString$1(value) ? (value = JSON.stringify(value), raw ? value : [`${key}=${value}`]) : typeof value == "number" || typeof value == "boolean" || value == null ? raw ? value : [`${key}=${value}`] : isRef(value) ? (value = formatProp(key, toRaw(value.value), !0), raw ? value : [`${key}=Ref<`, value, ">"]) : isFunction$1(value) ? [`${key}=fn${value.name ? `<${value.name}>` : ""}`] : (value = toRaw(value), raw ? value : [`${key}=`, value]);
}
__name(formatProp, "formatProp");
const ErrorTypeStrings$1 = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function callWithErrorHandling(fn, instance, type, args) {
  try {
    return args ? fn(...args) : fn();
  } catch (err) {
    handleError(err, instance, type);
  }
}
__name(callWithErrorHandling, "callWithErrorHandling");
function callWithAsyncErrorHandling(fn, instance, type, args) {
  if (isFunction$1(fn)) {
    const res = callWithErrorHandling(fn, instance, type, args);
    return res && isPromise$1(res) && res.catch((err) => {
      handleError(err, instance, type);
    }), res;
  }
  if (isArray$1(fn)) {
    const values = [];
    for (let i = 0; i < fn.length; i++)
      values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
    return values;
  } else process.env.NODE_ENV !== "production" && warn$1(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof fn}`
  );
}
__name(callWithAsyncErrorHandling, "callWithAsyncErrorHandling");
function handleError(err, instance, type, throwInDev = !0) {
  const contextVNode = instance ? instance.vnode : null, { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
  if (instance) {
    let cur = instance.parent;
    const exposedInstance = instance.proxy, errorInfo = process.env.NODE_ENV !== "production" ? ErrorTypeStrings$1[type] : `https://vuejs.org/error-reference/#runtime-${type}`;
    for (; cur; ) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i = 0; i < errorCapturedHooks.length; i++)
          if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === !1)
            return;
      }
      cur = cur.parent;
    }
    if (errorHandler) {
      pauseTracking(), callWithErrorHandling(errorHandler, null, 10, [
        err,
        exposedInstance,
        errorInfo
      ]), resetTracking();
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
__name(handleError, "handleError");
function logError(err, type, contextVNode, throwInDev = !0, throwInProd = !1) {
  if (process.env.NODE_ENV !== "production") {
    const info = ErrorTypeStrings$1[type];
    if (contextVNode && pushWarningContext(contextVNode), warn$1(`Unhandled error${info ? ` during execution of ${info}` : ""}`), contextVNode && popWarningContext(), throwInDev)
      throw err;
    console.error(err);
  } else {
    if (throwInProd)
      throw err;
    console.error(err);
  }
}
__name(logError, "logError");
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null, postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function findInsertionIndex(id) {
  let start = flushIndex + 1, end = queue.length;
  for (; start < end; ) {
    const middle = start + end >>> 1, middleJob = queue[middle], middleJobId = getId(middleJob);
    middleJobId < id || middleJobId === id && middleJob.flags & 2 ? start = middle + 1 : end = middle;
  }
  return start;
}
__name(findInsertionIndex, "findInsertionIndex");
function queueJob(job) {
  if (!(job.flags & 1)) {
    const jobId = getId(job), lastJob = queue[queue.length - 1];
    !lastJob || // fast path when the job id is larger than the tail
    !(job.flags & 2) && jobId >= getId(lastJob) ? queue.push(job) : queue.splice(findInsertionIndex(jobId), 0, job), job.flags |= 1, queueFlush();
  }
}
__name(queueJob, "queueJob");
function queueFlush() {
  currentFlushPromise || (currentFlushPromise = resolvedPromise.then(flushJobs));
}
__name(queueFlush, "queueFlush");
function queuePostFlushCb(cb) {
  isArray$1(cb) ? pendingPostFlushCbs.push(...cb) : activePostFlushCbs && cb.id === -1 ? activePostFlushCbs.splice(postFlushIndex + 1, 0, cb) : cb.flags & 1 || (pendingPostFlushCbs.push(cb), cb.flags |= 1), queueFlush();
}
__name(queuePostFlushCb, "queuePostFlushCb");
function flushPostFlushCbs(seen) {
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)].sort(
      (a, b) => getId(a) - getId(b)
    );
    if (pendingPostFlushCbs.length = 0, activePostFlushCbs) {
      activePostFlushCbs.push(...deduped);
      return;
    }
    for (activePostFlushCbs = deduped, process.env.NODE_ENV !== "production" && (seen = seen || /* @__PURE__ */ new Map()), postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      const cb = activePostFlushCbs[postFlushIndex];
      process.env.NODE_ENV !== "production" && checkRecursiveUpdates(seen, cb) || (cb.flags & 4 && (cb.flags &= -2), cb.flags & 8 || cb(), cb.flags &= -2);
    }
    activePostFlushCbs = null, postFlushIndex = 0;
  }
}
__name(flushPostFlushCbs, "flushPostFlushCbs");
const getId = /* @__PURE__ */ __name((job) => job.id == null ? job.flags & 2 ? -1 : 1 / 0 : job.id, "getId");
function flushJobs(seen) {
  process.env.NODE_ENV !== "production" && (seen = seen || /* @__PURE__ */ new Map());
  const check = process.env.NODE_ENV !== "production" ? (job) => checkRecursiveUpdates(seen, job) : NOOP;
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && !(job.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && check(job))
          continue;
        job.flags & 4 && (job.flags &= -2), callWithErrorHandling(
          job,
          job.i,
          job.i ? 15 : 14
        ), job.flags & 4 || (job.flags &= -2);
      }
    }
  } finally {
    for (; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      job && (job.flags &= -2);
    }
    flushIndex = -1, queue.length = 0, flushPostFlushCbs(seen), currentFlushPromise = null, (queue.length || pendingPostFlushCbs.length) && flushJobs(seen);
  }
}
__name(flushJobs, "flushJobs");
function checkRecursiveUpdates(seen, fn) {
  const count = seen.get(fn) || 0;
  if (count > RECURSION_LIMIT) {
    const instance = fn.i, componentName = instance && getComponentName(instance.type);
    return handleError(
      `Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return seen.set(fn, count + 1), !1;
}
__name(checkRecursiveUpdates, "checkRecursiveUpdates");
const hmrDirtyComponents = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (getGlobalThis$1().__VUE_HMR_RUNTIME__ = {
  createRecord: tryWrap(createRecord),
  rerender: tryWrap(rerender),
  reload: tryWrap(reload)
});
const map = /* @__PURE__ */ new Map();
function createRecord(id, initialDef) {
  return map.has(id) ? !1 : (map.set(id, {
    initialDef: normalizeClassComponent(initialDef),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
__name(createRecord, "createRecord");
function normalizeClassComponent(component) {
  return isClassComponent(component) ? component.__vccOpts : component;
}
__name(normalizeClassComponent, "normalizeClassComponent");
function rerender(id, newRender) {
  const record = map.get(id);
  record && (record.initialDef.render = newRender, [...record.instances].forEach((instance) => {
    newRender && (instance.render = newRender, normalizeClassComponent(instance.type).render = newRender), instance.renderCache = [], instance.update();
  }));
}
__name(rerender, "rerender");
function reload(id, newComp) {
  const record = map.get(id);
  if (!record) return;
  newComp = normalizeClassComponent(newComp), updateComponentDef(record.initialDef, newComp);
  const instances = [...record.instances];
  for (let i = 0; i < instances.length; i++) {
    const instance = instances[i], oldComp = normalizeClassComponent(instance.type);
    let dirtyInstances = hmrDirtyComponents.get(oldComp);
    dirtyInstances || (oldComp !== record.initialDef && updateComponentDef(oldComp, newComp), hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set())), dirtyInstances.add(instance), instance.appContext.propsCache.delete(instance.type), instance.appContext.emitsCache.delete(instance.type), instance.appContext.optionsCache.delete(instance.type), instance.ceReload ? (dirtyInstances.add(instance), instance.ceReload(newComp.styles), dirtyInstances.delete(instance)) : instance.parent ? queueJob(() => {
      instance.parent.update(), dirtyInstances.delete(instance);
    }) : instance.appContext.reload ? instance.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), instance.root.ce && instance !== instance.root && instance.root.ce._removeChildStyle(oldComp);
  }
  queuePostFlushCb(() => {
    hmrDirtyComponents.clear();
  });
}
__name(reload, "reload");
function updateComponentDef(oldComp, newComp) {
  extend(oldComp, newComp);
  for (const key in oldComp)
    key !== "__file" && !(key in newComp) && delete oldComp[key];
}
__name(updateComponentDef, "updateComponentDef");
function tryWrap(fn) {
  return (id, arg) => {
    try {
      return fn(id, arg);
    } catch (e) {
      console.error(e), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
__name(tryWrap, "tryWrap");
let devtools$1, buffer = [];
function setDevtoolsHook$1(hook, target) {
  var _a, _b;
  devtools$1 = hook, devtools$1 ? (devtools$1.enabled = !0, buffer.forEach(({ event, args }) => devtools$1.emit(event, ...args)), buffer = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) != null && _b.includes("jsdom")) ? ((target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((newHook) => {
    setDevtoolsHook$1(newHook, target);
  }), setTimeout(() => {
    devtools$1 || (target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, buffer = []);
  }, 3e3)) : buffer = [];
}
__name(setDevtoolsHook$1, "setDevtoolsHook$1");
let currentRenderingInstance = null, currentScopeId = null;
const isTeleport = /* @__PURE__ */ __name((type) => type.__isTeleport, "isTeleport");
function setTransitionHooks(vnode, hooks) {
  vnode.shapeFlag & 6 && vnode.component ? (vnode.transition = hooks, setTransitionHooks(vnode.component.subTree, hooks)) : vnode.shapeFlag & 128 ? (vnode.ssContent.transition = hooks.clone(vnode.ssContent), vnode.ssFallback.transition = hooks.clone(vnode.ssFallback)) : vnode.transition = hooks;
}
__name(setTransitionHooks, "setTransitionHooks");
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
  return isFunction$1(options) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    extend({ name: options.name }, extraOptions, { setup: options })
  ) : options;
}
__name(defineComponent, "defineComponent");
getGlobalThis$1().requestIdleCallback;
getGlobalThis$1().cancelIdleCallback;
function injectHook(type, hook, target = currentInstance, prepend = !1) {
  if (target) {
    const hooks = target[type] || (target[type] = []), wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      pauseTracking();
      const reset = setCurrentInstance(target), res = callWithAsyncErrorHandling(hook, target, type, args);
      return reset(), resetTracking(), res;
    });
    return prepend ? hooks.unshift(wrappedHook) : hooks.push(wrappedHook), wrappedHook;
  } else if (process.env.NODE_ENV !== "production") {
    const apiName = toHandlerKey(ErrorTypeStrings$1[type].replace(/ hook$/, ""));
    warn$1(
      `${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
__name(injectHook, "injectHook");
const createHook = /* @__PURE__ */ __name((lifecycle) => (hook, target = currentInstance) => {
  (!isInSSRComponentSetup || lifecycle === "sp") && injectHook(lifecycle, (...args) => hook(...args), target);
}, "createHook"), onMounted = createHook("m"), onUnmounted = createHook("um"), NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc"), PublicInstanceProxyHandlers = {};
process.env.NODE_ENV !== "production" && (PublicInstanceProxyHandlers.ownKeys = (target) => (warn$1(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(target)));
let currentApp = null;
function inject(key, defaultValue, treatDefaultAsFactory = !1) {
  const instance = currentInstance || currentRenderingInstance;
  if (instance || currentApp) {
    const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
    if (provides && key in provides)
      return provides[key];
    if (arguments.length > 1)
      return treatDefaultAsFactory && isFunction$1(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    process.env.NODE_ENV !== "production" && warn$1(`injection "${String(key)}" not found.`);
  } else process.env.NODE_ENV !== "production" && warn$1("inject() can only be used inside setup() or functional components.");
}
__name(inject, "inject");
const internalObjectProto = {}, isInternalObject = /* @__PURE__ */ __name((obj) => Object.getPrototypeOf(obj) === internalObjectProto, "isInternalObject"), queuePostRenderEffect = queueEffectWithSuspense, ssrContextKey = Symbol.for("v-scx"), useSSRContext = /* @__PURE__ */ __name(() => {
  {
    const ctx = inject(ssrContextKey);
    return ctx || process.env.NODE_ENV !== "production" && warn$1(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), ctx;
  }
}, "useSSRContext");
function watch(source, cb, options) {
  return process.env.NODE_ENV !== "production" && !isFunction$1(cb) && warn$1(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), doWatch(source, cb, options);
}
__name(watch, "watch");
function doWatch(source, cb, options = EMPTY_OBJ) {
  const { immediate, deep, flush, once } = options;
  process.env.NODE_ENV !== "production" && !cb && (immediate !== void 0 && warn$1(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), deep !== void 0 && warn$1(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), once !== void 0 && warn$1(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const baseWatchOptions = extend({}, options);
  process.env.NODE_ENV !== "production" && (baseWatchOptions.onWarn = warn$1);
  const runsImmediately = cb && immediate || !cb && flush !== "post";
  let ssrCleanup;
  if (isInSSRComponentSetup) {
    if (flush === "sync") {
      const ctx = useSSRContext();
      ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
    } else if (!runsImmediately) {
      const watchStopHandle = /* @__PURE__ */ __name(() => {
      }, "watchStopHandle");
      return watchStopHandle.stop = NOOP, watchStopHandle.resume = NOOP, watchStopHandle.pause = NOOP, watchStopHandle;
    }
  }
  const instance = currentInstance;
  baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
  let isPre = !1;
  flush === "post" ? baseWatchOptions.scheduler = (job) => {
    queuePostRenderEffect(job, instance && instance.suspense);
  } : flush !== "sync" && (isPre = !0, baseWatchOptions.scheduler = (job, isFirstRun) => {
    isFirstRun ? job() : queueJob(job);
  }), baseWatchOptions.augmentJob = (job) => {
    cb && (job.flags |= 4), isPre && (job.flags |= 2, instance && (job.id = instance.uid, job.i = instance));
  };
  const watchHandle = watch$1(source, cb, baseWatchOptions);
  return isInSSRComponentSetup && (ssrCleanup ? ssrCleanup.push(watchHandle) : runsImmediately && watchHandle()), watchHandle;
}
__name(doWatch, "doWatch");
const isSuspense = /* @__PURE__ */ __name((type) => type.__isSuspense, "isSuspense");
function queueEffectWithSuspense(fn, suspense) {
  suspense && suspense.pendingBranch ? isArray$1(fn) ? suspense.effects.push(...fn) : suspense.effects.push(fn) : queuePostFlushCb(fn);
}
__name(queueEffectWithSuspense, "queueEffectWithSuspense");
const Fragment = Symbol.for("v-fgt"), Text = Symbol.for("v-txt"), Comment = Symbol.for("v-cmt");
function isVNode$1(value) {
  return value ? value.__v_isVNode === !0 : !1;
}
__name(isVNode$1, "isVNode$1");
const createVNodeWithArgsTransform = /* @__PURE__ */ __name((...args) => _createVNode(
  ...args
), "createVNodeWithArgsTransform"), normalizeKey = /* @__PURE__ */ __name(({ key }) => key ?? null, "normalizeKey"), normalizeRef = /* @__PURE__ */ __name(({
  ref: ref3,
  ref_key,
  ref_for
}) => (typeof ref3 == "number" && (ref3 = "" + ref3), ref3 != null ? isString$1(ref3) || isRef(ref3) || isFunction$1(ref3) ? { i: currentRenderingInstance, r: ref3, k: ref_key, f: !!ref_for } : ref3 : null), "normalizeRef");
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = !1, needFullChildrenNormalization = !1) {
  const vnode = {
    __v_isVNode: !0,
    __v_skip: !0,
    type,
    props,
    key: props && normalizeKey(props),
    ref: props && normalizeRef(props),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null,
    ctx: currentRenderingInstance
  };
  return needFullChildrenNormalization ? (normalizeChildren(vnode, children), shapeFlag & 128 && type.normalize(vnode)) : children && (vnode.shapeFlag |= isString$1(children) ? 8 : 16), process.env.NODE_ENV !== "production" && vnode.key !== vnode.key && warn$1("VNode created with invalid key (NaN). VNode type:", vnode.type), vnode;
}
__name(createBaseVNode, "createBaseVNode");
const createVNode = process.env.NODE_ENV !== "production" ? createVNodeWithArgsTransform : _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = !1) {
  if ((!type || type === NULL_DYNAMIC_COMPONENT) && (process.env.NODE_ENV !== "production" && !type && warn$1(`Invalid vnode type when creating vnode: ${type}.`), type = Comment), isVNode$1(type)) {
    const cloned = cloneVNode(
      type,
      props,
      !0
      /* mergeRef: true */
    );
    return children && normalizeChildren(cloned, children), cloned.patchFlag = -2, cloned;
  }
  if (isClassComponent(type) && (type = type.__vccOpts), props) {
    props = guardReactiveProps(props);
    let { class: klass, style } = props;
    klass && !isString$1(klass) && (props.class = normalizeClass(klass)), isObject$1(style) && (isProxy(style) && !isArray$1(style) && (style = extend({}, style)), props.style = normalizeStyle(style));
  }
  const shapeFlag = isString$1(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$1(type) ? 4 : isFunction$1(type) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && shapeFlag & 4 && isProxy(type) && (type = toRaw(type), warn$1(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    type
  )), createBaseVNode(
    type,
    props,
    children,
    patchFlag,
    dynamicProps,
    shapeFlag,
    isBlockNode,
    !0
  );
}
__name(_createVNode, "_createVNode");
function guardReactiveProps(props) {
  return props ? isProxy(props) || isInternalObject(props) ? extend({}, props) : props : null;
}
__name(guardReactiveProps, "guardReactiveProps");
function cloneVNode(vnode, extraProps, mergeRef = !1, cloneTransition = !1) {
  const { props, ref: ref3, patchFlag, children, transition } = vnode, mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props, cloned = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      mergeRef && ref3 ? isArray$1(ref3) ? ref3.concat(normalizeRef(extraProps)) : [ref3, normalizeRef(extraProps)] : normalizeRef(extraProps)
    ) : ref3,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && patchFlag === -1 && isArray$1(children) ? children.map(deepCloneVNode) : children,
    target: vnode.target,
    targetStart: vnode.targetStart,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    el: vnode.el,
    anchor: vnode.anchor,
    ctx: vnode.ctx,
    ce: vnode.ce
  };
  return transition && cloneTransition && setTransitionHooks(
    cloned,
    transition.clone(cloned)
  ), cloned;
}
__name(cloneVNode, "cloneVNode");
function deepCloneVNode(vnode) {
  const cloned = cloneVNode(vnode);
  return isArray$1(vnode.children) && (cloned.children = vnode.children.map(deepCloneVNode)), cloned;
}
__name(deepCloneVNode, "deepCloneVNode");
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
__name(createTextVNode, "createTextVNode");
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null)
    children = null;
  else if (isArray$1(children))
    type = 16;
  else if (typeof children == "object")
    if (shapeFlag & 65) {
      const slot = children.default;
      slot && (slot._c && (slot._d = !1), normalizeChildren(vnode, slot()), slot._c && (slot._d = !0));
      return;
    } else
      type = 32, !children._ && !isInternalObject(children) && (children._ctx = currentRenderingInstance);
  else isFunction$1(children) ? (children = { default: children, _ctx: currentRenderingInstance }, type = 32) : (children = String(children), shapeFlag & 64 ? (type = 16, children = [createTextVNode(children)]) : type = 8);
  vnode.children = children, vnode.shapeFlag |= type;
}
__name(normalizeChildren, "normalizeChildren");
function mergeProps(...args) {
  const ret = {};
  for (let i = 0; i < args.length; i++) {
    const toMerge = args[i];
    for (const key in toMerge)
      if (key === "class")
        ret.class !== toMerge.class && (ret.class = normalizeClass([ret.class, toMerge.class]));
      else if (key === "style")
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      else if (isOn(key)) {
        const existing = ret[key], incoming = toMerge[key];
        incoming && existing !== incoming && !(isArray$1(existing) && existing.includes(incoming)) && (ret[key] = existing ? [].concat(existing, incoming) : incoming);
      } else key !== "" && (ret[key] = toMerge[key]);
  }
  return ret;
}
__name(mergeProps, "mergeProps");
let currentInstance = null;
const getCurrentInstance = /* @__PURE__ */ __name(() => currentInstance || currentRenderingInstance, "getCurrentInstance");
let internalSetCurrentInstance;
{
  const g = getGlobalThis$1(), registerGlobalSetter = /* @__PURE__ */ __name((key, setter) => {
    let setters;
    return (setters = g[key]) || (setters = g[key] = []), setters.push(setter), (v) => {
      setters.length > 1 ? setters.forEach((set) => set(v)) : setters[0](v);
    };
  }, "registerGlobalSetter");
  internalSetCurrentInstance = registerGlobalSetter(
    "__VUE_INSTANCE_SETTERS__",
    (v) => currentInstance = v
  ), registerGlobalSetter(
    "__VUE_SSR_SETTERS__",
    (v) => isInSSRComponentSetup = v
  );
}
const setCurrentInstance = /* @__PURE__ */ __name((instance) => {
  const prev = currentInstance;
  return internalSetCurrentInstance(instance), instance.scope.on(), () => {
    instance.scope.off(), internalSetCurrentInstance(prev);
  };
}, "setCurrentInstance");
let isInSSRComponentSetup = !1;
process.env.NODE_ENV;
const classifyRE = /(?:^|[-_])(\w)/g, classify = /* @__PURE__ */ __name((str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, ""), "classify");
function getComponentName(Component, includeInferred = !0) {
  return isFunction$1(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
__name(getComponentName, "getComponentName");
function formatComponentName(instance, Component, isRoot = !1) {
  let name = getComponentName(Component);
  if (!name && Component.__file) {
    const match = Component.__file.match(/([^/\\]+)\.\w+$/);
    match && (name = match[1]);
  }
  if (!name && instance && instance.parent) {
    const inferFromRegistry = /* @__PURE__ */ __name((registry) => {
      for (const key in registry)
        if (registry[key] === Component)
          return key;
    }, "inferFromRegistry");
    name = inferFromRegistry(
      instance.components || instance.parent.type.components
    ) || inferFromRegistry(instance.appContext.components);
  }
  return name ? classify(name) : isRoot ? "App" : "Anonymous";
}
__name(formatComponentName, "formatComponentName");
function isClassComponent(value) {
  return isFunction$1(value) && "__vccOpts" in value;
}
__name(isClassComponent, "isClassComponent");
const computed = /* @__PURE__ */ __name((getterOrOptions, debugOptions) => {
  const c = computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
  if (process.env.NODE_ENV !== "production") {
    const i = getCurrentInstance();
    i && i.appContext.config.warnRecursiveComputed && (c._warnRecursive = !0);
  }
  return c;
}, "computed");
function h(type, propsOrChildren, children) {
  const l = arguments.length;
  return l === 2 ? isObject$1(propsOrChildren) && !isArray$1(propsOrChildren) ? isVNode$1(propsOrChildren) ? createVNode(type, null, [propsOrChildren]) : createVNode(type, propsOrChildren) : createVNode(type, null, propsOrChildren) : (l > 3 ? children = Array.prototype.slice.call(arguments, 2) : l === 3 && isVNode$1(children) && (children = [children]), createVNode(type, propsOrChildren, children));
}
__name(h, "h");
function initCustomFormatter() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const vueStyle = { style: "color:#3ba776" }, numberStyle = { style: "color:#1677ff" }, stringStyle = { style: "color:#f5222d" }, keywordStyle = { style: "color:#eb2f96" }, formatter = {
    __vue_custom_formatter: !0,
    header(obj) {
      return isObject$1(obj) ? obj.__isVue ? ["div", vueStyle, "VueInstance"] : isRef(obj) ? [
        "div",
        {},
        ["span", vueStyle, genRefFlag(obj)],
        "<",
        // avoid debugger accessing value affecting behavior
        formatValue("_value" in obj ? obj._value : obj),
        ">"
      ] : isReactive(obj) ? [
        "div",
        {},
        ["span", vueStyle, isShallow(obj) ? "ShallowReactive" : "Reactive"],
        "<",
        formatValue(obj),
        `>${isReadonly(obj) ? " (readonly)" : ""}`
      ] : isReadonly(obj) ? [
        "div",
        {},
        ["span", vueStyle, isShallow(obj) ? "ShallowReadonly" : "Readonly"],
        "<",
        formatValue(obj),
        ">"
      ] : null : null;
    },
    hasBody(obj) {
      return obj && obj.__isVue;
    },
    body(obj) {
      if (obj && obj.__isVue)
        return [
          "div",
          {},
          ...formatInstance(obj.$)
        ];
    }
  };
  function formatInstance(instance) {
    const blocks = [];
    instance.type.props && instance.props && blocks.push(createInstanceBlock("props", toRaw(instance.props))), instance.setupState !== EMPTY_OBJ && blocks.push(createInstanceBlock("setup", instance.setupState)), instance.data !== EMPTY_OBJ && blocks.push(createInstanceBlock("data", toRaw(instance.data)));
    const computed2 = extractKeys(instance, "computed");
    computed2 && blocks.push(createInstanceBlock("computed", computed2));
    const injected = extractKeys(instance, "inject");
    return injected && blocks.push(createInstanceBlock("injected", injected)), blocks.push([
      "div",
      {},
      [
        "span",
        {
          style: keywordStyle.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: instance }]
    ]), blocks;
  }
  __name(formatInstance, "formatInstance");
  function createInstanceBlock(type, target) {
    return target = extend({}, target), Object.keys(target).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        type
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(target).map((key) => [
          "div",
          {},
          ["span", keywordStyle, key + ": "],
          formatValue(target[key], !1)
        ])
      ]
    ] : ["span", {}];
  }
  __name(createInstanceBlock, "createInstanceBlock");
  function formatValue(v, asRaw = !0) {
    return typeof v == "number" ? ["span", numberStyle, v] : typeof v == "string" ? ["span", stringStyle, JSON.stringify(v)] : typeof v == "boolean" ? ["span", keywordStyle, v] : isObject$1(v) ? ["object", { object: asRaw ? toRaw(v) : v }] : ["span", stringStyle, String(v)];
  }
  __name(formatValue, "formatValue");
  function extractKeys(instance, type) {
    const Comp = instance.type;
    if (isFunction$1(Comp))
      return;
    const extracted = {};
    for (const key in instance.ctx)
      isKeyOfType(Comp, key, type) && (extracted[key] = instance.ctx[key]);
    return extracted;
  }
  __name(extractKeys, "extractKeys");
  function isKeyOfType(Comp, key, type) {
    const opts = Comp[type];
    if (isArray$1(opts) && opts.includes(key) || isObject$1(opts) && key in opts || Comp.extends && isKeyOfType(Comp.extends, key, type) || Comp.mixins && Comp.mixins.some((m) => isKeyOfType(m, key, type)))
      return !0;
  }
  __name(isKeyOfType, "isKeyOfType");
  function genRefFlag(v) {
    return isShallow(v) ? "ShallowRef" : v.effect ? "ComputedRef" : "Ref";
  }
  __name(genRefFlag, "genRefFlag"), window.devtoolsFormatters ? window.devtoolsFormatters.push(formatter) : window.devtoolsFormatters = [formatter];
}
__name(initCustomFormatter, "initCustomFormatter");
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function initDev() {
  initCustomFormatter();
}
__name(initDev, "initDev");
process.env.NODE_ENV !== "production" && initDev();
function getDevtoolsGlobalHook() {
  return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
__name(getDevtoolsGlobalHook, "getDevtoolsGlobalHook");
function getTarget() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
__name(getTarget, "getTarget");
const isProxyAvailable = typeof Proxy == "function", HOOK_SETUP = "devtools-plugin:setup", HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
let supported, perf;
function isPerformanceSupported() {
  var _a;
  return supported !== void 0 || (typeof window < "u" && window.performance ? (supported = !0, perf = window.performance) : typeof globalThis < "u" && (!((_a = globalThis.perf_hooks) === null || _a === void 0) && _a.performance) ? (supported = !0, perf = globalThis.perf_hooks.performance) : supported = !1), supported;
}
__name(isPerformanceSupported, "isPerformanceSupported");
function now() {
  return isPerformanceSupported() ? perf.now() : Date.now();
}
__name(now, "now");
const _ApiProxy = class _ApiProxy {
  constructor(plugin, hook) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = plugin, this.hook = hook;
    const defaultSettings = {};
    if (plugin.settings)
      for (const id in plugin.settings) {
        const item = plugin.settings[id];
        defaultSettings[id] = item.defaultValue;
      }
    const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
    let currentSettings = Object.assign({}, defaultSettings);
    try {
      const raw = localStorage.getItem(localSettingsSaveId), data = JSON.parse(raw);
      Object.assign(currentSettings, data);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return currentSettings;
      },
      setSettings(value) {
        try {
          localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
        } catch {
        }
        currentSettings = value;
      },
      now() {
        return now();
      }
    }, hook && hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
      pluginId === this.plugin.id && this.fallbacks.setSettings(value);
    }), this.proxiedOn = new Proxy({}, {
      get: /* @__PURE__ */ __name((_target, prop) => this.target ? this.target.on[prop] : (...args) => {
        this.onQueue.push({
          method: prop,
          args
        });
      }, "get")
    }), this.proxiedTarget = new Proxy({}, {
      get: /* @__PURE__ */ __name((_target, prop) => this.target ? this.target[prop] : prop === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(prop) ? (...args) => (this.targetQueue.push({
        method: prop,
        args,
        resolve: /* @__PURE__ */ __name(() => {
        }, "resolve")
      }), this.fallbacks[prop](...args)) : (...args) => new Promise((resolve) => {
        this.targetQueue.push({
          method: prop,
          args,
          resolve
        });
      }), "get")
    });
  }
  async setRealTarget(target) {
    this.target = target;
    for (const item of this.onQueue)
      this.target.on[item.method](...item.args);
    for (const item of this.targetQueue)
      item.resolve(await this.target[item.method](...item.args));
  }
};
__name(_ApiProxy, "ApiProxy");
let ApiProxy = _ApiProxy;
function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
  const descriptor = pluginDescriptor, target = getTarget(), hook = getDevtoolsGlobalHook(), enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
  if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy))
    hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
  else {
    const proxy = enableProxy ? new ApiProxy(descriptor, hook) : null;
    (target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: descriptor,
      setupFn,
      proxy
    }), proxy && setupFn(proxy.proxiedTarget);
  }
}
__name(setupDevtoolsPlugin, "setupDevtoolsPlugin");
/*!
  * vue-router v4.5.1
  * (c) 2025 Eduardo San Martin Morote
  * @license MIT
  */
var NavigationType;
(function(NavigationType2) {
  NavigationType2.pop = "pop", NavigationType2.push = "push";
})(NavigationType || (NavigationType = {}));
var NavigationDirection;
(function(NavigationDirection2) {
  NavigationDirection2.back = "back", NavigationDirection2.forward = "forward", NavigationDirection2.unknown = "";
})(NavigationDirection || (NavigationDirection = {}));
const NavigationFailureSymbol = Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var NavigationFailureType;
(function(NavigationFailureType2) {
  NavigationFailureType2[NavigationFailureType2.aborted = 4] = "aborted", NavigationFailureType2[NavigationFailureType2.cancelled = 8] = "cancelled", NavigationFailureType2[NavigationFailureType2.duplicated = 16] = "duplicated";
})(NavigationFailureType || (NavigationFailureType = {}));
function isNavigationFailure(error2, type) {
  return error2 instanceof Error && NavigationFailureSymbol in error2 && (type == null || !!(error2.type & type));
}
__name(isNavigationFailure, "isNavigationFailure");
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
const failureTypeMap = {
  duplicated: {
    type: NavigationFailureType.duplicated,
    text: "the navigation was prevented since we are already at the target location."
  },
  redirected: {
    type: NavigationFailureType.redirected,
    text: "next(newLocation) was called inside of a navigation guard to redirect somewhere else."
  },
  aborted: {
    type: NavigationFailureType.aborted,
    text: "next(false) was called inside of a navigation guard to the navigation."
  },
  cancelled: {
    type: NavigationFailureType.cancelled,
    text: "new navigation completely took place before the current navigation could finish."
  }
};
function getSlugFromSlugWithPath(slugWithPath) {
  if (slugWithPath.includes("/") == !1)
    return;
  const slugWithPathParts = slugWithPath.split("/");
  return slugWithPathParts[slugWithPathParts.length - 1];
}
__name(getSlugFromSlugWithPath, "getSlugFromSlugWithPath");
function handleNavigationFailure(failure, ignore_types = ["duplicated"]) {
  let type_string = "", to_string = JSON.stringify(failure.to.fullPath), from_string = JSON.stringify(failure.from.fullPath);
  Object.keys(failureTypeMap).forEach((type) => {
    if (ignore_types.includes(type) == !1) {
      let match = failureTypeMap[type];
      isNavigationFailure(failure, match.type) && (type_string = match.text);
    }
  }), type_string != "" && console.error(
    "Navigation from " + from_string + " to " + to_string + " failed because " + type_string
  );
}
__name(handleNavigationFailure, "handleNavigationFailure");
function routerPush(router, routerTo) {
  router.push(routerTo).catch((failure) => {
    handleNavigationFailure(failure);
  });
}
__name(routerPush, "routerPush");
function routerReplace(router, routerTo) {
  router.replace(routerTo).catch((failure) => {
    handleNavigationFailure(failure);
  });
}
__name(routerReplace, "routerReplace");
function cleanupUrl(path = "/", defaultBaseUrl) {
  let url = trimTrailingSlash(getBaseUrlForIdManager());
  path.startsWith("/") == !1 && (url += "/"), url += path, url = trimTrailingSlash(url);
  let last = url.lastIndexOf("/"), slug = url.substring(last).toUpperCase();
  return slug = slug.replace(/O/gi, "0"), slug = slug.replace(/([LI])/gi, "1"), url = url.substring(0, last) + slug, url;
}
__name(cleanupUrl, "cleanupUrl");
async function getIndexedIdFromRoute(routeObj, defaultBaseUrl, targetGenerator) {
  let indexedId = getIndexedIdFromBody(routeObj);
  if (indexedId)
    return { indexedId };
  let routerPath = routeObj.path;
  if (routerPath == null && routeObj?.state?.indexedId == null)
    return { status: "err.not_found" };
  if (routeObj?.state?.indexedId != null)
    return {
      indexedId: routeObj.state.indexedId
    };
  let match = routerPath.match(/\/(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})\/?$/);
  if (match && match.length > 1)
    return { indexedId: match[1] };
  if (routerPath == null && (routeObj.params == null || routeObj.params.slug == null))
    return { status: "err.not_found" };
  routerPath == null && (routerPath = routeObj.name + "/" + routeObj.state.indexedId);
  let url = cleanupUrl(routerPath);
  try {
    indexedId = await lookupUuidFromUrl(
      url,
      targetGenerator,
      void 0
    );
  } catch (e) {
    return { status: "err.not_found", exception: e };
  }
  return indexedId == null ? { status: "err.not_found" } : (indexedId = trimTrailingSlash(indexedId), indexedId = getIndexedId(indexedId), { indexedId });
}
__name(getIndexedIdFromRoute, "getIndexedIdFromRoute");
function getIndexedIdFromBody(route) {
  if (document == null)
    return;
  let local_id = document.getElementById("local_id_manager");
  if (local_id == null || local_id.innerText == null)
    return;
  let localIdLookup = JSON.parse(local_id.innerText);
  if (route && route.params && route.params.slug == localIdLookup.slug)
    return localIdLookup.indexedId;
}
__name(getIndexedIdFromBody, "getIndexedIdFromBody");
const Router = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cleanupUrl,
  getIndexedIdFromRoute,
  getSlugFromSlugWithPath,
  handleNavigationFailure,
  routerPush,
  routerReplace
}, Symbol.toStringTag, { value: "Module" })), special_characters = {
  Á: "a",
  á: "a",
  Â: "a",
  â: "a",
  Ä: "a",
  ä: "a",
  Ã: "a",
  ã: "a",
  Ç: "c",
  ç: "c",
  È: "e",
  è: "e",
  É: "e",
  é: "e",
  Ê: "e",
  ê: "e",
  Ě: "e",
  ě: "e",
  Ë: "e",
  ë: "e",
  Í: "i",
  í: "i",
  Î: "i",
  î: "i",
  Ï: "i",
  ï: "i",
  Ó: "o",
  ó: "o",
  Ò: "o",
  ò: "o",
  Ô: "o",
  ô: "o",
  Ö: "o",
  ö: "o",
  Ø: "o",
  ø: "o",
  Ñ: "n",
  ñ: "n",
  Ř: "r",
  ř: "r",
  Š: "s",
  š: "s",
  Ú: "u",
  ú: "u",
  Ù: "u",
  ù: "u",
  Ü: "u",
  ü: "u",
  Ý: "y",
  ý: "y",
  Ÿ: "y",
  ÿ: "y"
}, RESERVED_FIELDS = ["page", "size", "q", "view", "from"], IS_FILTER_ID_RE = /(^id$)|(.[\._]id)/, ID_FILTERS = ["part_of"];
function getIntParam(initial_value, default_value) {
  const value = typeof initial_value == "number" ? initial_value : parseInt(initial_value);
  return value == null || isNaN(value) ? default_value : value;
}
__name(getIntParam, "getIntParam");
function getArrayParam(initial_value, default_value) {
  if (initial_value == null)
    return default_value;
  let value = JSON.parse(JSON.stringify(initial_value));
  return value == "" ? [] : typeof value == "string" && value != "" ? [value] : value;
}
__name(getArrayParam, "getArrayParam");
function getStringParam(initial_value, default_value) {
  return initial_value == null || initial_value == "" || typeof initial_value != "string" ? default_value : initial_value;
}
__name(getStringParam, "getStringParam");
function extractSearchParams(queryObject, allowedFilters, defaultSize, extraParams = []) {
  let query = queryObject.q ? JSON.parse(JSON.stringify(queryObject.q)) : [];
  query == "" ? query = [] : typeof query == "string" && query != "" && (query = [query]);
  const from = getIntParam(queryObject.from, 0), size = getIntParam(queryObject.size, defaultSize), debug = queryObject.debug ? !0 : void 0;
  let extra = {}, filters = {}, sort;
  for (let key in queryObject) {
    if (RESERVED_FIELDS.includes(key) || queryObject[key] == null || key == "")
      continue;
    if (key == "sort") {
      sort = queryObject[key];
      continue;
    }
    let val = getKeyValue(queryObject, key);
    if (val != null) {
      if (extraParams.includes(key)) {
        extra[key] = val;
        continue;
      }
      allowedFilters.includes(key) && (filters[key] = val);
    }
  }
  let searchParams = { query, from, size, filters };
  return sort && (searchParams.sort = sort), debug && (searchParams.debug = debug), Object.keys(extra).length > 0 && (searchParams.extra = extra), searchParams;
}
__name(extractSearchParams, "extractSearchParams");
function getKeyValue(queryObject, key) {
  if (typeof queryObject[key] == "string" || typeof queryObject[key] == "boolean")
    return [queryObject[key]];
  if (!(queryObject[key] == null || queryObject[key].length == 0))
    return queryObject[key];
}
__name(getKeyValue, "getKeyValue");
function handleSearchEvent(event, $router, currentQuery, search = !0, reservedFields = RESERVED_FIELDS) {
  let query = generateNewSearchQueryObject(event, currentQuery, reservedFields);
  (isEqual(query, currentQuery) == !1 || search == !1) && routerPush($router, {
    name: "search",
    query
  });
}
__name(handleSearchEvent, "handleSearchEvent");
function generateNewSearchQueryObject(event, currentQuery_, reservedFields = RESERVED_FIELDS) {
  let currentQuery = currentQuery_, query = JSON.parse(JSON.stringify(currentQuery)), key = event.name, from;
  switch (event.type) {
    case "batchEvent":
      Array.isArray(event.value) && (event.value.forEach((facet) => {
        currentQuery = generateNewSearchQueryObject(
          facet,
          currentQuery,
          reservedFields
        );
      }), query = currentQuery);
      break;
    case "clearField":
      if (reservedFields.includes(key) && key != "q")
        break;
      delete query[key];
      break;
    case "replaceFieldValues":
      if (reservedFields.includes(key) && key != "q")
        break;
      query[key] = [];
    case "addField":
      if (reservedFields.includes(key) && key != "q")
        break;
      query[key] == null && (query[key] = []), Array.isArray(query[key]) == !1 && (query[key] = [query[key]]), query[key].includes(event.value) == !1 && query[key].push(event.value), query[key] = query[key].filter(function(el) {
        return el != null && (typeof el == "string" && el.trim().length > 0 || typeof el != "string");
      }), query[key].length == 0 && delete query[key];
      break;
    case "deleteField":
      if (query[key] == null || (query.sort && delete query.sort, reservedFields.includes(key) && key != "q"))
        break;
      Array.isArray(query[key]) == !1 && (query[key] = [query[key]]);
      let index = query[key].indexOf(event.value);
      index > -1 && query[key].splice(index, 1);
      break;
    case "clearAll":
      let toDelete = [];
      for (key in query)
        toDelete.push(key);
      if (toDelete.forEach((key2) => {
        delete query[key2];
      }), event.value)
        for (key of Object.keys(event.value))
          query[key] = event.value[key];
      break;
    case "page":
      from = event.value;
      break;
    case "sort":
      query.sort = event.value;
      break;
    case "size":
      query.size = event.value;
      break;
    case "view":
      query.view = event.value;
      break;
    case "updateBoolean":
      event.value == !0 ? query[key] = !0 : query[key] && delete query[key];
      break;
  }
  return query.from = from, (query.from == null || query.from == 0) && delete query.from, query;
}
__name(generateNewSearchQueryObject, "generateNewSearchQueryObject");
function joinStringArray(translate2, stringArray, _conjunction) {
  let comma = translate2("search_results_title.punctuation.comma"), result = "";
  return _conjunction == null && (_conjunction = translate2("search_results_title.default_conjunction")), stringArray.length >= 3 ? (result = stringArray.slice(0, -1).join(comma + " "), result = result + comma + _conjunction + stringArray.slice(-1)) : result = stringArray.join(_conjunction), result;
}
__name(joinStringArray, "joinStringArray");
function getFiltersString(t, filters, filterMap, translationKeys = []) {
  let base = "search_results_title." + filterMap.app, filterStrings = [], booleanFilters = [];
  for (let key in filters) {
    let filterValues = filters[key], filterString = "";
    if (!Object.keys(filterMap).includes(key) || filterMap.ignore.includes(key) || !filters.hasOwnProperty(key)) {
      console.warn("skipping query parameter:" + key);
      continue;
    }
    if (filters[key] === !0) {
      booleanFilters.push(key);
      continue;
    }
    translationKeys.includes(key) && (filterValues = filterValues.map((x) => filterMap[x] ? t(base + filterMap[x]) : x)), filterMap[key].prefix && (filterString += t(base + filterMap[key].prefix));
    let conjunction = filterMap[key].conjunction ? t(base + filterMap[key].conjunction) : "";
    filterString += joinStringArray(t, filterValues, conjunction), filterStrings.push(filterString);
  }
  if (booleanFilters.length == 0 && filterStrings.length == 0)
    return "";
  let filtersPrefix = t("search_results_title.filter_pieces.basic"), booleanPrefix = t("search_results_title.filter_pieces.boolean"), filtersDisplayString = joinStringArray(t, filterStrings), booleanFiltersDisplayString = joinStringArray(
    t,
    booleanFilters.map((x) => t(base + filterMap[x]))
  ), displayFilters = "";
  return filterStrings.length && (displayFilters += filtersPrefix + filtersDisplayString), booleanFilters.length && (displayFilters.length && (displayFilters += booleanPrefix), displayFilters += booleanFiltersDisplayString), displayFilters;
}
__name(getFiltersString, "getFiltersString");
function getSearchResultsTitle(translate2, searchObj, filter_map, translationKeys = [], _initial_filters = {}) {
  let filters = _initial_filters || {}, query = [];
  if (Array.isArray(searchObj))
    query = searchObj;
  else if (query = searchObj.q || [], Object.keys(_initial_filters).length == 0) {
    const standard = filter_map.standard;
    for (let key in searchObj) {
      let val = searchObj[key];
      standard.includes(key) || Array.isArray(val) && val.length == 0 || (typeof searchObj[key] == "string" ? filters[key] = [val] : filters[key] = val);
    }
  }
  let comma = translate2("search_results_title.punctuation.comma"), quote = translate2("search_results_title.punctuation.quote"), prefix = translate2("search_results_title.prefix.keyword"), no_query = translate2("search_results_title.prefix.no_keyword"), find_all = translate2("search_results_title.default"), queries = joinStringArray(
    translate2,
    query.map((x) => quote + x + quote)
  ), filtersString = getFiltersString(
    translate2,
    filters,
    filter_map,
    translationKeys
  );
  if (query.length > 0) {
    let result = prefix + queries;
    return Object.keys(filters).length > 0 && filtersString != "" && (result += comma + " " + filtersString), result;
  } else if (Object.keys(filters).length > 0)
    return no_query + filtersString;
  return find_all;
}
__name(getSearchResultsTitle, "getSearchResultsTitle");
function getDateMinMax(value) {
  if (value == null || value.length == 0)
    return;
  let ret = {}, range = value[0].split(":");
  return range[0] != null && range[0] != "" && (ret.min = parseInt(range[0])), range[1] != null && range[1] != "" && (ret.max = parseInt(range[1])), ret;
}
__name(getDateMinMax, "getDateMinMax");
function getErrorMessage(results) {
  if (results != null) {
    if (results.total == 0)
      return "search.no_results_error";
    if (results.error == "page_out_of_range" || results.error == "too_many_results")
      return "search.out_of_range_error";
  }
}
__name(getErrorMessage, "getErrorMessage");
function getSearchHash(results) {
  let returnHash;
  return results != null && results.searchHash && (returnHash = results.searchHash), returnHash;
}
__name(getSearchHash, "getSearchHash");
function getSearchInputText(params) {
  if (params.query != null)
    return params.query.join(" ");
}
__name(getSearchInputText, "getSearchInputText");
function asciiMapText(string) {
  let asciiMappedLetters = [];
  for (let i = 0; i < string.length; i++) {
    let letter = string.charAt(i).toLowerCase();
    special_characters[letter] ? asciiMappedLetters.push(special_characters[letter]) : asciiMappedLetters.push(letter);
  }
  return asciiMappedLetters.join("").replace(/,/g, "");
}
__name(asciiMapText, "asciiMapText");
function isEmptySearch(params) {
  return (params.query == null || params.query.length == 0) && (params.filters == null || Object.keys(params.filters).length == 0);
}
__name(isEmptySearch, "isEmptySearch");
function getBooleanFilters(filterMap) {
  let booleans = [];
  return Object.keys(filterMap).forEach((key) => {
    let value = filterMap[key];
    typeof value == "string" && value.includes("boolean") && booleans.push(key);
  }), booleans;
}
__name(getBooleanFilters, "getBooleanFilters");
function constructQueryObject(params, display) {
  let currentQuery = Object.assign({}, params.filters);
  return params.query.length > 0 && (currentQuery.q = params.query), params.size != display.PAGE_SIZE && (currentQuery.size = params.size), params.from != 0 && (currentQuery.from = params.from), params.sort != display.SORT && (currentQuery.sort = params.sort), currentQuery;
}
__name(constructQueryObject, "constructQueryObject");
function getFacetInfo(facetInfo, results) {
  const facets = results.facets || {};
  return facetInfo.forEach((facet, i) => {
    const resultsFacet = facets[facet.fieldName] || [];
    if (facetInfo[i].disabled = !1, resultsFacet.length < 2)
      facetInfo[i].disabled = !0;
    else if (facet.type == "DateRange") {
      const vals = new Set(resultsFacet.map((e) => e.val));
      (results.total == 1 || vals.size == 1) && (facetInfo[i].disabled = !0);
    }
  }), facetInfo;
}
__name(getFacetInfo, "getFacetInfo");
function getFilterInfo(filterInfo, params, results) {
  const facets = results.facets ?? {}, currentFilters = params?.filters ?? {};
  return filterInfo.forEach((filter, _index) => {
    const isChecked = currentFilters[filter.fieldName]?.[0] == "true";
    filter.checked = !!isChecked;
    const hasCheckedResults = facets[filter.fieldName]?.find(
      // boolean facets return filter names of '0' and '1'
      (e) => Number(e.name) == 1
    );
    filter.disabled = !(filter.checked || hasCheckedResults);
  }), filterInfo;
}
__name(getFilterInfo, "getFilterInfo");
function isIdFilter(filter) {
  return !!(filter.search(IS_FILTER_ID_RE) > -1 || ID_FILTERS.includes(filter));
}
__name(isIdFilter, "isIdFilter");
async function getChipTermIds(params) {
  return Object.entries(params.filters).filter((entry) => isIdFilter(entry[0])).reduce((acc, val) => acc.concat(val[1]), []);
}
__name(getChipTermIds, "getChipTermIds");
const SearchService = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  asciiMapText,
  constructQueryObject,
  extractSearchParams,
  generateNewSearchQueryObject,
  getArrayParam,
  getBooleanFilters,
  getChipTermIds,
  getDateMinMax,
  getErrorMessage,
  getFacetInfo,
  getFilterInfo,
  getFiltersString,
  getIntParam,
  getSearchHash,
  getSearchInputText,
  getSearchResultsTitle,
  getStringParam,
  handleSearchEvent,
  isEmptySearch,
  isIdFilter,
  joinStringArray
}, Symbol.toStringTag, { value: "Module" })), MAX_DATE = /* @__PURE__ */ new Date(864e13), MIN_DATE = /* @__PURE__ */ new Date(-864e13);
function buildDate(str, logger = console) {
  if (str == null)
    return str;
  let calendar_date, time, year, month, day, hour, min, sec, ms = 0, date = /* @__PURE__ */ new Date(), date_parts = str.split(" "), bc = !1;
  if (date_parts[0] == "BC" ? (calendar_date = date_parts[1], time = date_parts[2], bc = !0) : (calendar_date = date_parts[0], time = date_parts[1]), time == null && logger) {
    logger.error("invalid date passed into date parsing %s", str);
    return;
  }
  let cal_parts = calendar_date.split("-"), time_parts = time.split(":");
  return year = cal_parts[0], bc && (year *= -1), month = cal_parts[1], day = cal_parts[2], hour = time_parts[0], min = time_parts[1], sec = time_parts[2], ms = time_parts[3], date.setHours(hour), date.setMinutes(min), date.setSeconds(sec), date.setMilliseconds(ms), date.setFullYear(year), date.setDate(day), date.setMonth(month - 1), date;
}
__name(buildDate, "buildDate");
function getTotalRange(rangeArray, interval = 10, returnIntervals = !0, logger = console) {
  let years = [], _min = MAX_DATE, _max = MIN_DATE, _mint, _maxt;
  return rangeArray.forEach((range) => {
    if (range != null) {
      let c_min = buildDate(range.gte, logger), c_max = buildDate(range.lte, logger);
      c_min < _min && (_min = c_min, _mint = range.gte), c_max > _max && (_max = c_max, _maxt = range.lte);
    }
  }), returnIntervals == !1 ? {
    min: { date: _min, text: _mint },
    max: { date: _max, text: _maxt }
  } : (_min != MAX_DATE && _max != MIN_DATE && (years = getRangeIntervals(_min, _max, interval)), years);
}
__name(getTotalRange, "getTotalRange");
function getRangeIntervals(_min, _max, n) {
  let min = _min, max = _max, years = [];
  if (min != null && max != null) {
    let minY = 1900 + min.getYear(), maxY = 1900 + max.getYear(), minR = Math.floor(minY / n) * n, maxR = Math.floor(maxY / n) * n;
    if (minR < maxR) {
      let i = minR;
      for (; i <= maxR; )
        years.push(i), i += n;
    } else {
      let floor = Math.floor(maxY / n) * n, ceil = Math.ceil(minY / n) * n;
      minY == maxY ? minY - floor < ceil - maxY ? years = [floor] : years = [ceil] : years = [ceil];
    }
  }
  return years;
}
__name(getRangeIntervals, "getRangeIntervals");
const DateHelpers = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  buildDate,
  getRangeIntervals,
  getTotalRange
}, Symbol.toStringTag, { value: "Module" }));
function toPascalCase(string) {
  return string.replace(/(\w)(\w*)/g, function(_g0, g1, g2) {
    return g1.toUpperCase() + g2.toLowerCase();
  });
}
__name(toPascalCase, "toPascalCase");
function deepAssign(target, ...sources) {
  for (let source of sources)
    for (let k in source) {
      let vs = source[k], vt = target[k];
      if (Object(vs) == vs && Object(vt) === vt) {
        target[k] = deepAssign(vt, vs);
        continue;
      }
      target[k] = source[k];
    }
  return target;
}
__name(deepAssign, "deepAssign");
function setupForStore(obj) {
  return obj._id = obj.id, obj.id = getIndexedId(obj.id), obj;
}
__name(setupForStore, "setupForStore");
function setupIdManagerResponseForStore(id_response, baseUrl = "/") {
  let item = id_response.items[0];
  return item.id = baseUrl + getIndexedId(item.target.id), item;
}
__name(setupIdManagerResponseForStore, "setupIdManagerResponseForStore");
function fakeIdManagerEntry(path, route, obj) {
  let id = obj.id, ids = id.split("/");
  return {
    id: getIndexedId(id),
    body: {
      id: "http://localhost:8080/" + route + "/" + ids[ids.length - 1]
    }
  };
}
__name(fakeIdManagerEntry, "fakeIdManagerEntry");
function setupMock(mock, url, file) {
  mock.onGet(url).reply(200, file);
}
__name(setupMock, "setupMock");
function cleanupEnvironmentUrls(url) {
  let id = getIndexedId(url).split("/")[1], extra = "", oldId;
  if (url.includes("?")) {
    const qsPoint = url.indexOf("?"), qs = url.substring(url.indexOf("?") + 1);
    let part = url.substring(0, qsPoint);
    part.endsWith("/") && (part = part.substring(0, part.length - 1)), extra = part.split("/").at(-1), id = MD5(`${extra}?${qs}`);
  }
  return url.includes("/api/") ? oldId = MD5(url) : url.includes("/links/") ? (url = url.replace(
    "http://localhost:8080/",
    "https://services.getty.edu/id-management/"
  ), oldId = MD5(url)) : url.includes("-tm-") && (id = `-tm-${id}`), { id, url, oldId, extra };
}
__name(cleanupEnvironmentUrls, "cleanupEnvironmentUrls");
async function setupMockAxios({
  mockAxios,
  existsSync,
  readFileSync,
  writeFileSync,
  mkdirSync,
  renameSync,
  baseFilePath = "src/data/mocks"
}) {
  mockAxios.onAny().reply(async (config) => {
    let { id, url, oldId, extra } = cleanupEnvironmentUrls(config.url);
    config.url = url, ["aat", "tgn", "ulan"].forEach((vocab) => {
      url.includes(`/${vocab}/`) && (extra = `${vocab}`);
    }), url.includes("/manifest/") && (extra = "manifest", (url.includes("/v3.") || url.includes("/3/")) && (extra = "manifest3")), config.method != "get" && (extra = config.url.split("/").at(-1), id = MD5(JSON.stringify(config.data) + extra), oldId = MD5(JSON.stringify(config.data) + config.uri), config.url.includes("sparql") && (id = "sparql-" + id, extra = "sparql")), baseFilePath.endsWith("/") && (baseFilePath = baseFilePath.splice(0, baseFilePath.length - 1)), extra != "" && (extra += "/");
    let path = `${baseFilePath}/${extra}${id}.json`;
    console.trace(`${url} --> ${path}`);
    let data;
    existsSync(`${baseFilePath}/${extra}`) == !1 && mkdirSync(`${baseFilePath}/${extra}`);
    const oldPath = `${baseFilePath}/${oldId}.json`;
    if (existsSync(oldPath) && existsSync(path) == !1 && renameSync(oldPath, path), existsSync(path))
      data = readFileSync(path, "utf8"), data = JSON.parse(data);
    else {
      delete config.headers.axiosRetryCount;
      try {
        data = await axios.request(config);
      } catch (e) {
        if (config.method == "get")
          try {
            data = (await fetch(config.url)).json();
          } catch (ee) {
            console.error("fetch fallback failed", ee);
          }
        console.error(`${config.url} --> ${path}`, e);
      }
      writeFileSync(path, JSON.stringify(data.data)), data = data.data;
    }
    return [200, data];
  });
}
__name(setupMockAxios, "setupMockAxios");
async function addAndValidateStore({
  indexedId,
  basePath = "src/data/mocks",
  addMethod,
  getMethod,
  translate: translate2,
  translateNumber,
  existsSync,
  readFileSync,
  writeFileSync,
  mkdirSync
}) {
  let id = indexedId.split("/")[1];
  expect(getMethod(indexedId)).toEqual(void 0);
  const path = `${basePath}/${id}.json`;
  existsSync(basePath) == !1 && mkdirSync(basePath), await addMethod(indexedId, translate2, translateNumber);
  const record = getMethod(indexedId);
  if (existsSync(path)) {
    const originalData = JSON.parse(readFileSync(path));
    expect(record).toEqual(originalData);
  }
  writeFileSync(path, JSON.stringify(record, null, 4));
}
__name(addAndValidateStore, "addAndValidateStore");
const testHelpers = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAndValidateStore,
  fakeIdManagerEntry,
  setupForStore,
  setupIdManagerResponseForStore,
  setupMock,
  setupMockAxios
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * shared v11.1.10
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function warn(msg, err) {
  typeof console < "u" && (console.warn("[intlify] " + msg), err && console.warn(err.stack));
}
__name(warn, "warn");
const hasWarned = {};
function warnOnce(msg) {
  hasWarned[msg] || (hasWarned[msg] = !0, warn(msg));
}
__name(warnOnce, "warnOnce");
const inBrowser = typeof window < "u";
let mark, measure;
if (process.env.NODE_ENV !== "production") {
  const perf2 = inBrowser && window.performance;
  perf2 && perf2.mark && perf2.measure && perf2.clearMarks && // @ts-ignore browser compat
  perf2.clearMeasures && (mark = /* @__PURE__ */ __name((tag) => {
    perf2.mark(tag);
  }, "mark"), measure = /* @__PURE__ */ __name((name, startTag, endTag) => {
    perf2.measure(name, startTag, endTag), perf2.clearMarks(startTag), perf2.clearMarks(endTag);
  }, "measure"));
}
const RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
function format$1(message, ...args) {
  return args.length === 1 && isObject(args[0]) && (args = args[0]), (!args || !args.hasOwnProperty) && (args = {}), message.replace(RE_ARGS, (match, identifier) => args.hasOwnProperty(identifier) ? args[identifier] : "");
}
__name(format$1, "format$1");
const makeSymbol = /* @__PURE__ */ __name((name, shareable = !1) => shareable ? Symbol.for(name) : Symbol(name), "makeSymbol"), generateFormatCacheKey = /* @__PURE__ */ __name((locale, key, source) => friendlyJSONstringify({ l: locale, k: key, s: source }), "generateFormatCacheKey"), friendlyJSONstringify = /* @__PURE__ */ __name((json) => JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), "friendlyJSONstringify"), isNumber = /* @__PURE__ */ __name((val) => typeof val == "number" && isFinite(val), "isNumber"), isDate = /* @__PURE__ */ __name((val) => toTypeString(val) === "[object Date]", "isDate"), isRegExp = /* @__PURE__ */ __name((val) => toTypeString(val) === "[object RegExp]", "isRegExp"), isEmptyObject = /* @__PURE__ */ __name((val) => isPlainObject(val) && Object.keys(val).length === 0, "isEmptyObject"), assign = Object.assign, _create = Object.create, create = /* @__PURE__ */ __name((obj = null) => _create(obj), "create");
let _globalThis;
const getGlobalThis = /* @__PURE__ */ __name(() => _globalThis || (_globalThis = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : create()), "getGlobalThis");
function escapeHtml(rawText) {
  return rawText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
__name(escapeHtml, "escapeHtml");
function escapeAttributeValue(value) {
  return value.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
__name(escapeAttributeValue, "escapeAttributeValue");
function sanitizeTranslatedHtml(html) {
  return html = html.replace(/(\w+)\s*=\s*"([^"]*)"/g, (_, attrName, attrValue) => `${attrName}="${escapeAttributeValue(attrValue)}"`), html = html.replace(/(\w+)\s*=\s*'([^']*)'/g, (_, attrName, attrValue) => `${attrName}='${escapeAttributeValue(attrValue)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(html) && (process.env.NODE_ENV !== "production" && warn("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), html = html.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((pattern) => {
    html = html.replace(pattern, "$1javascript&#58;");
  }), html;
}
__name(sanitizeTranslatedHtml, "sanitizeTranslatedHtml");
const hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
__name(hasOwn, "hasOwn");
const isArray = Array.isArray, isFunction = /* @__PURE__ */ __name((val) => typeof val == "function", "isFunction"), isString = /* @__PURE__ */ __name((val) => typeof val == "string", "isString"), isBoolean = /* @__PURE__ */ __name((val) => typeof val == "boolean", "isBoolean"), isObject = /* @__PURE__ */ __name((val) => val !== null && typeof val == "object", "isObject"), isPromise = /* @__PURE__ */ __name((val) => isObject(val) && isFunction(val.then) && isFunction(val.catch), "isPromise"), objectToString = Object.prototype.toString, toTypeString = /* @__PURE__ */ __name((value) => objectToString.call(value), "toTypeString"), isPlainObject = /* @__PURE__ */ __name((val) => toTypeString(val) === "[object Object]", "isPlainObject"), toDisplayString = /* @__PURE__ */ __name((val) => val == null ? "" : isArray(val) || isPlainObject(val) && val.toString === objectToString ? JSON.stringify(val, null, 2) : String(val), "toDisplayString");
function join(items, separator = "") {
  return items.reduce((str, item, index) => index === 0 ? str + item : str + separator + item, "");
}
__name(join, "join");
const RANGE = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
  const lines = source.split(/\r?\n/);
  let count = 0;
  const res = [];
  for (let i = 0; i < lines.length; i++)
    if (count += lines[i].length + 1, count >= start) {
      for (let j = i - RANGE; j <= i + RANGE || end > count; j++) {
        if (j < 0 || j >= lines.length)
          continue;
        const line = j + 1;
        res.push(`${line}${" ".repeat(3 - String(line).length)}|  ${lines[j]}`);
        const lineLength = lines[j].length;
        if (j === i) {
          const pad = start - (count - lineLength) + 1, length = Math.max(1, end > count ? lineLength - pad : end - start);
          res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
        } else if (j > i) {
          if (end > count) {
            const length = Math.max(Math.min(end - count, lineLength), 1);
            res.push("   |  " + "^".repeat(length));
          }
          count += lineLength + 1;
        }
      }
      break;
    }
  return res.join(`
`);
}
__name(generateCodeFrame, "generateCodeFrame");
function createEmitter() {
  const events = /* @__PURE__ */ new Map();
  return {
    events,
    on(event, handler) {
      const handlers = events.get(event);
      handlers && handlers.push(handler) || events.set(event, [handler]);
    },
    off(event, handler) {
      const handlers = events.get(event);
      handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
    },
    emit(event, payload) {
      (events.get(event) || []).slice().map((handler) => handler(payload)), (events.get("*") || []).slice().map((handler) => handler(event, payload));
    }
  };
}
__name(createEmitter, "createEmitter");
const isNotObjectOrIsArray = /* @__PURE__ */ __name((val) => !isObject(val) || isArray(val), "isNotObjectOrIsArray");
function deepCopy(src, des) {
  if (isNotObjectOrIsArray(src) || isNotObjectOrIsArray(des))
    throw new Error("Invalid value");
  const stack2 = [{ src, des }];
  for (; stack2.length; ) {
    const { src: src2, des: des2 } = stack2.pop();
    Object.keys(src2).forEach((key) => {
      key !== "__proto__" && (isObject(src2[key]) && !isObject(des2[key]) && (des2[key] = Array.isArray(src2[key]) ? [] : create()), isNotObjectOrIsArray(des2[key]) || isNotObjectOrIsArray(src2[key]) ? des2[key] = src2[key] : stack2.push({ src: src2[key], des: des2[key] }));
    });
  }
}
__name(deepCopy, "deepCopy");
/*!
  * message-compiler v11.1.10
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function createPosition(line, column, offset) {
  return { line, column, offset };
}
__name(createPosition, "createPosition");
function createLocation(start, end, source) {
  return { start, end };
}
__name(createLocation, "createLocation");
const CompileErrorCodes = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, COMPILE_ERROR_CODES_EXTEND_POINT = 17, errorMessages$2 = {
  // tokenizer error messages
  [CompileErrorCodes.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [CompileErrorCodes.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [CompileErrorCodes.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function createCompileError(code, loc, options = {}) {
  const { domain, messages, args } = options, msg = process.env.NODE_ENV !== "production" ? format$1((messages || errorMessages$2)[code] || "", ...args || []) : code, error2 = new SyntaxError(String(msg));
  return error2.code = code, loc && (error2.location = loc), error2.domain = domain, error2;
}
__name(createCompileError, "createCompileError");
function defaultOnError(error2) {
  throw error2;
}
__name(defaultOnError, "defaultOnError");
const RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/, detectHtmlTag = /* @__PURE__ */ __name((source) => RE_HTML_TAG.test(source), "detectHtmlTag"), CHAR_SP = " ", CHAR_CR = "\r", CHAR_LF = `
`, CHAR_LS = "\u2028", CHAR_PS = "\u2029";
function createScanner(str) {
  const _buf = str;
  let _index = 0, _line = 1, _column = 1, _peekOffset = 0;
  const isCRLF = /* @__PURE__ */ __name((index2) => _buf[index2] === CHAR_CR && _buf[index2 + 1] === CHAR_LF, "isCRLF"), isLF = /* @__PURE__ */ __name((index2) => _buf[index2] === CHAR_LF, "isLF"), isPS = /* @__PURE__ */ __name((index2) => _buf[index2] === CHAR_PS, "isPS"), isLS = /* @__PURE__ */ __name((index2) => _buf[index2] === CHAR_LS, "isLS"), isLineEnd = /* @__PURE__ */ __name((index2) => isCRLF(index2) || isLF(index2) || isPS(index2) || isLS(index2), "isLineEnd"), index = /* @__PURE__ */ __name(() => _index, "index"), line = /* @__PURE__ */ __name(() => _line, "line"), column = /* @__PURE__ */ __name(() => _column, "column"), peekOffset = /* @__PURE__ */ __name(() => _peekOffset, "peekOffset"), charAt = /* @__PURE__ */ __name((offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? CHAR_LF : _buf[offset], "charAt"), currentChar = /* @__PURE__ */ __name(() => charAt(_index), "currentChar"), currentPeek = /* @__PURE__ */ __name(() => charAt(_index + _peekOffset), "currentPeek");
  function next() {
    return _peekOffset = 0, isLineEnd(_index) && (_line++, _column = 0), isCRLF(_index) && _index++, _index++, _column++, _buf[_index];
  }
  __name(next, "next");
  function peek() {
    return isCRLF(_index + _peekOffset) && _peekOffset++, _peekOffset++, _buf[_index + _peekOffset];
  }
  __name(peek, "peek");
  function reset() {
    _index = 0, _line = 1, _column = 1, _peekOffset = 0;
  }
  __name(reset, "reset");
  function resetPeek(offset = 0) {
    _peekOffset = offset;
  }
  __name(resetPeek, "resetPeek");
  function skipToPeek() {
    const target = _index + _peekOffset;
    for (; target !== _index; )
      next();
    _peekOffset = 0;
  }
  return __name(skipToPeek, "skipToPeek"), {
    index,
    line,
    column,
    peekOffset,
    charAt,
    currentChar,
    currentPeek,
    next,
    peek,
    reset,
    resetPeek,
    skipToPeek
  };
}
__name(createScanner, "createScanner");
const EOF = void 0, DOT = ".", LITERAL_DELIMITER = "'", ERROR_DOMAIN$3 = "tokenizer";
function createTokenizer(source, options = {}) {
  const location = options.location !== !1, _scnr = createScanner(source), currentOffset = /* @__PURE__ */ __name(() => _scnr.index(), "currentOffset"), currentPosition = /* @__PURE__ */ __name(() => createPosition(_scnr.line(), _scnr.column(), _scnr.index()), "currentPosition"), _initLoc = currentPosition(), _initOffset = currentOffset(), _context = {
    currentType: 13,
    offset: _initOffset,
    startLoc: _initLoc,
    endLoc: _initLoc,
    lastType: 13,
    lastOffset: _initOffset,
    lastStartLoc: _initLoc,
    lastEndLoc: _initLoc,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, context = /* @__PURE__ */ __name(() => _context, "context"), { onError } = options;
  function emitError(code, pos, offset, ...args) {
    const ctx = context();
    if (pos.column += offset, pos.offset += offset, onError) {
      const loc = location ? createLocation(ctx.startLoc, pos) : null, err = createCompileError(code, loc, {
        domain: ERROR_DOMAIN$3,
        args
      });
      onError(err);
    }
  }
  __name(emitError, "emitError");
  function getToken(context2, type, value) {
    context2.endLoc = currentPosition(), context2.currentType = type;
    const token = { type };
    return location && (token.loc = createLocation(context2.startLoc, context2.endLoc)), value != null && (token.value = value), token;
  }
  __name(getToken, "getToken");
  const getEndToken = /* @__PURE__ */ __name((context2) => getToken(
    context2,
    13
    /* TokenTypes.EOF */
  ), "getEndToken");
  function eat(scnr, ch) {
    return scnr.currentChar() === ch ? (scnr.next(), ch) : (emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch), "");
  }
  __name(eat, "eat");
  function peekSpaces(scnr) {
    let buf = "";
    for (; scnr.currentPeek() === CHAR_SP || scnr.currentPeek() === CHAR_LF; )
      buf += scnr.currentPeek(), scnr.peek();
    return buf;
  }
  __name(peekSpaces, "peekSpaces");
  function skipSpaces(scnr) {
    const buf = peekSpaces(scnr);
    return scnr.skipToPeek(), buf;
  }
  __name(skipSpaces, "skipSpaces");
  function isIdentifierStart(ch) {
    if (ch === EOF)
      return !1;
    const cc = ch.charCodeAt(0);
    return cc >= 97 && cc <= 122 || // a-z
    cc >= 65 && cc <= 90 || // A-Z
    cc === 95;
  }
  __name(isIdentifierStart, "isIdentifierStart");
  function isNumberStart(ch) {
    if (ch === EOF)
      return !1;
    const cc = ch.charCodeAt(0);
    return cc >= 48 && cc <= 57;
  }
  __name(isNumberStart, "isNumberStart");
  function isNamedIdentifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2)
      return !1;
    peekSpaces(scnr);
    const ret = isIdentifierStart(scnr.currentPeek());
    return scnr.resetPeek(), ret;
  }
  __name(isNamedIdentifierStart, "isNamedIdentifierStart");
  function isListIdentifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2)
      return !1;
    peekSpaces(scnr);
    const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek(), ret = isNumberStart(ch);
    return scnr.resetPeek(), ret;
  }
  __name(isListIdentifierStart, "isListIdentifierStart");
  function isLiteralStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2)
      return !1;
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === LITERAL_DELIMITER;
    return scnr.resetPeek(), ret;
  }
  __name(isLiteralStart, "isLiteralStart");
  function isLinkedDotStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 7)
      return !1;
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === ".";
    return scnr.resetPeek(), ret;
  }
  __name(isLinkedDotStart, "isLinkedDotStart");
  function isLinkedModifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 8)
      return !1;
    peekSpaces(scnr);
    const ret = isIdentifierStart(scnr.currentPeek());
    return scnr.resetPeek(), ret;
  }
  __name(isLinkedModifierStart, "isLinkedModifierStart");
  function isLinkedDelimiterStart(scnr, context2) {
    const { currentType } = context2;
    if (!(currentType === 7 || currentType === 11))
      return !1;
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === ":";
    return scnr.resetPeek(), ret;
  }
  __name(isLinkedDelimiterStart, "isLinkedDelimiterStart");
  function isLinkedReferStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 9)
      return !1;
    const fn = /* @__PURE__ */ __name(() => {
      const ch = scnr.currentPeek();
      return ch === "{" ? isIdentifierStart(scnr.peek()) : ch === "@" || ch === "|" || ch === ":" || ch === "." || ch === CHAR_SP || !ch ? !1 : ch === CHAR_LF ? (scnr.peek(), fn()) : isTextStart(scnr, !1);
    }, "fn"), ret = fn();
    return scnr.resetPeek(), ret;
  }
  __name(isLinkedReferStart, "isLinkedReferStart");
  function isPluralStart(scnr) {
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === "|";
    return scnr.resetPeek(), ret;
  }
  __name(isPluralStart, "isPluralStart");
  function isTextStart(scnr, reset = !0) {
    const fn = /* @__PURE__ */ __name((hasSpace = !1, prev = "") => {
      const ch = scnr.currentPeek();
      return ch === "{" || ch === "@" || !ch ? hasSpace : ch === "|" ? !(prev === CHAR_SP || prev === CHAR_LF) : ch === CHAR_SP ? (scnr.peek(), fn(!0, CHAR_SP)) : ch === CHAR_LF ? (scnr.peek(), fn(!0, CHAR_LF)) : !0;
    }, "fn"), ret = fn();
    return reset && scnr.resetPeek(), ret;
  }
  __name(isTextStart, "isTextStart");
  function takeChar(scnr, fn) {
    const ch = scnr.currentChar();
    return ch === EOF ? EOF : fn(ch) ? (scnr.next(), ch) : null;
  }
  __name(takeChar, "takeChar");
  function isIdentifier(ch) {
    const cc = ch.charCodeAt(0);
    return cc >= 97 && cc <= 122 || // a-z
    cc >= 65 && cc <= 90 || // A-Z
    cc >= 48 && cc <= 57 || // 0-9
    cc === 95 || // _
    cc === 36;
  }
  __name(isIdentifier, "isIdentifier");
  function takeIdentifierChar(scnr) {
    return takeChar(scnr, isIdentifier);
  }
  __name(takeIdentifierChar, "takeIdentifierChar");
  function isNamedIdentifier(ch) {
    const cc = ch.charCodeAt(0);
    return cc >= 97 && cc <= 122 || // a-z
    cc >= 65 && cc <= 90 || // A-Z
    cc >= 48 && cc <= 57 || // 0-9
    cc === 95 || // _
    cc === 36 || // $
    cc === 45;
  }
  __name(isNamedIdentifier, "isNamedIdentifier");
  function takeNamedIdentifierChar(scnr) {
    return takeChar(scnr, isNamedIdentifier);
  }
  __name(takeNamedIdentifierChar, "takeNamedIdentifierChar");
  function isDigit(ch) {
    const cc = ch.charCodeAt(0);
    return cc >= 48 && cc <= 57;
  }
  __name(isDigit, "isDigit");
  function takeDigit(scnr) {
    return takeChar(scnr, isDigit);
  }
  __name(takeDigit, "takeDigit");
  function isHexDigit(ch) {
    const cc = ch.charCodeAt(0);
    return cc >= 48 && cc <= 57 || // 0-9
    cc >= 65 && cc <= 70 || // A-F
    cc >= 97 && cc <= 102;
  }
  __name(isHexDigit, "isHexDigit");
  function takeHexDigit(scnr) {
    return takeChar(scnr, isHexDigit);
  }
  __name(takeHexDigit, "takeHexDigit");
  function getDigits(scnr) {
    let ch = "", num = "";
    for (; ch = takeDigit(scnr); )
      num += ch;
    return num;
  }
  __name(getDigits, "getDigits");
  function readText(scnr) {
    let buf = "";
    for (; ; ) {
      const ch = scnr.currentChar();
      if (ch === "{" || ch === "}" || ch === "@" || ch === "|" || !ch)
        break;
      if (ch === CHAR_SP || ch === CHAR_LF)
        if (isTextStart(scnr))
          buf += ch, scnr.next();
        else {
          if (isPluralStart(scnr))
            break;
          buf += ch, scnr.next();
        }
      else
        buf += ch, scnr.next();
    }
    return buf;
  }
  __name(readText, "readText");
  function readNamedIdentifier(scnr) {
    skipSpaces(scnr);
    let ch = "", name = "";
    for (; ch = takeNamedIdentifierChar(scnr); )
      name += ch;
    return scnr.currentChar() === EOF && emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0), name;
  }
  __name(readNamedIdentifier, "readNamedIdentifier");
  function readListIdentifier(scnr) {
    skipSpaces(scnr);
    let value = "";
    return scnr.currentChar() === "-" ? (scnr.next(), value += `-${getDigits(scnr)}`) : value += getDigits(scnr), scnr.currentChar() === EOF && emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0), value;
  }
  __name(readListIdentifier, "readListIdentifier");
  function isLiteral2(ch) {
    return ch !== LITERAL_DELIMITER && ch !== CHAR_LF;
  }
  __name(isLiteral2, "isLiteral");
  function readLiteral(scnr) {
    skipSpaces(scnr), eat(scnr, "'");
    let ch = "", literal = "";
    for (; ch = takeChar(scnr, isLiteral2); )
      ch === "\\" ? literal += readEscapeSequence(scnr) : literal += ch;
    const current = scnr.currentChar();
    return current === CHAR_LF || current === EOF ? (emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0), current === CHAR_LF && (scnr.next(), eat(scnr, "'")), literal) : (eat(scnr, "'"), literal);
  }
  __name(readLiteral, "readLiteral");
  function readEscapeSequence(scnr) {
    const ch = scnr.currentChar();
    switch (ch) {
      case "\\":
      case "'":
        return scnr.next(), `\\${ch}`;
      case "u":
        return readUnicodeEscapeSequence(scnr, ch, 4);
      case "U":
        return readUnicodeEscapeSequence(scnr, ch, 6);
      default:
        return emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch), "";
    }
  }
  __name(readEscapeSequence, "readEscapeSequence");
  function readUnicodeEscapeSequence(scnr, unicode, digits) {
    eat(scnr, unicode);
    let sequence = "";
    for (let i = 0; i < digits; i++) {
      const ch = takeHexDigit(scnr);
      if (!ch) {
        emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
        break;
      }
      sequence += ch;
    }
    return `\\${unicode}${sequence}`;
  }
  __name(readUnicodeEscapeSequence, "readUnicodeEscapeSequence");
  function isInvalidIdentifier(ch) {
    return ch !== "{" && ch !== "}" && ch !== CHAR_SP && ch !== CHAR_LF;
  }
  __name(isInvalidIdentifier, "isInvalidIdentifier");
  function readInvalidIdentifier(scnr) {
    skipSpaces(scnr);
    let ch = "", identifiers = "";
    for (; ch = takeChar(scnr, isInvalidIdentifier); )
      identifiers += ch;
    return identifiers;
  }
  __name(readInvalidIdentifier, "readInvalidIdentifier");
  function readLinkedModifier(scnr) {
    let ch = "", name = "";
    for (; ch = takeIdentifierChar(scnr); )
      name += ch;
    return name;
  }
  __name(readLinkedModifier, "readLinkedModifier");
  function readLinkedRefer(scnr) {
    const fn = /* @__PURE__ */ __name((buf) => {
      const ch = scnr.currentChar();
      return ch === "{" || ch === "@" || ch === "|" || ch === "(" || ch === ")" || !ch || ch === CHAR_SP ? buf : (buf += ch, scnr.next(), fn(buf));
    }, "fn");
    return fn("");
  }
  __name(readLinkedRefer, "readLinkedRefer");
  function readPlural(scnr) {
    skipSpaces(scnr);
    const plural = eat(
      scnr,
      "|"
      /* TokenChars.Pipe */
    );
    return skipSpaces(scnr), plural;
  }
  __name(readPlural, "readPlural");
  function readTokenInPlaceholder(scnr, context2) {
    let token = null;
    switch (scnr.currentChar()) {
      case "{":
        return context2.braceNest >= 1 && emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0), scnr.next(), token = getToken(
          context2,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), skipSpaces(scnr), context2.braceNest++, token;
      case "}":
        return context2.braceNest > 0 && context2.currentType === 2 && emitError(CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0), scnr.next(), token = getToken(
          context2,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), context2.braceNest--, context2.braceNest > 0 && skipSpaces(scnr), context2.inLinked && context2.braceNest === 0 && (context2.inLinked = !1), token;
      case "@":
        return context2.braceNest > 0 && emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0), token = readTokenInLinked(scnr, context2) || getEndToken(context2), context2.braceNest = 0, token;
      default: {
        let validNamedIdentifier = !0, validListIdentifier = !0, validLiteral = !0;
        if (isPluralStart(scnr))
          return context2.braceNest > 0 && emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0), token = getToken(context2, 1, readPlural(scnr)), context2.braceNest = 0, context2.inLinked = !1, token;
        if (context2.braceNest > 0 && (context2.currentType === 4 || context2.currentType === 5 || context2.currentType === 6))
          return emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0), context2.braceNest = 0, readToken(scnr, context2);
        if (validNamedIdentifier = isNamedIdentifierStart(scnr, context2))
          return token = getToken(context2, 4, readNamedIdentifier(scnr)), skipSpaces(scnr), token;
        if (validListIdentifier = isListIdentifierStart(scnr, context2))
          return token = getToken(context2, 5, readListIdentifier(scnr)), skipSpaces(scnr), token;
        if (validLiteral = isLiteralStart(scnr, context2))
          return token = getToken(context2, 6, readLiteral(scnr)), skipSpaces(scnr), token;
        if (!validNamedIdentifier && !validListIdentifier && !validLiteral)
          return token = getToken(context2, 12, readInvalidIdentifier(scnr)), emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value), skipSpaces(scnr), token;
        break;
      }
    }
    return token;
  }
  __name(readTokenInPlaceholder, "readTokenInPlaceholder");
  function readTokenInLinked(scnr, context2) {
    const { currentType } = context2;
    let token = null;
    const ch = scnr.currentChar();
    switch ((currentType === 7 || currentType === 8 || currentType === 11 || currentType === 9) && (ch === CHAR_LF || ch === CHAR_SP) && emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0), ch) {
      case "@":
        return scnr.next(), token = getToken(
          context2,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), context2.inLinked = !0, token;
      case ".":
        return skipSpaces(scnr), scnr.next(), getToken(
          context2,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return skipSpaces(scnr), scnr.next(), getToken(
          context2,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return isPluralStart(scnr) ? (token = getToken(context2, 1, readPlural(scnr)), context2.braceNest = 0, context2.inLinked = !1, token) : isLinkedDotStart(scnr, context2) || isLinkedDelimiterStart(scnr, context2) ? (skipSpaces(scnr), readTokenInLinked(scnr, context2)) : isLinkedModifierStart(scnr, context2) ? (skipSpaces(scnr), getToken(context2, 11, readLinkedModifier(scnr))) : isLinkedReferStart(scnr, context2) ? (skipSpaces(scnr), ch === "{" ? readTokenInPlaceholder(scnr, context2) || token : getToken(context2, 10, readLinkedRefer(scnr))) : (currentType === 7 && emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0), context2.braceNest = 0, context2.inLinked = !1, readToken(scnr, context2));
    }
  }
  __name(readTokenInLinked, "readTokenInLinked");
  function readToken(scnr, context2) {
    let token = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (context2.braceNest > 0)
      return readTokenInPlaceholder(scnr, context2) || getEndToken(context2);
    if (context2.inLinked)
      return readTokenInLinked(scnr, context2) || getEndToken(context2);
    switch (scnr.currentChar()) {
      case "{":
        return readTokenInPlaceholder(scnr, context2) || getEndToken(context2);
      case "}":
        return emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0), scnr.next(), getToken(
          context2,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return readTokenInLinked(scnr, context2) || getEndToken(context2);
      default: {
        if (isPluralStart(scnr))
          return token = getToken(context2, 1, readPlural(scnr)), context2.braceNest = 0, context2.inLinked = !1, token;
        if (isTextStart(scnr))
          return getToken(context2, 0, readText(scnr));
        break;
      }
    }
    return token;
  }
  __name(readToken, "readToken");
  function nextToken() {
    const { currentType, offset, startLoc, endLoc } = _context;
    return _context.lastType = currentType, _context.lastOffset = offset, _context.lastStartLoc = startLoc, _context.lastEndLoc = endLoc, _context.offset = currentOffset(), _context.startLoc = currentPosition(), _scnr.currentChar() === EOF ? getToken(
      _context,
      13
      /* TokenTypes.EOF */
    ) : readToken(_scnr, _context);
  }
  return __name(nextToken, "nextToken"), {
    nextToken,
    currentOffset,
    currentPosition,
    context
  };
}
__name(createTokenizer, "createTokenizer");
const ERROR_DOMAIN$2 = "parser", KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(match, codePoint4, codePoint6) {
  switch (match) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const codePoint = parseInt(codePoint4 || codePoint6, 16);
      return codePoint <= 55295 || codePoint >= 57344 ? String.fromCodePoint(codePoint) : "�";
    }
  }
}
__name(fromEscapeSequence, "fromEscapeSequence");
function createParser(options = {}) {
  const location = options.location !== !1, { onError } = options;
  function emitError(tokenzer, code, start, offset, ...args) {
    const end = tokenzer.currentPosition();
    if (end.offset += offset, end.column += offset, onError) {
      const loc = location ? createLocation(start, end) : null, err = createCompileError(code, loc, {
        domain: ERROR_DOMAIN$2,
        args
      });
      onError(err);
    }
  }
  __name(emitError, "emitError");
  function startNode(type, offset, loc) {
    const node = { type };
    return location && (node.start = offset, node.end = offset, node.loc = { start: loc, end: loc }), node;
  }
  __name(startNode, "startNode");
  function endNode(node, offset, pos, type) {
    location && (node.end = offset, node.loc && (node.loc.end = pos));
  }
  __name(endNode, "endNode");
  function parseText(tokenizer, value) {
    const context = tokenizer.context(), node = startNode(3, context.offset, context.startLoc);
    return node.value = value, endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  __name(parseText, "parseText");
  function parseList(tokenizer, index) {
    const context = tokenizer.context(), { lastOffset: offset, lastStartLoc: loc } = context, node = startNode(5, offset, loc);
    return node.index = parseInt(index, 10), tokenizer.nextToken(), endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  __name(parseList, "parseList");
  function parseNamed(tokenizer, key) {
    const context = tokenizer.context(), { lastOffset: offset, lastStartLoc: loc } = context, node = startNode(4, offset, loc);
    return node.key = key, tokenizer.nextToken(), endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  __name(parseNamed, "parseNamed");
  function parseLiteral(tokenizer, value) {
    const context = tokenizer.context(), { lastOffset: offset, lastStartLoc: loc } = context, node = startNode(9, offset, loc);
    return node.value = value.replace(KNOWN_ESCAPES, fromEscapeSequence), tokenizer.nextToken(), endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  __name(parseLiteral, "parseLiteral");
  function parseLinkedModifier(tokenizer) {
    const token = tokenizer.nextToken(), context = tokenizer.context(), { lastOffset: offset, lastStartLoc: loc } = context, node = startNode(8, offset, loc);
    return token.type !== 11 ? (emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0), node.value = "", endNode(node, offset, loc), {
      nextConsumeToken: token,
      node
    }) : (token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), node.value = token.value || "", endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), {
      node
    });
  }
  __name(parseLinkedModifier, "parseLinkedModifier");
  function parseLinkedKey(tokenizer, value) {
    const context = tokenizer.context(), node = startNode(7, context.offset, context.startLoc);
    return node.value = value, endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  __name(parseLinkedKey, "parseLinkedKey");
  function parseLinked(tokenizer) {
    const context = tokenizer.context(), linkedNode = startNode(6, context.offset, context.startLoc);
    let token = tokenizer.nextToken();
    if (token.type === 8) {
      const parsed = parseLinkedModifier(tokenizer);
      linkedNode.modifier = parsed.node, token = parsed.nextConsumeToken || tokenizer.nextToken();
    }
    switch (token.type !== 9 && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), token = tokenizer.nextToken(), token.type === 2 && (token = tokenizer.nextToken()), token.type) {
      case 10:
        token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
        break;
      case 4:
        token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), linkedNode.key = parseNamed(tokenizer, token.value || "");
        break;
      case 5:
        token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), linkedNode.key = parseList(tokenizer, token.value || "");
        break;
      case 6:
        token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), linkedNode.key = parseLiteral(tokenizer, token.value || "");
        break;
      default: {
        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
        const nextContext = tokenizer.context(), emptyLinkedKeyNode = startNode(7, nextContext.offset, nextContext.startLoc);
        return emptyLinkedKeyNode.value = "", endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc), linkedNode.key = emptyLinkedKeyNode, endNode(linkedNode, nextContext.offset, nextContext.startLoc), {
          nextConsumeToken: token,
          node: linkedNode
        };
      }
    }
    return endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition()), {
      node: linkedNode
    };
  }
  __name(parseLinked, "parseLinked");
  function parseMessage(tokenizer) {
    const context = tokenizer.context(), startOffset = context.currentType === 1 ? tokenizer.currentOffset() : context.offset, startLoc = context.currentType === 1 ? context.endLoc : context.startLoc, node = startNode(2, startOffset, startLoc);
    node.items = [];
    let nextToken = null;
    do {
      const token = nextToken || tokenizer.nextToken();
      switch (nextToken = null, token.type) {
        case 0:
          token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), node.items.push(parseText(tokenizer, token.value || ""));
          break;
        case 5:
          token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), node.items.push(parseList(tokenizer, token.value || ""));
          break;
        case 4:
          token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), node.items.push(parseNamed(tokenizer, token.value || ""));
          break;
        case 6:
          token.value == null && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token)), node.items.push(parseLiteral(tokenizer, token.value || ""));
          break;
        case 7: {
          const parsed = parseLinked(tokenizer);
          node.items.push(parsed.node), nextToken = parsed.nextConsumeToken || null;
          break;
        }
      }
    } while (context.currentType !== 13 && context.currentType !== 1);
    const endOffset = context.currentType === 1 ? context.lastOffset : tokenizer.currentOffset(), endLoc = context.currentType === 1 ? context.lastEndLoc : tokenizer.currentPosition();
    return endNode(node, endOffset, endLoc), node;
  }
  __name(parseMessage, "parseMessage");
  function parsePlural(tokenizer, offset, loc, msgNode) {
    const context = tokenizer.context();
    let hasEmptyMessage = msgNode.items.length === 0;
    const node = startNode(1, offset, loc);
    node.cases = [], node.cases.push(msgNode);
    do {
      const msg = parseMessage(tokenizer);
      hasEmptyMessage || (hasEmptyMessage = msg.items.length === 0), node.cases.push(msg);
    } while (context.currentType !== 13);
    return hasEmptyMessage && emitError(tokenizer, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0), endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  __name(parsePlural, "parsePlural");
  function parseResource(tokenizer) {
    const context = tokenizer.context(), { offset, startLoc } = context, msgNode = parseMessage(tokenizer);
    return context.currentType === 13 ? msgNode : parsePlural(tokenizer, offset, startLoc, msgNode);
  }
  __name(parseResource, "parseResource");
  function parse2(source) {
    const tokenizer = createTokenizer(source, assign({}, options)), context = tokenizer.context(), node = startNode(0, context.offset, context.startLoc);
    return location && node.loc && (node.loc.source = source), node.body = parseResource(tokenizer), options.onCacheKey && (node.cacheKey = options.onCacheKey(source)), context.currentType !== 13 && emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || ""), endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition()), node;
  }
  return __name(parse2, "parse"), { parse: parse2 };
}
__name(createParser, "createParser");
function getTokenCaption(token) {
  if (token.type === 13)
    return "EOF";
  const name = (token.value || "").replace(/\r?\n/gu, "\\n");
  return name.length > 10 ? name.slice(0, 9) + "…" : name;
}
__name(getTokenCaption, "getTokenCaption");
function createTransformer(ast, options = {}) {
  const _context = {
    ast,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: /* @__PURE__ */ __name(() => _context, "context"), helper: /* @__PURE__ */ __name((name) => (_context.helpers.add(name), name), "helper") };
}
__name(createTransformer, "createTransformer");
function traverseNodes(nodes, transformer) {
  for (let i = 0; i < nodes.length; i++)
    traverseNode(nodes[i], transformer);
}
__name(traverseNodes, "traverseNodes");
function traverseNode(node, transformer) {
  switch (node.type) {
    case 1:
      traverseNodes(node.cases, transformer), transformer.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      traverseNodes(node.items, transformer);
      break;
    case 6: {
      traverseNode(node.key, transformer), transformer.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), transformer.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      transformer.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), transformer.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      transformer.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), transformer.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
__name(traverseNode, "traverseNode");
function transform(ast, options = {}) {
  const transformer = createTransformer(ast);
  transformer.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), ast.body && traverseNode(ast.body, transformer);
  const context = transformer.context();
  ast.helpers = Array.from(context.helpers);
}
__name(transform, "transform");
function optimize(ast) {
  const body = ast.body;
  return body.type === 2 ? optimizeMessageNode(body) : body.cases.forEach((c) => optimizeMessageNode(c)), ast;
}
__name(optimize, "optimize");
function optimizeMessageNode(message) {
  if (message.items.length === 1) {
    const item = message.items[0];
    (item.type === 3 || item.type === 9) && (message.static = item.value, delete item.value);
  } else {
    const values = [];
    for (let i = 0; i < message.items.length; i++) {
      const item = message.items[i];
      if (!(item.type === 3 || item.type === 9) || item.value == null)
        break;
      values.push(item.value);
    }
    if (values.length === message.items.length) {
      message.static = join(values);
      for (let i = 0; i < message.items.length; i++) {
        const item = message.items[i];
        (item.type === 3 || item.type === 9) && delete item.value;
      }
    }
  }
}
__name(optimizeMessageNode, "optimizeMessageNode");
const ERROR_DOMAIN$1 = "minifier";
function minify(node) {
  switch (node.t = node.type, node.type) {
    case 0: {
      const resource = node;
      minify(resource.body), resource.b = resource.body, delete resource.body;
      break;
    }
    case 1: {
      const plural = node, cases = plural.cases;
      for (let i = 0; i < cases.length; i++)
        minify(cases[i]);
      plural.c = cases, delete plural.cases;
      break;
    }
    case 2: {
      const message = node, items = message.items;
      for (let i = 0; i < items.length; i++)
        minify(items[i]);
      message.i = items, delete message.items, message.static && (message.s = message.static, delete message.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const valueNode = node;
      valueNode.value && (valueNode.v = valueNode.value, delete valueNode.value);
      break;
    }
    case 6: {
      const linked = node;
      minify(linked.key), linked.k = linked.key, delete linked.key, linked.modifier && (minify(linked.modifier), linked.m = linked.modifier, delete linked.modifier);
      break;
    }
    case 5: {
      const list = node;
      list.i = list.index, delete list.index;
      break;
    }
    case 4: {
      const named = node;
      named.k = named.key, delete named.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw createCompileError(CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: ERROR_DOMAIN$1,
          args: [node.type]
        });
  }
  delete node.type;
}
__name(minify, "minify");
const ERROR_DOMAIN = "parser";
function createCodeGenerator(ast, options) {
  const { filename, breakLineCode, needIndent: _needIndent } = options, location = options.location !== !1, _context = {
    filename,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode,
    needIndent: _needIndent,
    indentLevel: 0
  };
  location && ast.loc && (_context.source = ast.loc.source);
  const context = /* @__PURE__ */ __name(() => _context, "context");
  function push(code, node) {
    _context.code += code;
  }
  __name(push, "push");
  function _newline(n, withBreakLine = !0) {
    const _breakLineCode = withBreakLine ? breakLineCode : "";
    push(_needIndent ? _breakLineCode + "  ".repeat(n) : _breakLineCode);
  }
  __name(_newline, "_newline");
  function indent(withNewLine = !0) {
    const level = ++_context.indentLevel;
    withNewLine && _newline(level);
  }
  __name(indent, "indent");
  function deindent(withNewLine = !0) {
    const level = --_context.indentLevel;
    withNewLine && _newline(level);
  }
  __name(deindent, "deindent");
  function newline() {
    _newline(_context.indentLevel);
  }
  return __name(newline, "newline"), {
    context,
    push,
    indent,
    deindent,
    newline,
    helper: /* @__PURE__ */ __name((key) => `_${key}`, "helper"),
    needIndent: /* @__PURE__ */ __name(() => _context.needIndent, "needIndent")
  };
}
__name(createCodeGenerator, "createCodeGenerator");
function generateLinkedNode(generator, node) {
  const { helper } = generator;
  generator.push(`${helper(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), generateNode(generator, node.key), node.modifier ? (generator.push(", "), generateNode(generator, node.modifier), generator.push(", _type")) : generator.push(", undefined, _type"), generator.push(")");
}
__name(generateLinkedNode, "generateLinkedNode");
function generateMessageNode(generator, node) {
  const { helper, needIndent } = generator;
  generator.push(`${helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), generator.indent(needIndent());
  const length = node.items.length;
  for (let i = 0; i < length && (generateNode(generator, node.items[i]), i !== length - 1); i++)
    generator.push(", ");
  generator.deindent(needIndent()), generator.push("])");
}
__name(generateMessageNode, "generateMessageNode");
function generatePluralNode(generator, node) {
  const { helper, needIndent } = generator;
  if (node.cases.length > 1) {
    generator.push(`${helper(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), generator.indent(needIndent());
    const length = node.cases.length;
    for (let i = 0; i < length && (generateNode(generator, node.cases[i]), i !== length - 1); i++)
      generator.push(", ");
    generator.deindent(needIndent()), generator.push("])");
  }
}
__name(generatePluralNode, "generatePluralNode");
function generateResource(generator, node) {
  node.body ? generateNode(generator, node.body) : generator.push("null");
}
__name(generateResource, "generateResource");
function generateNode(generator, node) {
  const { helper } = generator;
  switch (node.type) {
    case 0:
      generateResource(generator, node);
      break;
    case 1:
      generatePluralNode(generator, node);
      break;
    case 2:
      generateMessageNode(generator, node);
      break;
    case 6:
      generateLinkedNode(generator, node);
      break;
    case 8:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 7:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 5:
      generator.push(`${helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${helper(
        "list"
        /* HelperNameMap.LIST */
      )}(${node.index}))`, node);
      break;
    case 4:
      generator.push(`${helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${helper(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(node.key)}))`, node);
      break;
    case 9:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 3:
      generator.push(JSON.stringify(node.value), node);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw createCompileError(CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: ERROR_DOMAIN,
          args: [node.type]
        });
  }
}
__name(generateNode, "generateNode");
const generate = /* @__PURE__ */ __name((ast, options = {}) => {
  const mode = isString(options.mode) ? options.mode : "normal", filename = isString(options.filename) ? options.filename : "message.intl";
  options.sourceMap;
  const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : `
`, needIndent = options.needIndent ? options.needIndent : mode !== "arrow", helpers = ast.helpers || [], generator = createCodeGenerator(ast, {
    filename,
    breakLineCode,
    needIndent
  });
  generator.push(mode === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), generator.indent(needIndent), helpers.length > 0 && (generator.push(`const { ${join(helpers.map((s) => `${s}: _${s}`), ", ")} } = ctx`), generator.newline()), generator.push("return "), generateNode(generator, ast), generator.deindent(needIndent), generator.push("}"), delete ast.helpers;
  const { code, map: map2 } = generator.context();
  return {
    ast,
    code,
    map: map2 ? map2.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
}, "generate");
function baseCompile$1(source, options = {}) {
  const assignedOptions = assign({}, options), jit = !!assignedOptions.jit, enalbeMinify = !!assignedOptions.minify, enambeOptimize = assignedOptions.optimize == null ? !0 : assignedOptions.optimize, ast = createParser(assignedOptions).parse(source);
  return jit ? (enambeOptimize && optimize(ast), enalbeMinify && minify(ast), { ast, code: "" }) : (transform(ast, assignedOptions), generate(ast, assignedOptions));
}
__name(baseCompile$1, "baseCompile$1");
/*!
  * core-base v11.1.10
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function initFeatureFlags$1() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
__name(initFeatureFlags$1, "initFeatureFlags$1");
function isMessageAST(val) {
  return isObject(val) && resolveType(val) === 0 && (hasOwn(val, "b") || hasOwn(val, "body"));
}
__name(isMessageAST, "isMessageAST");
const PROPS_BODY = ["b", "body"];
function resolveBody(node) {
  return resolveProps(node, PROPS_BODY);
}
__name(resolveBody, "resolveBody");
const PROPS_CASES = ["c", "cases"];
function resolveCases(node) {
  return resolveProps(node, PROPS_CASES, []);
}
__name(resolveCases, "resolveCases");
const PROPS_STATIC = ["s", "static"];
function resolveStatic(node) {
  return resolveProps(node, PROPS_STATIC);
}
__name(resolveStatic, "resolveStatic");
const PROPS_ITEMS = ["i", "items"];
function resolveItems(node) {
  return resolveProps(node, PROPS_ITEMS, []);
}
__name(resolveItems, "resolveItems");
const PROPS_TYPE = ["t", "type"];
function resolveType(node) {
  return resolveProps(node, PROPS_TYPE);
}
__name(resolveType, "resolveType");
const PROPS_VALUE = ["v", "value"];
function resolveValue$1(node, type) {
  const resolved = resolveProps(node, PROPS_VALUE);
  if (resolved != null)
    return resolved;
  throw createUnhandleNodeError(type);
}
__name(resolveValue$1, "resolveValue$1");
const PROPS_MODIFIER = ["m", "modifier"];
function resolveLinkedModifier(node) {
  return resolveProps(node, PROPS_MODIFIER);
}
__name(resolveLinkedModifier, "resolveLinkedModifier");
const PROPS_KEY = ["k", "key"];
function resolveLinkedKey(node) {
  const resolved = resolveProps(node, PROPS_KEY);
  if (resolved)
    return resolved;
  throw createUnhandleNodeError(
    6
    /* NodeTypes.Linked */
  );
}
__name(resolveLinkedKey, "resolveLinkedKey");
function resolveProps(node, props, defaultValue) {
  for (let i = 0; i < props.length; i++) {
    const prop = props[i];
    if (hasOwn(node, prop) && node[prop] != null)
      return node[prop];
  }
  return defaultValue;
}
__name(resolveProps, "resolveProps");
const AST_NODE_PROPS_KEYS = [
  ...PROPS_BODY,
  ...PROPS_CASES,
  ...PROPS_STATIC,
  ...PROPS_ITEMS,
  ...PROPS_KEY,
  ...PROPS_MODIFIER,
  ...PROPS_VALUE,
  ...PROPS_TYPE
];
function createUnhandleNodeError(type) {
  return new Error(`unhandled node type: ${type}`);
}
__name(createUnhandleNodeError, "createUnhandleNodeError");
function format(ast) {
  return /* @__PURE__ */ __name((ctx) => formatParts(ctx, ast), "msg");
}
__name(format, "format");
function formatParts(ctx, ast) {
  const body = resolveBody(ast);
  if (body == null)
    throw createUnhandleNodeError(
      0
      /* NodeTypes.Resource */
    );
  if (resolveType(body) === 1) {
    const cases = resolveCases(body);
    return ctx.plural(cases.reduce((messages, c) => [
      ...messages,
      formatMessageParts(ctx, c)
    ], []));
  } else
    return formatMessageParts(ctx, body);
}
__name(formatParts, "formatParts");
function formatMessageParts(ctx, node) {
  const static_ = resolveStatic(node);
  if (static_ != null)
    return ctx.type === "text" ? static_ : ctx.normalize([static_]);
  {
    const messages = resolveItems(node).reduce((acm, c) => [...acm, formatMessagePart(ctx, c)], []);
    return ctx.normalize(messages);
  }
}
__name(formatMessageParts, "formatMessageParts");
function formatMessagePart(ctx, node) {
  const type = resolveType(node);
  switch (type) {
    case 3:
      return resolveValue$1(node, type);
    case 9:
      return resolveValue$1(node, type);
    case 4: {
      const named = node;
      if (hasOwn(named, "k") && named.k)
        return ctx.interpolate(ctx.named(named.k));
      if (hasOwn(named, "key") && named.key)
        return ctx.interpolate(ctx.named(named.key));
      throw createUnhandleNodeError(type);
    }
    case 5: {
      const list = node;
      if (hasOwn(list, "i") && isNumber(list.i))
        return ctx.interpolate(ctx.list(list.i));
      if (hasOwn(list, "index") && isNumber(list.index))
        return ctx.interpolate(ctx.list(list.index));
      throw createUnhandleNodeError(type);
    }
    case 6: {
      const linked = node, modifier = resolveLinkedModifier(linked), key = resolveLinkedKey(linked);
      return ctx.linked(formatMessagePart(ctx, key), modifier ? formatMessagePart(ctx, modifier) : void 0, ctx.type);
    }
    case 7:
      return resolveValue$1(node, type);
    case 8:
      return resolveValue$1(node, type);
    default:
      throw new Error(`unhandled node on format message part: ${type}`);
  }
}
__name(formatMessagePart, "formatMessagePart");
const WARN_MESSAGE = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function checkHtmlMessage(source, warnHtmlMessage) {
  warnHtmlMessage && detectHtmlTag(source) && warn(format$1(WARN_MESSAGE, { source }));
}
__name(checkHtmlMessage, "checkHtmlMessage");
const defaultOnCacheKey = /* @__PURE__ */ __name((message) => message, "defaultOnCacheKey");
let compileCache = create();
function baseCompile(message, options = {}) {
  let detectError = !1;
  const onError = options.onError || defaultOnError;
  return options.onError = (err) => {
    detectError = !0, onError(err);
  }, { ...baseCompile$1(message, options), detectError };
}
__name(baseCompile, "baseCompile");
// @__NO_SIDE_EFFECTS__
function compile(message, context) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && isString(message)) {
    const warnHtmlMessage = isBoolean(context.warnHtmlMessage) ? context.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && checkHtmlMessage(message, warnHtmlMessage);
    const cacheKey = (context.onCacheKey || defaultOnCacheKey)(message), cached = compileCache[cacheKey];
    if (cached)
      return cached;
    const { ast, detectError } = baseCompile(message, {
      ...context,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), msg = format(ast);
    return detectError ? msg : compileCache[cacheKey] = msg;
  } else {
    if (process.env.NODE_ENV !== "production" && !isMessageAST(message))
      return warn(`the message that is resolve with key '${context.key}' is not supported for jit compilation`), () => message;
    const cacheKey = message.cacheKey;
    if (cacheKey) {
      const cached = compileCache[cacheKey];
      return cached || (compileCache[cacheKey] = format(message));
    } else
      return format(message);
  }
}
__name(compile, "compile");
let devtools = null;
function setDevToolsHook(hook) {
  devtools = hook;
}
__name(setDevToolsHook, "setDevToolsHook");
function initI18nDevTools(i18n, version, meta) {
  devtools && devtools.emit("i18n:init", {
    timestamp: Date.now(),
    i18n,
    version,
    meta
  });
}
__name(initI18nDevTools, "initI18nDevTools");
const translateDevTools = /* @__PURE__ */ createDevToolsHook("function:translate");
function createDevToolsHook(hook) {
  return (payloads) => devtools && devtools.emit(hook, payloads);
}
__name(createDevToolsHook, "createDevToolsHook");
const CoreErrorCodes = {
  INVALID_ARGUMENT: COMPILE_ERROR_CODES_EXTEND_POINT,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, CORE_ERROR_CODES_EXTEND_POINT = 24;
function createCoreError(code) {
  return createCompileError(code, null, process.env.NODE_ENV !== "production" ? { messages: errorMessages$1 } : void 0);
}
__name(createCoreError, "createCoreError");
const errorMessages$1 = {
  [CoreErrorCodes.INVALID_ARGUMENT]: "Invalid arguments",
  [CoreErrorCodes.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function getLocale(context, options) {
  return options.locale != null ? resolveLocale(options.locale) : resolveLocale(context.locale);
}
__name(getLocale, "getLocale");
let _resolveLocale;
function resolveLocale(locale) {
  if (isString(locale))
    return locale;
  if (isFunction(locale)) {
    if (locale.resolvedOnce && _resolveLocale != null)
      return _resolveLocale;
    if (locale.constructor.name === "Function") {
      const resolve = locale();
      if (isPromise(resolve))
        throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return _resolveLocale = resolve;
    } else
      throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);
}
__name(resolveLocale, "resolveLocale");
function fallbackWithSimple(ctx, fallback, start) {
  return [.../* @__PURE__ */ new Set([
    start,
    ...isArray(fallback) ? fallback : isObject(fallback) ? Object.keys(fallback) : isString(fallback) ? [fallback] : [start]
  ])];
}
__name(fallbackWithSimple, "fallbackWithSimple");
function fallbackWithLocaleChain(ctx, fallback, start) {
  const startLocale = isString(start) ? start : DEFAULT_LOCALE, context = ctx;
  context.__localeChainCache || (context.__localeChainCache = /* @__PURE__ */ new Map());
  let chain = context.__localeChainCache.get(startLocale);
  if (!chain) {
    chain = [];
    let block = [start];
    for (; isArray(block); )
      block = appendBlockToChain(chain, block, fallback);
    const defaults = isArray(fallback) || !isPlainObject(fallback) ? fallback : fallback.default ? fallback.default : null;
    block = isString(defaults) ? [defaults] : defaults, isArray(block) && appendBlockToChain(chain, block, !1), context.__localeChainCache.set(startLocale, chain);
  }
  return chain;
}
__name(fallbackWithLocaleChain, "fallbackWithLocaleChain");
function appendBlockToChain(chain, block, blocks) {
  let follow = !0;
  for (let i = 0; i < block.length && isBoolean(follow); i++) {
    const locale = block[i];
    isString(locale) && (follow = appendLocaleToChain(chain, block[i], blocks));
  }
  return follow;
}
__name(appendBlockToChain, "appendBlockToChain");
function appendLocaleToChain(chain, locale, blocks) {
  let follow;
  const tokens = locale.split("-");
  do {
    const target = tokens.join("-");
    follow = appendItemToChain(chain, target, blocks), tokens.splice(-1, 1);
  } while (tokens.length && follow === !0);
  return follow;
}
__name(appendLocaleToChain, "appendLocaleToChain");
function appendItemToChain(chain, target, blocks) {
  let follow = !1;
  if (!chain.includes(target) && (follow = !0, target)) {
    follow = target[target.length - 1] !== "!";
    const locale = target.replace(/!/g, "");
    chain.push(locale), (isArray(blocks) || isPlainObject(blocks)) && blocks[locale] && (follow = blocks[locale]);
  }
  return follow;
}
__name(appendItemToChain, "appendItemToChain");
const pathStateMachine = [];
pathStateMachine[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pathStateMachine[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pathStateMachine[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
pathStateMachine[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
  return literalValueRE.test(exp);
}
__name(isLiteral, "isLiteral");
function stripQuotes(str) {
  const a = str.charCodeAt(0), b = str.charCodeAt(str.length - 1);
  return a === b && (a === 34 || a === 39) ? str.slice(1, -1) : str;
}
__name(stripQuotes, "stripQuotes");
function getPathCharType(ch) {
  if (ch == null)
    return "o";
  switch (ch.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return ch;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
__name(getPathCharType, "getPathCharType");
function formatSubPath(path) {
  const trimmed = path.trim();
  return path.charAt(0) === "0" && isNaN(parseInt(path)) ? !1 : isLiteral(trimmed) ? stripQuotes(trimmed) : "*" + trimmed;
}
__name(formatSubPath, "formatSubPath");
function parse(path) {
  const keys = [];
  let index = -1, mode = 0, subPathDepth = 0, c, key, newChar, type, transition, action, typeMap;
  const actions = [];
  actions[
    0
    /* Actions.APPEND */
  ] = () => {
    key === void 0 ? key = newChar : key += newChar;
  }, actions[
    1
    /* Actions.PUSH */
  ] = () => {
    key !== void 0 && (keys.push(key), key = void 0);
  }, actions[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    actions[
      0
      /* Actions.APPEND */
    ](), subPathDepth++;
  }, actions[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (subPathDepth > 0)
      subPathDepth--, mode = 4, actions[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (subPathDepth = 0, key === void 0 || (key = formatSubPath(key), key === !1))
        return !1;
      actions[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function maybeUnescapeQuote() {
    const nextChar = path[index + 1];
    if (mode === 5 && nextChar === "'" || mode === 6 && nextChar === '"')
      return index++, newChar = "\\" + nextChar, actions[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (__name(maybeUnescapeQuote, "maybeUnescapeQuote"); mode !== null; )
    if (index++, c = path[index], !(c === "\\" && maybeUnescapeQuote())) {
      if (type = getPathCharType(c), typeMap = pathStateMachine[mode], transition = typeMap[type] || typeMap.l || 8, transition === 8 || (mode = transition[0], transition[1] !== void 0 && (action = actions[transition[1]], action && (newChar = c, action() === !1))))
        return;
      if (mode === 7)
        return keys;
    }
}
__name(parse, "parse");
const cache = /* @__PURE__ */ new Map();
function resolveWithKeyValue(obj, path) {
  return isObject(obj) ? obj[path] : null;
}
__name(resolveWithKeyValue, "resolveWithKeyValue");
function resolveValue(obj, path) {
  if (!isObject(obj))
    return null;
  let hit = cache.get(path);
  if (hit || (hit = parse(path), hit && cache.set(path, hit)), !hit)
    return null;
  const len = hit.length;
  let last = obj, i = 0;
  for (; i < len; ) {
    const key = hit[i];
    if (AST_NODE_PROPS_KEYS.includes(key) && isMessageAST(last))
      return null;
    const val = last[key];
    if (val === void 0 || isFunction(last))
      return null;
    last = val, i++;
  }
  return last;
}
__name(resolveValue, "resolveValue");
const CoreWarnCodes = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, CORE_WARN_CODES_EXTEND_POINT = 8, warnMessages$1 = {
  [CoreWarnCodes.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [CoreWarnCodes.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [CoreWarnCodes.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [CoreWarnCodes.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [CoreWarnCodes.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function getWarnMessage$1(code, ...args) {
  return format$1(warnMessages$1[code], ...args);
}
__name(getWarnMessage$1, "getWarnMessage$1");
const VERSION$1 = "11.1.10", NOT_REOSLVED = -1, DEFAULT_LOCALE = "en-US", MISSING_RESOLVE_VALUE = "", capitalize = /* @__PURE__ */ __name((str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`, "capitalize");
function getDefaultLinkedModifiers() {
  return {
    upper: /* @__PURE__ */ __name((val, type) => type === "text" && isString(val) ? val.toUpperCase() : type === "vnode" && isObject(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val, "upper"),
    lower: /* @__PURE__ */ __name((val, type) => type === "text" && isString(val) ? val.toLowerCase() : type === "vnode" && isObject(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val, "lower"),
    capitalize: /* @__PURE__ */ __name((val, type) => type === "text" && isString(val) ? capitalize(val) : type === "vnode" && isObject(val) && "__v_isVNode" in val ? capitalize(val.children) : val, "capitalize")
  };
}
__name(getDefaultLinkedModifiers, "getDefaultLinkedModifiers");
let _compiler;
function registerMessageCompiler(compiler) {
  _compiler = compiler;
}
__name(registerMessageCompiler, "registerMessageCompiler");
let _resolver;
function registerMessageResolver(resolver) {
  _resolver = resolver;
}
__name(registerMessageResolver, "registerMessageResolver");
let _fallbacker;
function registerLocaleFallbacker(fallbacker) {
  _fallbacker = fallbacker;
}
__name(registerLocaleFallbacker, "registerLocaleFallbacker");
let _additionalMeta = null;
const setAdditionalMeta = /* @__PURE__ */ __name(/* @__NO_SIDE_EFFECTS__ */ (meta) => {
  _additionalMeta = meta;
}, "setAdditionalMeta"), getAdditionalMeta = /* @__PURE__ */ __name(/* @__NO_SIDE_EFFECTS__ */ () => _additionalMeta, "getAdditionalMeta");
let _fallbackContext = null;
const setFallbackContext = /* @__PURE__ */ __name((context) => {
  _fallbackContext = context;
}, "setFallbackContext"), getFallbackContext = /* @__PURE__ */ __name(() => _fallbackContext, "getFallbackContext");
let _cid = 0;
function createCoreContext(options = {}) {
  const onWarn = isFunction(options.onWarn) ? options.onWarn : warn, version = isString(options.version) ? options.version : VERSION$1, locale = isString(options.locale) || isFunction(options.locale) ? options.locale : DEFAULT_LOCALE, _locale = isFunction(locale) ? DEFAULT_LOCALE : locale, fallbackLocale = isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || isString(options.fallbackLocale) || options.fallbackLocale === !1 ? options.fallbackLocale : _locale, messages = isPlainObject(options.messages) ? options.messages : createResources(_locale), datetimeFormats = isPlainObject(options.datetimeFormats) ? options.datetimeFormats : createResources(_locale), numberFormats = isPlainObject(options.numberFormats) ? options.numberFormats : createResources(_locale), modifiers = assign(create(), options.modifiers, getDefaultLinkedModifiers()), pluralRules = options.pluralRules || create(), missing = isFunction(options.missing) ? options.missing : null, missingWarn = isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : !0, fallbackWarn = isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : !0, fallbackFormat = !!options.fallbackFormat, unresolving = !!options.unresolving, postTranslation = isFunction(options.postTranslation) ? options.postTranslation : null, processor = isPlainObject(options.processor) ? options.processor : null, warnHtmlMessage = isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : !0, escapeParameter = !!options.escapeParameter, messageCompiler = isFunction(options.messageCompiler) ? options.messageCompiler : _compiler;
  process.env.NODE_ENV !== "production" && isFunction(options.messageCompiler) && warnOnce(getWarnMessage$1(CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const messageResolver = isFunction(options.messageResolver) ? options.messageResolver : _resolver || resolveWithKeyValue, localeFallbacker = isFunction(options.localeFallbacker) ? options.localeFallbacker : _fallbacker || fallbackWithSimple, fallbackContext = isObject(options.fallbackContext) ? options.fallbackContext : void 0, internalOptions = options, __datetimeFormatters = isObject(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : /* @__PURE__ */ new Map(), __numberFormatters = isObject(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : /* @__PURE__ */ new Map(), __meta = isObject(internalOptions.__meta) ? internalOptions.__meta : {};
  _cid++;
  const context = {
    version,
    cid: _cid,
    locale,
    fallbackLocale,
    messages,
    modifiers,
    pluralRules,
    missing,
    missingWarn,
    fallbackWarn,
    fallbackFormat,
    unresolving,
    postTranslation,
    processor,
    warnHtmlMessage,
    escapeParameter,
    messageCompiler,
    messageResolver,
    localeFallbacker,
    fallbackContext,
    onWarn,
    __meta
  };
  return context.datetimeFormats = datetimeFormats, context.numberFormats = numberFormats, context.__datetimeFormatters = __datetimeFormatters, context.__numberFormatters = __numberFormatters, process.env.NODE_ENV !== "production" && (context.__v_emitter = internalOptions.__v_emitter != null ? internalOptions.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && initI18nDevTools(context, version, __meta), context;
}
__name(createCoreContext, "createCoreContext");
const createResources = /* @__PURE__ */ __name((locale) => ({ [locale]: create() }), "createResources");
function isTranslateFallbackWarn(fallback, key) {
  return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
__name(isTranslateFallbackWarn, "isTranslateFallbackWarn");
function isTranslateMissingWarn(missing, key) {
  return missing instanceof RegExp ? missing.test(key) : missing;
}
__name(isTranslateMissingWarn, "isTranslateMissingWarn");
function handleMissing(context, key, locale, missingWarn, type) {
  const { missing, onWarn } = context;
  if (process.env.NODE_ENV !== "production") {
    const emitter = context.__v_emitter;
    emitter && emitter.emit("missing", {
      locale,
      key,
      type,
      groupId: `${type}:${key}`
    });
  }
  if (missing !== null) {
    const ret = missing(context, locale, key, type);
    return isString(ret) ? ret : key;
  } else
    return process.env.NODE_ENV !== "production" && isTranslateMissingWarn(missingWarn, key) && onWarn(getWarnMessage$1(CoreWarnCodes.NOT_FOUND_KEY, { key, locale })), key;
}
__name(handleMissing, "handleMissing");
function updateFallbackLocale(ctx, locale, fallback) {
  const context = ctx;
  context.__localeChainCache = /* @__PURE__ */ new Map(), ctx.localeFallbacker(ctx, fallback, locale);
}
__name(updateFallbackLocale, "updateFallbackLocale");
function isAlmostSameLocale(locale, compareLocale) {
  return locale === compareLocale ? !1 : locale.split("-")[0] === compareLocale.split("-")[0];
}
__name(isAlmostSameLocale, "isAlmostSameLocale");
function isImplicitFallback(targetLocale, locales) {
  const index = locales.indexOf(targetLocale);
  if (index === -1)
    return !1;
  for (let i = index + 1; i < locales.length; i++)
    if (isAlmostSameLocale(targetLocale, locales[i]))
      return !0;
  return !1;
}
__name(isImplicitFallback, "isImplicitFallback");
const intlDefined = typeof Intl < "u", Availabilities = {
  dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat < "u",
  numberFormat: intlDefined && typeof Intl.NumberFormat < "u"
};
function datetime(context, ...args) {
  const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context, { __datetimeFormatters } = context;
  if (process.env.NODE_ENV !== "production" && !Availabilities.dateTimeFormat)
    return onWarn(getWarnMessage$1(CoreWarnCodes.CANNOT_FORMAT_DATE)), MISSING_RESOLVE_VALUE;
  const [key, value, options, overrides] = parseDateTimeArgs(...args), missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn, fallbackWarn = isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn, part = !!options.part, locale = getLocale(context, options), locales = localeFallbacker(
    context,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale,
    locale
  );
  if (!isString(key) || key === "")
    return new Intl.DateTimeFormat(locale, overrides).format(value);
  let datetimeFormat = {}, targetLocale, format2 = null, from = locale, to = null;
  const type = "datetime format";
  for (let i = 0; i < locales.length; i++) {
    if (targetLocale = to = locales[i], process.env.NODE_ENV !== "production" && locale !== targetLocale && isTranslateFallbackWarn(fallbackWarn, key) && onWarn(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_DATE_FORMAT, {
      key,
      target: targetLocale
    })), process.env.NODE_ENV !== "production" && locale !== targetLocale) {
      const emitter = context.__v_emitter;
      emitter && emitter.emit("fallback", {
        type,
        key,
        from,
        to,
        groupId: `${type}:${key}`
      });
    }
    if (datetimeFormat = datetimeFormats[targetLocale] || {}, format2 = datetimeFormat[key], isPlainObject(format2))
      break;
    handleMissing(context, key, targetLocale, missingWarn, type), from = to;
  }
  if (!isPlainObject(format2) || !isString(targetLocale))
    return unresolving ? NOT_REOSLVED : key;
  let id = `${targetLocale}__${key}`;
  isEmptyObject(overrides) || (id = `${id}__${JSON.stringify(overrides)}`);
  let formatter = __datetimeFormatters.get(id);
  return formatter || (formatter = new Intl.DateTimeFormat(targetLocale, assign({}, format2, overrides)), __datetimeFormatters.set(id, formatter)), part ? formatter.formatToParts(value) : formatter.format(value);
}
__name(datetime, "datetime");
const DATETIME_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function parseDateTimeArgs(...args) {
  const [arg1, arg2, arg3, arg4] = args, options = create();
  let overrides = create(), value;
  if (isString(arg1)) {
    const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!matches)
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
    value = new Date(dateTime);
    try {
      value.toISOString();
    } catch {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (isDate(arg1)) {
    if (isNaN(arg1.getTime()))
      throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
    value = arg1;
  } else if (isNumber(arg1))
    value = arg1;
  else
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  return isString(arg2) ? options.key = arg2 : isPlainObject(arg2) && Object.keys(arg2).forEach((key) => {
    DATETIME_FORMAT_OPTIONS_KEYS.includes(key) ? overrides[key] = arg2[key] : options[key] = arg2[key];
  }), isString(arg3) ? options.locale = arg3 : isPlainObject(arg3) && (overrides = arg3), isPlainObject(arg4) && (overrides = arg4), [options.key || "", value, options, overrides];
}
__name(parseDateTimeArgs, "parseDateTimeArgs");
function clearDateTimeFormat(ctx, locale, format2) {
  const context = ctx;
  for (const key in format2) {
    const id = `${locale}__${key}`;
    context.__datetimeFormatters.has(id) && context.__datetimeFormatters.delete(id);
  }
}
__name(clearDateTimeFormat, "clearDateTimeFormat");
function number(context, ...args) {
  const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context, { __numberFormatters } = context;
  if (process.env.NODE_ENV !== "production" && !Availabilities.numberFormat)
    return onWarn(getWarnMessage$1(CoreWarnCodes.CANNOT_FORMAT_NUMBER)), MISSING_RESOLVE_VALUE;
  const [key, value, options, overrides] = parseNumberArgs(...args), missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn, fallbackWarn = isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn, part = !!options.part, locale = getLocale(context, options), locales = localeFallbacker(
    context,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale,
    locale
  );
  if (!isString(key) || key === "")
    return new Intl.NumberFormat(locale, overrides).format(value);
  let numberFormat = {}, targetLocale, format2 = null, from = locale, to = null;
  const type = "number format";
  for (let i = 0; i < locales.length; i++) {
    if (targetLocale = to = locales[i], process.env.NODE_ENV !== "production" && locale !== targetLocale && isTranslateFallbackWarn(fallbackWarn, key) && onWarn(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT, {
      key,
      target: targetLocale
    })), process.env.NODE_ENV !== "production" && locale !== targetLocale) {
      const emitter = context.__v_emitter;
      emitter && emitter.emit("fallback", {
        type,
        key,
        from,
        to,
        groupId: `${type}:${key}`
      });
    }
    if (numberFormat = numberFormats[targetLocale] || {}, format2 = numberFormat[key], isPlainObject(format2))
      break;
    handleMissing(context, key, targetLocale, missingWarn, type), from = to;
  }
  if (!isPlainObject(format2) || !isString(targetLocale))
    return unresolving ? NOT_REOSLVED : key;
  let id = `${targetLocale}__${key}`;
  isEmptyObject(overrides) || (id = `${id}__${JSON.stringify(overrides)}`);
  let formatter = __numberFormatters.get(id);
  return formatter || (formatter = new Intl.NumberFormat(targetLocale, assign({}, format2, overrides)), __numberFormatters.set(id, formatter)), part ? formatter.formatToParts(value) : formatter.format(value);
}
__name(number, "number");
const NUMBER_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function parseNumberArgs(...args) {
  const [arg1, arg2, arg3, arg4] = args, options = create();
  let overrides = create();
  if (!isNumber(arg1))
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  const value = arg1;
  return isString(arg2) ? options.key = arg2 : isPlainObject(arg2) && Object.keys(arg2).forEach((key) => {
    NUMBER_FORMAT_OPTIONS_KEYS.includes(key) ? overrides[key] = arg2[key] : options[key] = arg2[key];
  }), isString(arg3) ? options.locale = arg3 : isPlainObject(arg3) && (overrides = arg3), isPlainObject(arg4) && (overrides = arg4), [options.key || "", value, options, overrides];
}
__name(parseNumberArgs, "parseNumberArgs");
function clearNumberFormat(ctx, locale, format2) {
  const context = ctx;
  for (const key in format2) {
    const id = `${locale}__${key}`;
    context.__numberFormatters.has(id) && context.__numberFormatters.delete(id);
  }
}
__name(clearNumberFormat, "clearNumberFormat");
const DEFAULT_MODIFIER = /* @__PURE__ */ __name((str) => str, "DEFAULT_MODIFIER"), DEFAULT_MESSAGE = /* @__PURE__ */ __name((ctx) => "", "DEFAULT_MESSAGE"), DEFAULT_MESSAGE_DATA_TYPE = "text", DEFAULT_NORMALIZE = /* @__PURE__ */ __name((values) => values.length === 0 ? "" : join(values), "DEFAULT_NORMALIZE"), DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(choice, choicesLength) {
  return choice = Math.abs(choice), choicesLength === 2 ? choice ? choice > 1 ? 1 : 0 : 1 : choice ? Math.min(choice, 2) : 0;
}
__name(pluralDefault, "pluralDefault");
function getPluralIndex(options) {
  const index = isNumber(options.pluralIndex) ? options.pluralIndex : -1;
  return options.named && (isNumber(options.named.count) || isNumber(options.named.n)) ? isNumber(options.named.count) ? options.named.count : isNumber(options.named.n) ? options.named.n : index : index;
}
__name(getPluralIndex, "getPluralIndex");
function normalizeNamed(pluralIndex, props) {
  props.count || (props.count = pluralIndex), props.n || (props.n = pluralIndex);
}
__name(normalizeNamed, "normalizeNamed");
function createMessageContext(options = {}) {
  const locale = options.locale, pluralIndex = getPluralIndex(options), pluralRule = isObject(options.pluralRules) && isString(locale) && isFunction(options.pluralRules[locale]) ? options.pluralRules[locale] : pluralDefault, orgPluralRule = isObject(options.pluralRules) && isString(locale) && isFunction(options.pluralRules[locale]) ? pluralDefault : void 0, plural = /* @__PURE__ */ __name((messages) => messages[pluralRule(pluralIndex, messages.length, orgPluralRule)], "plural"), _list = options.list || [], list = /* @__PURE__ */ __name((index) => _list[index], "list"), _named = options.named || create();
  isNumber(options.pluralIndex) && normalizeNamed(pluralIndex, _named);
  const named = /* @__PURE__ */ __name((key) => _named[key], "named");
  function message(key, useLinked) {
    const msg = isFunction(options.messages) ? options.messages(key, !!useLinked) : isObject(options.messages) ? options.messages[key] : !1;
    return msg || (options.parent ? options.parent.message(key) : DEFAULT_MESSAGE);
  }
  __name(message, "message");
  const _modifier = /* @__PURE__ */ __name((name) => options.modifiers ? options.modifiers[name] : DEFAULT_MODIFIER, "_modifier"), normalize = isPlainObject(options.processor) && isFunction(options.processor.normalize) ? options.processor.normalize : DEFAULT_NORMALIZE, interpolate = isPlainObject(options.processor) && isFunction(options.processor.interpolate) ? options.processor.interpolate : DEFAULT_INTERPOLATE, type = isPlainObject(options.processor) && isString(options.processor.type) ? options.processor.type : DEFAULT_MESSAGE_DATA_TYPE, ctx = {
    list,
    named,
    plural,
    linked: /* @__PURE__ */ __name((key, ...args) => {
      const [arg1, arg2] = args;
      let type2 = "text", modifier = "";
      args.length === 1 ? isObject(arg1) ? (modifier = arg1.modifier || modifier, type2 = arg1.type || type2) : isString(arg1) && (modifier = arg1 || modifier) : args.length === 2 && (isString(arg1) && (modifier = arg1 || modifier), isString(arg2) && (type2 = arg2 || type2));
      const ret = message(key, !0)(ctx), msg = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type2 === "vnode" && isArray(ret) && modifier ? ret[0] : ret
      );
      return modifier ? _modifier(modifier)(msg, type2) : msg;
    }, "linked"),
    message,
    type,
    interpolate,
    normalize,
    values: assign(create(), _list, _named)
  };
  return ctx;
}
__name(createMessageContext, "createMessageContext");
const NOOP_MESSAGE_FUNCTION = /* @__PURE__ */ __name(() => "", "NOOP_MESSAGE_FUNCTION"), isMessageFunction = /* @__PURE__ */ __name((val) => isFunction(val), "isMessageFunction");
function translate(context, ...args) {
  const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context, [key, options] = parseTranslateArgs(...args), missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn, fallbackWarn = isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn, escapeParameter = isBoolean(options.escapeParameter) ? options.escapeParameter : context.escapeParameter, resolvedMessage = !!options.resolvedMessage, defaultMsgOrKey = isString(options.default) || isBoolean(options.default) ? isBoolean(options.default) ? messageCompiler ? key : () => key : options.default : fallbackFormat ? messageCompiler ? key : () => key : null, enableDefaultMsg = fallbackFormat || defaultMsgOrKey != null && (isString(defaultMsgOrKey) || isFunction(defaultMsgOrKey)), locale = getLocale(context, options);
  escapeParameter && escapeParams(options);
  let [formatScope, targetLocale, message] = resolvedMessage ? [
    key,
    locale,
    messages[locale] || create()
  ] : resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn), format2 = formatScope, cacheBaseKey = key;
  if (!resolvedMessage && !(isString(format2) || isMessageAST(format2) || isMessageFunction(format2)) && enableDefaultMsg && (format2 = defaultMsgOrKey, cacheBaseKey = format2), !resolvedMessage && (!(isString(format2) || isMessageAST(format2) || isMessageFunction(format2)) || !isString(targetLocale)))
    return unresolving ? NOT_REOSLVED : key;
  if (process.env.NODE_ENV !== "production" && isString(format2) && context.messageCompiler == null)
    return warn(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${key}'.`), key;
  let occurred = !1;
  const onError = /* @__PURE__ */ __name(() => {
    occurred = !0;
  }, "onError"), msg = isMessageFunction(format2) ? format2 : compileMessageFormat(context, key, targetLocale, format2, cacheBaseKey, onError);
  if (occurred)
    return format2;
  const ctxOptions = getMessageContextOptions(context, targetLocale, message, options), msgContext = createMessageContext(ctxOptions), messaged = evaluateMessage(context, msg, msgContext);
  let ret = postTranslation ? postTranslation(messaged, key) : messaged;
  if (escapeParameter && isString(ret) && (ret = sanitizeTranslatedHtml(ret)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const payloads = {
      timestamp: Date.now(),
      key: isString(key) ? key : isMessageFunction(format2) ? format2.key : "",
      locale: targetLocale || (isMessageFunction(format2) ? format2.locale : ""),
      format: isString(format2) ? format2 : isMessageFunction(format2) ? format2.source : "",
      message: ret
    };
    payloads.meta = assign({}, context.__meta, /* @__PURE__ */ getAdditionalMeta() || {}), translateDevTools(payloads);
  }
  return ret;
}
__name(translate, "translate");
function escapeParams(options) {
  isArray(options.list) ? options.list = options.list.map((item) => isString(item) ? escapeHtml(item) : item) : isObject(options.named) && Object.keys(options.named).forEach((key) => {
    isString(options.named[key]) && (options.named[key] = escapeHtml(options.named[key]));
  });
}
__name(escapeParams, "escapeParams");
function resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
  const { messages, onWarn, messageResolver: resolveValue2, localeFallbacker } = context, locales = localeFallbacker(context, fallbackLocale, locale);
  let message = create(), targetLocale, format2 = null, from = locale, to = null;
  const type = "translate";
  for (let i = 0; i < locales.length; i++) {
    if (targetLocale = to = locales[i], process.env.NODE_ENV !== "production" && locale !== targetLocale && !isAlmostSameLocale(locale, targetLocale) && isTranslateFallbackWarn(fallbackWarn, key) && onWarn(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_TRANSLATE, {
      key,
      target: targetLocale
    })), process.env.NODE_ENV !== "production" && locale !== targetLocale) {
      const emitter = context.__v_emitter;
      emitter && emitter.emit("fallback", {
        type,
        key,
        from,
        to,
        groupId: `${type}:${key}`
      });
    }
    message = messages[targetLocale] || create();
    let start = null, startTag, endTag;
    if (process.env.NODE_ENV !== "production" && inBrowser && (start = window.performance.now(), startTag = "intlify-message-resolve-start", endTag = "intlify-message-resolve-end", mark && mark(startTag)), (format2 = resolveValue2(message, key)) === null && (format2 = message[key]), process.env.NODE_ENV !== "production" && inBrowser) {
      const end = window.performance.now(), emitter = context.__v_emitter;
      emitter && start && format2 && emitter.emit("message-resolve", {
        type: "message-resolve",
        key,
        message: format2,
        time: end - start,
        groupId: `${type}:${key}`
      }), startTag && endTag && mark && measure && (mark(endTag), measure("intlify message resolve", startTag, endTag));
    }
    if (isString(format2) || isMessageAST(format2) || isMessageFunction(format2))
      break;
    if (!isImplicitFallback(targetLocale, locales)) {
      const missingRet = handleMissing(
        context,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        key,
        targetLocale,
        missingWarn,
        type
      );
      missingRet !== key && (format2 = missingRet);
    }
    from = to;
  }
  return [format2, targetLocale, message];
}
__name(resolveMessageFormat, "resolveMessageFormat");
function compileMessageFormat(context, key, targetLocale, format2, cacheBaseKey, onError) {
  const { messageCompiler, warnHtmlMessage } = context;
  if (isMessageFunction(format2)) {
    const msg2 = format2;
    return msg2.locale = msg2.locale || targetLocale, msg2.key = msg2.key || key, msg2;
  }
  if (messageCompiler == null) {
    const msg2 = /* @__PURE__ */ __name(() => format2, "msg");
    return msg2.locale = targetLocale, msg2.key = key, msg2;
  }
  let start = null, startTag, endTag;
  process.env.NODE_ENV !== "production" && inBrowser && (start = window.performance.now(), startTag = "intlify-message-compilation-start", endTag = "intlify-message-compilation-end", mark && mark(startTag));
  const msg = messageCompiler(format2, getCompileContext(context, targetLocale, cacheBaseKey, format2, warnHtmlMessage, onError));
  if (process.env.NODE_ENV !== "production" && inBrowser) {
    const end = window.performance.now(), emitter = context.__v_emitter;
    emitter && start && emitter.emit("message-compilation", {
      type: "message-compilation",
      message: format2,
      time: end - start,
      groupId: `translate:${key}`
    }), startTag && endTag && mark && measure && (mark(endTag), measure("intlify message compilation", startTag, endTag));
  }
  return msg.locale = targetLocale, msg.key = key, msg.source = format2, msg;
}
__name(compileMessageFormat, "compileMessageFormat");
function evaluateMessage(context, msg, msgCtx) {
  let start = null, startTag, endTag;
  process.env.NODE_ENV !== "production" && inBrowser && (start = window.performance.now(), startTag = "intlify-message-evaluation-start", endTag = "intlify-message-evaluation-end", mark && mark(startTag));
  const messaged = msg(msgCtx);
  if (process.env.NODE_ENV !== "production" && inBrowser) {
    const end = window.performance.now(), emitter = context.__v_emitter;
    emitter && start && emitter.emit("message-evaluation", {
      type: "message-evaluation",
      value: messaged,
      time: end - start,
      groupId: `translate:${msg.key}`
    }), startTag && endTag && mark && measure && (mark(endTag), measure("intlify message evaluation", startTag, endTag));
  }
  return messaged;
}
__name(evaluateMessage, "evaluateMessage");
function parseTranslateArgs(...args) {
  const [arg1, arg2, arg3] = args, options = create();
  if (!isString(arg1) && !isNumber(arg1) && !isMessageFunction(arg1) && !isMessageAST(arg1))
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  const key = isNumber(arg1) ? String(arg1) : (isMessageFunction(arg1), arg1);
  return isNumber(arg2) ? options.plural = arg2 : isString(arg2) ? options.default = arg2 : isPlainObject(arg2) && !isEmptyObject(arg2) ? options.named = arg2 : isArray(arg2) && (options.list = arg2), isNumber(arg3) ? options.plural = arg3 : isString(arg3) ? options.default = arg3 : isPlainObject(arg3) && assign(options, arg3), [key, options];
}
__name(parseTranslateArgs, "parseTranslateArgs");
function getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
  return {
    locale,
    key,
    warnHtmlMessage,
    onError: /* @__PURE__ */ __name((err) => {
      if (onError && onError(err), process.env.NODE_ENV !== "production") {
        const _source = getSourceForCodeFrame(source), message = `Message compilation error: ${err.message}`, codeFrame = err.location && _source && generateCodeFrame(_source, err.location.start.offset, err.location.end.offset), emitter = context.__v_emitter;
        emitter && _source && emitter.emit("compile-error", {
          message: _source,
          error: err.message,
          start: err.location && err.location.start.offset,
          end: err.location && err.location.end.offset,
          groupId: `translate:${key}`
        }), console.error(codeFrame ? `${message}
${codeFrame}` : message);
      } else
        throw err;
    }, "onError"),
    onCacheKey: /* @__PURE__ */ __name((source2) => generateFormatCacheKey(locale, key, source2), "onCacheKey")
  };
}
__name(getCompileContext, "getCompileContext");
function getSourceForCodeFrame(source) {
  if (isString(source))
    return source;
  if (source.loc && source.loc.source)
    return source.loc.source;
}
__name(getSourceForCodeFrame, "getSourceForCodeFrame");
function getMessageContextOptions(context, locale, message, options) {
  const { modifiers, pluralRules, messageResolver: resolveValue2, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context, ctxOptions = {
    locale,
    modifiers,
    pluralRules,
    messages: /* @__PURE__ */ __name((key, useLinked) => {
      let val = resolveValue2(message, key);
      if (val == null && (fallbackContext || useLinked)) {
        const [, , message2] = resolveMessageFormat(
          fallbackContext || context,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          key,
          locale,
          fallbackLocale,
          fallbackWarn,
          missingWarn
        );
        val = resolveValue2(message2, key);
      }
      if (isString(val) || isMessageAST(val)) {
        let occurred = !1;
        const msg = compileMessageFormat(context, key, locale, val, key, /* @__PURE__ */ __name(() => {
          occurred = !0;
        }, "onError"));
        return occurred ? NOOP_MESSAGE_FUNCTION : msg;
      } else return isMessageFunction(val) ? val : NOOP_MESSAGE_FUNCTION;
    }, "resolveMessage")
  };
  return context.processor && (ctxOptions.processor = context.processor), options.list && (ctxOptions.list = options.list), options.named && (ctxOptions.named = options.named), isNumber(options.plural) && (ctxOptions.pluralIndex = options.plural), ctxOptions;
}
__name(getMessageContextOptions, "getMessageContextOptions");
initFeatureFlags$1();
/*!
  * vue-i18n v11.1.10
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const VERSION = "11.1.10";
function initFeatureFlags() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (getGlobalThis().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (getGlobalThis().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
__name(initFeatureFlags, "initFeatureFlags");
const I18nErrorCodes = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: CORE_ERROR_CODES_EXTEND_POINT,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 35
};
function createI18nError(code, ...args) {
  return createCompileError(code, null, process.env.NODE_ENV !== "production" ? { messages: errorMessages, args } : void 0);
}
__name(createI18nError, "createI18nError");
const errorMessages = {
  [I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
  [I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [I18nErrorCodes.NOT_INSTALLED]: "Need to install with `app.use` function",
  [I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
  [I18nErrorCodes.REQUIRED_VALUE]: "Required in value: {0}",
  [I18nErrorCodes.INVALID_VALUE]: "Invalid value",
  [I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly",
  [I18nErrorCodes.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope"
}, TranslateVNodeSymbol = /* @__PURE__ */ makeSymbol("__translateVNode"), DatetimePartsSymbol = /* @__PURE__ */ makeSymbol("__datetimeParts"), NumberPartsSymbol = /* @__PURE__ */ makeSymbol("__numberParts"), EnableEmitter = /* @__PURE__ */ makeSymbol("__enableEmitter"), DisableEmitter = /* @__PURE__ */ makeSymbol("__disableEmitter"), SetPluralRulesSymbol = makeSymbol("__setPluralRules"), InejctWithOptionSymbol = /* @__PURE__ */ makeSymbol("__injectWithOption"), DisposeSymbol = /* @__PURE__ */ makeSymbol("__dispose"), I18nWarnCodes = {
  FALLBACK_TO_ROOT: CORE_WARN_CODES_EXTEND_POINT,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12
}, warnMessages = {
  [I18nWarnCodes.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [I18nWarnCodes.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [I18nWarnCodes.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [I18nWarnCodes.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead."
};
function getWarnMessage(code, ...args) {
  return format$1(warnMessages[code], ...args);
}
__name(getWarnMessage, "getWarnMessage");
function handleFlatJson(obj) {
  if (!isObject(obj) || isMessageAST(obj))
    return obj;
  for (const key in obj)
    if (hasOwn(obj, key))
      if (!key.includes("."))
        isObject(obj[key]) && handleFlatJson(obj[key]);
      else {
        const subKeys = key.split("."), lastIndex = subKeys.length - 1;
        let currentObj = obj, hasStringValue = !1;
        for (let i = 0; i < lastIndex; i++) {
          if (subKeys[i] === "__proto__")
            throw new Error(`unsafe key: ${subKeys[i]}`);
          if (subKeys[i] in currentObj || (currentObj[subKeys[i]] = create()), !isObject(currentObj[subKeys[i]])) {
            process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.IGNORE_OBJ_FLATTEN, {
              key: subKeys[i]
            })), hasStringValue = !0;
            break;
          }
          currentObj = currentObj[subKeys[i]];
        }
        if (hasStringValue || (isMessageAST(currentObj) ? AST_NODE_PROPS_KEYS.includes(subKeys[lastIndex]) || delete obj[key] : (currentObj[subKeys[lastIndex]] = obj[key], delete obj[key])), !isMessageAST(currentObj)) {
          const target = currentObj[subKeys[lastIndex]];
          isObject(target) && handleFlatJson(target);
        }
      }
  return obj;
}
__name(handleFlatJson, "handleFlatJson");
function getLocaleMessages(locale, options) {
  const { messages, __i18n, messageResolver, flatJson } = options, ret = isPlainObject(messages) ? messages : isArray(__i18n) ? create() : { [locale]: create() };
  if (isArray(__i18n) && __i18n.forEach((custom) => {
    if ("locale" in custom && "resource" in custom) {
      const { locale: locale2, resource } = custom;
      locale2 ? (ret[locale2] = ret[locale2] || create(), deepCopy(resource, ret[locale2])) : deepCopy(resource, ret);
    } else
      isString(custom) && deepCopy(JSON.parse(custom), ret);
  }), messageResolver == null && flatJson)
    for (const key in ret)
      hasOwn(ret, key) && handleFlatJson(ret[key]);
  return ret;
}
__name(getLocaleMessages, "getLocaleMessages");
function getComponentOptions(instance) {
  return instance.type;
}
__name(getComponentOptions, "getComponentOptions");
function adjustI18nResources(gl, options, componentOptions) {
  let messages = isObject(options.messages) ? options.messages : create();
  "__i18nGlobal" in componentOptions && (messages = getLocaleMessages(gl.locale.value, {
    messages,
    __i18n: componentOptions.__i18nGlobal
  }));
  const locales = Object.keys(messages);
  locales.length && locales.forEach((locale) => {
    gl.mergeLocaleMessage(locale, messages[locale]);
  });
  {
    if (isObject(options.datetimeFormats)) {
      const locales2 = Object.keys(options.datetimeFormats);
      locales2.length && locales2.forEach((locale) => {
        gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
      });
    }
    if (isObject(options.numberFormats)) {
      const locales2 = Object.keys(options.numberFormats);
      locales2.length && locales2.forEach((locale) => {
        gl.mergeNumberFormat(locale, options.numberFormats[locale]);
      });
    }
  }
}
__name(adjustI18nResources, "adjustI18nResources");
function createTextNode(key) {
  return createVNode(Text, null, key, 0);
}
__name(createTextNode, "createTextNode");
const DEVTOOLS_META = "__INTLIFY_META__", NOOP_RETURN_ARRAY = /* @__PURE__ */ __name(() => [], "NOOP_RETURN_ARRAY"), NOOP_RETURN_FALSE = /* @__PURE__ */ __name(() => !1, "NOOP_RETURN_FALSE");
let composerID = 0;
function defineCoreMissingHandler(missing) {
  return (ctx, locale, key, type) => missing(locale, key, getCurrentInstance() || void 0, type);
}
__name(defineCoreMissingHandler, "defineCoreMissingHandler");
const getMetaInfo = /* @__PURE__ */ __name(/* @__NO_SIDE_EFFECTS__ */ () => {
  const instance = getCurrentInstance();
  let meta = null;
  return instance && (meta = getComponentOptions(instance)[DEVTOOLS_META]) ? { [DEVTOOLS_META]: meta } : null;
}, "getMetaInfo");
function createComposer(options = {}) {
  const { __root, __injectWithOption } = options, _isGlobal = __root === void 0, flatJson = options.flatJson, _ref = inBrowser ? ref : shallowRef;
  let _inheritLocale = isBoolean(options.inheritLocale) ? options.inheritLocale : !0;
  const _locale = _ref(
    // prettier-ignore
    __root && _inheritLocale ? __root.locale.value : isString(options.locale) ? options.locale : DEFAULT_LOCALE
  ), _fallbackLocale = _ref(
    // prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : isString(options.fallbackLocale) || isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || options.fallbackLocale === !1 ? options.fallbackLocale : _locale.value
  ), _messages = _ref(getLocaleMessages(_locale.value, options)), _datetimeFormats = _ref(isPlainObject(options.datetimeFormats) ? options.datetimeFormats : { [_locale.value]: {} }), _numberFormats = _ref(isPlainObject(options.numberFormats) ? options.numberFormats : { [_locale.value]: {} });
  let _missingWarn = __root ? __root.missingWarn : isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : !0, _fallbackWarn = __root ? __root.fallbackWarn : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : !0, _fallbackRoot = __root ? __root.fallbackRoot : isBoolean(options.fallbackRoot) ? options.fallbackRoot : !0, _fallbackFormat = !!options.fallbackFormat, _missing = isFunction(options.missing) ? options.missing : null, _runtimeMissing = isFunction(options.missing) ? defineCoreMissingHandler(options.missing) : null, _postTranslation = isFunction(options.postTranslation) ? options.postTranslation : null, _warnHtmlMessage = __root ? __root.warnHtmlMessage : isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : !0, _escapeParameter = !!options.escapeParameter;
  const _modifiers = __root ? __root.modifiers : isPlainObject(options.modifiers) ? options.modifiers : {};
  let _pluralRules = options.pluralRules || __root && __root.pluralRules, _context;
  _context = (/* @__PURE__ */ __name(() => {
    _isGlobal && setFallbackContext(null);
    const ctxOptions = {
      version: VERSION,
      locale: _locale.value,
      fallbackLocale: _fallbackLocale.value,
      messages: _messages.value,
      modifiers: _modifiers,
      pluralRules: _pluralRules,
      missing: _runtimeMissing === null ? void 0 : _runtimeMissing,
      missingWarn: _missingWarn,
      fallbackWarn: _fallbackWarn,
      fallbackFormat: _fallbackFormat,
      unresolving: !0,
      postTranslation: _postTranslation === null ? void 0 : _postTranslation,
      warnHtmlMessage: _warnHtmlMessage,
      escapeParameter: _escapeParameter,
      messageResolver: options.messageResolver,
      messageCompiler: options.messageCompiler,
      __meta: { framework: "vue" }
    };
    ctxOptions.datetimeFormats = _datetimeFormats.value, ctxOptions.numberFormats = _numberFormats.value, ctxOptions.__datetimeFormatters = isPlainObject(_context) ? _context.__datetimeFormatters : void 0, ctxOptions.__numberFormatters = isPlainObject(_context) ? _context.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (ctxOptions.__v_emitter = isPlainObject(_context) ? _context.__v_emitter : void 0);
    const ctx = createCoreContext(ctxOptions);
    return _isGlobal && setFallbackContext(ctx), ctx;
  }, "getCoreContext"))(), updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
  function trackReactivityValues() {
    return [
      _locale.value,
      _fallbackLocale.value,
      _messages.value,
      _datetimeFormats.value,
      _numberFormats.value
    ];
  }
  __name(trackReactivityValues, "trackReactivityValues");
  const locale = computed({
    get: /* @__PURE__ */ __name(() => _locale.value, "get"),
    set: /* @__PURE__ */ __name((val) => {
      _context.locale = val, _locale.value = val;
    }, "set")
  }), fallbackLocale = computed({
    get: /* @__PURE__ */ __name(() => _fallbackLocale.value, "get"),
    set: /* @__PURE__ */ __name((val) => {
      _context.fallbackLocale = val, _fallbackLocale.value = val, updateFallbackLocale(_context, _locale.value, val);
    }, "set")
  }), messages = computed(() => _messages.value), datetimeFormats = /* @__PURE__ */ computed(() => _datetimeFormats.value), numberFormats = /* @__PURE__ */ computed(() => _numberFormats.value);
  function getPostTranslationHandler() {
    return isFunction(_postTranslation) ? _postTranslation : null;
  }
  __name(getPostTranslationHandler, "getPostTranslationHandler");
  function setPostTranslationHandler(handler) {
    _postTranslation = handler, _context.postTranslation = handler;
  }
  __name(setPostTranslationHandler, "setPostTranslationHandler");
  function getMissingHandler() {
    return _missing;
  }
  __name(getMissingHandler, "getMissingHandler");
  function setMissingHandler(handler) {
    handler !== null && (_runtimeMissing = defineCoreMissingHandler(handler)), _missing = handler, _context.missing = _runtimeMissing;
  }
  __name(setMissingHandler, "setMissingHandler");
  function isResolvedTranslateMessage(type, arg) {
    return type !== "translate" || !arg.resolvedMessage;
  }
  __name(isResolvedTranslateMessage, "isResolvedTranslateMessage");
  const wrapWithDeps = /* @__PURE__ */ __name((fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) => {
    trackReactivityValues();
    let ret;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, _isGlobal || (_context.fallbackContext = __root ? getFallbackContext() : void 0), ret = fn(_context);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, _isGlobal || (_context.fallbackContext = void 0);
    }
    if (warnType !== "translate exists" && // for not `te` (e.g `t`)
    isNumber(ret) && ret === NOT_REOSLVED || warnType === "translate exists" && !ret) {
      const [key, arg2] = argumentParser();
      if (process.env.NODE_ENV !== "production" && __root && isString(key) && isResolvedTranslateMessage(warnType, arg2) && (_fallbackRoot && (isTranslateFallbackWarn(_fallbackWarn, key) || isTranslateMissingWarn(_missingWarn, key)) && warn(getWarnMessage(I18nWarnCodes.FALLBACK_TO_ROOT, {
        key,
        type: warnType
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: emitter } = _context;
        emitter && _fallbackRoot && emitter.emit("fallback", {
          type: warnType,
          key,
          to: "global",
          groupId: `${warnType}:${key}`
        });
      }
      return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
    } else {
      if (successCondition(ret))
        return ret;
      throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    }
  }, "wrapWithDeps");
  function t(...args) {
    return wrapWithDeps((context) => Reflect.apply(translate, null, [context, ...args]), () => parseTranslateArgs(...args), "translate", (root) => Reflect.apply(root.t, root, [...args]), (key) => key, (val) => isString(val));
  }
  __name(t, "t");
  function rt(...args) {
    const [arg1, arg2, arg3] = args;
    if (arg3 && !isObject(arg3))
      throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
    return t(arg1, arg2, assign({ resolvedMessage: !0 }, arg3 || {}));
  }
  __name(rt, "rt");
  function d(...args) {
    return wrapWithDeps((context) => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), "datetime format", (root) => Reflect.apply(root.d, root, [...args]), () => MISSING_RESOLVE_VALUE, (val) => isString(val) || isArray(val));
  }
  __name(d, "d");
  function n(...args) {
    return wrapWithDeps((context) => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), "number format", (root) => Reflect.apply(root.n, root, [...args]), () => MISSING_RESOLVE_VALUE, (val) => isString(val) || isArray(val));
  }
  __name(n, "n");
  function normalize(values) {
    return values.map((val) => isString(val) || isNumber(val) || isBoolean(val) ? createTextNode(String(val)) : val);
  }
  __name(normalize, "normalize");
  const processor = {
    normalize,
    interpolate: /* @__PURE__ */ __name((val) => val, "interpolate"),
    type: "vnode"
  };
  function translateVNode(...args) {
    return wrapWithDeps((context) => {
      let ret;
      const _context2 = context;
      try {
        _context2.processor = processor, ret = Reflect.apply(translate, null, [_context2, ...args]);
      } finally {
        _context2.processor = null;
      }
      return ret;
    }, () => parseTranslateArgs(...args), "translate", (root) => root[TranslateVNodeSymbol](...args), (key) => [createTextNode(key)], (val) => isArray(val));
  }
  __name(translateVNode, "translateVNode");
  function numberParts(...args) {
    return wrapWithDeps((context) => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), "number format", (root) => root[NumberPartsSymbol](...args), NOOP_RETURN_ARRAY, (val) => isString(val) || isArray(val));
  }
  __name(numberParts, "numberParts");
  function datetimeParts(...args) {
    return wrapWithDeps((context) => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), "datetime format", (root) => root[DatetimePartsSymbol](...args), NOOP_RETURN_ARRAY, (val) => isString(val) || isArray(val));
  }
  __name(datetimeParts, "datetimeParts");
  function setPluralRules(rules) {
    _pluralRules = rules, _context.pluralRules = _pluralRules;
  }
  __name(setPluralRules, "setPluralRules");
  function te(key, locale2) {
    return wrapWithDeps(() => {
      if (!key)
        return !1;
      const targetLocale = isString(locale2) ? locale2 : _locale.value, message = getLocaleMessage(targetLocale), resolved = _context.messageResolver(message, key);
      return isMessageAST(resolved) || isMessageFunction(resolved) || isString(resolved);
    }, () => [key], "translate exists", (root) => Reflect.apply(root.te, root, [key, locale2]), NOOP_RETURN_FALSE, (val) => isBoolean(val));
  }
  __name(te, "te");
  function resolveMessages(key) {
    let messages2 = null;
    const locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
    for (let i = 0; i < locales.length; i++) {
      const targetLocaleMessages = _messages.value[locales[i]] || {}, messageValue = _context.messageResolver(targetLocaleMessages, key);
      if (messageValue != null) {
        messages2 = messageValue;
        break;
      }
    }
    return messages2;
  }
  __name(resolveMessages, "resolveMessages");
  function tm(key) {
    const messages2 = resolveMessages(key);
    return messages2 ?? (__root ? __root.tm(key) || {} : {});
  }
  __name(tm, "tm");
  function getLocaleMessage(locale2) {
    return _messages.value[locale2] || {};
  }
  __name(getLocaleMessage, "getLocaleMessage");
  function setLocaleMessage(locale2, message) {
    if (flatJson) {
      const _message = { [locale2]: message };
      for (const key in _message)
        hasOwn(_message, key) && handleFlatJson(_message[key]);
      message = _message[locale2];
    }
    _messages.value[locale2] = message, _context.messages = _messages.value;
  }
  __name(setLocaleMessage, "setLocaleMessage");
  function mergeLocaleMessage(locale2, message) {
    _messages.value[locale2] = _messages.value[locale2] || {};
    const _message = { [locale2]: message };
    if (flatJson)
      for (const key in _message)
        hasOwn(_message, key) && handleFlatJson(_message[key]);
    message = _message[locale2], deepCopy(message, _messages.value[locale2]), _context.messages = _messages.value;
  }
  __name(mergeLocaleMessage, "mergeLocaleMessage");
  function getDateTimeFormat(locale2) {
    return _datetimeFormats.value[locale2] || {};
  }
  __name(getDateTimeFormat, "getDateTimeFormat");
  function setDateTimeFormat(locale2, format2) {
    _datetimeFormats.value[locale2] = format2, _context.datetimeFormats = _datetimeFormats.value, clearDateTimeFormat(_context, locale2, format2);
  }
  __name(setDateTimeFormat, "setDateTimeFormat");
  function mergeDateTimeFormat(locale2, format2) {
    _datetimeFormats.value[locale2] = assign(_datetimeFormats.value[locale2] || {}, format2), _context.datetimeFormats = _datetimeFormats.value, clearDateTimeFormat(_context, locale2, format2);
  }
  __name(mergeDateTimeFormat, "mergeDateTimeFormat");
  function getNumberFormat(locale2) {
    return _numberFormats.value[locale2] || {};
  }
  __name(getNumberFormat, "getNumberFormat");
  function setNumberFormat(locale2, format2) {
    _numberFormats.value[locale2] = format2, _context.numberFormats = _numberFormats.value, clearNumberFormat(_context, locale2, format2);
  }
  __name(setNumberFormat, "setNumberFormat");
  function mergeNumberFormat(locale2, format2) {
    _numberFormats.value[locale2] = assign(_numberFormats.value[locale2] || {}, format2), _context.numberFormats = _numberFormats.value, clearNumberFormat(_context, locale2, format2);
  }
  __name(mergeNumberFormat, "mergeNumberFormat"), composerID++, __root && inBrowser && (watch(__root.locale, (val) => {
    _inheritLocale && (_locale.value = val, _context.locale = val, updateFallbackLocale(_context, _locale.value, _fallbackLocale.value));
  }), watch(__root.fallbackLocale, (val) => {
    _inheritLocale && (_fallbackLocale.value = val, _context.fallbackLocale = val, updateFallbackLocale(_context, _locale.value, _fallbackLocale.value));
  }));
  const composer = {
    id: composerID,
    locale,
    fallbackLocale,
    get inheritLocale() {
      return _inheritLocale;
    },
    set inheritLocale(val) {
      _inheritLocale = val, val && __root && (_locale.value = __root.locale.value, _fallbackLocale.value = __root.fallbackLocale.value, updateFallbackLocale(_context, _locale.value, _fallbackLocale.value));
    },
    get availableLocales() {
      return Object.keys(_messages.value).sort();
    },
    messages,
    get modifiers() {
      return _modifiers;
    },
    get pluralRules() {
      return _pluralRules || {};
    },
    get isGlobal() {
      return _isGlobal;
    },
    get missingWarn() {
      return _missingWarn;
    },
    set missingWarn(val) {
      _missingWarn = val, _context.missingWarn = _missingWarn;
    },
    get fallbackWarn() {
      return _fallbackWarn;
    },
    set fallbackWarn(val) {
      _fallbackWarn = val, _context.fallbackWarn = _fallbackWarn;
    },
    get fallbackRoot() {
      return _fallbackRoot;
    },
    set fallbackRoot(val) {
      _fallbackRoot = val;
    },
    get fallbackFormat() {
      return _fallbackFormat;
    },
    set fallbackFormat(val) {
      _fallbackFormat = val, _context.fallbackFormat = _fallbackFormat;
    },
    get warnHtmlMessage() {
      return _warnHtmlMessage;
    },
    set warnHtmlMessage(val) {
      _warnHtmlMessage = val, _context.warnHtmlMessage = val;
    },
    get escapeParameter() {
      return _escapeParameter;
    },
    set escapeParameter(val) {
      _escapeParameter = val, _context.escapeParameter = val;
    },
    t,
    getLocaleMessage,
    setLocaleMessage,
    mergeLocaleMessage,
    getPostTranslationHandler,
    setPostTranslationHandler,
    getMissingHandler,
    setMissingHandler,
    [SetPluralRulesSymbol]: setPluralRules
  };
  return composer.datetimeFormats = datetimeFormats, composer.numberFormats = numberFormats, composer.rt = rt, composer.te = te, composer.tm = tm, composer.d = d, composer.n = n, composer.getDateTimeFormat = getDateTimeFormat, composer.setDateTimeFormat = setDateTimeFormat, composer.mergeDateTimeFormat = mergeDateTimeFormat, composer.getNumberFormat = getNumberFormat, composer.setNumberFormat = setNumberFormat, composer.mergeNumberFormat = mergeNumberFormat, composer[InejctWithOptionSymbol] = __injectWithOption, composer[TranslateVNodeSymbol] = translateVNode, composer[DatetimePartsSymbol] = datetimeParts, composer[NumberPartsSymbol] = numberParts, process.env.NODE_ENV !== "production" && (composer[EnableEmitter] = (emitter) => {
    _context.__v_emitter = emitter;
  }, composer[DisableEmitter] = () => {
    _context.__v_emitter = void 0;
  }), composer;
}
__name(createComposer, "createComposer");
const VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties", VueDevToolsLabels = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n DevTools",
  "vue-i18n-resource-inspector": "Vue I18n DevTools",
  "vue-i18n-timeline": "Vue I18n"
}, VueDevToolsPlaceholders = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, VueDevToolsTimelineColors = {
  "vue-i18n-timeline": 16764185
};
let devtoolsApi;
async function enableDevTools(app, i18n) {
  return new Promise((resolve, reject) => {
    try {
      setupDevtoolsPlugin({
        id: "vue-devtools-plugin-vue-i18n",
        label: VueDevToolsLabels["vue-devtools-plugin-vue-i18n"],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [VUE_I18N_COMPONENT_TYPES],
        app
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (api) => {
        devtoolsApi = api, api.on.visitComponentTree(({ componentInstance, treeNode }) => {
          updateComponentTreeTags(componentInstance, treeNode, i18n);
        }), api.on.inspectComponent(({ componentInstance, instanceData }) => {
          componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData && (i18n.mode === "legacy" ? componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer && inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__) : inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__));
        }), api.addInspector({
          id: "vue-i18n-resource-inspector",
          label: VueDevToolsLabels["vue-i18n-resource-inspector"],
          icon: "language",
          treeFilterPlaceholder: VueDevToolsPlaceholders["vue-i18n-resource-inspector"]
        }), api.on.getInspectorTree((payload) => {
          payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" && registerScope(payload, i18n);
        });
        const roots = /* @__PURE__ */ new Map();
        api.on.getInspectorState(async (payload) => {
          if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector")
            if (api.unhighlightElement(), inspectScope(payload, i18n), payload.nodeId === "global") {
              if (!roots.has(payload.app)) {
                const [root] = await api.getComponentInstances(payload.app);
                roots.set(payload.app, root);
              }
              api.highlightElement(roots.get(payload.app));
            } else {
              const instance = getComponentInstance(payload.nodeId, i18n);
              instance && api.highlightElement(instance);
            }
        }), api.on.editInspectorState((payload) => {
          payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" && editScope(payload, i18n);
        }), api.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: VueDevToolsLabels["vue-i18n-timeline"],
          color: VueDevToolsTimelineColors["vue-i18n-timeline"]
        }), resolve(!0);
      });
    } catch (e) {
      console.error(e), reject(!1);
    }
  });
}
__name(enableDevTools, "enableDevTools");
function getI18nScopeLable(instance) {
  return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
__name(getI18nScopeLable, "getI18nScopeLable");
function updateComponentTreeTags(instance, treeNode, i18n) {
  const global2 = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
  if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__ && instance.vnode.el.__VUE_I18N__ !== global2) {
    const tag = {
      label: `i18n (${getI18nScopeLable(instance)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    treeNode.tags.push(tag);
  }
}
__name(updateComponentTreeTags, "updateComponentTreeTags");
function inspectComposer(instanceData, composer) {
  const type = VUE_I18N_COMPONENT_TYPES;
  instanceData.state.push({
    type,
    key: "locale",
    editable: !0,
    value: composer.locale.value
  }), instanceData.state.push({
    type,
    key: "availableLocales",
    editable: !1,
    value: composer.availableLocales
  }), instanceData.state.push({
    type,
    key: "fallbackLocale",
    editable: !0,
    value: composer.fallbackLocale.value
  }), instanceData.state.push({
    type,
    key: "inheritLocale",
    editable: !0,
    value: composer.inheritLocale
  }), instanceData.state.push({
    type,
    key: "messages",
    editable: !1,
    value: getLocaleMessageValue(composer.messages.value)
  }), instanceData.state.push({
    type,
    key: "datetimeFormats",
    editable: !1,
    value: composer.datetimeFormats.value
  }), instanceData.state.push({
    type,
    key: "numberFormats",
    editable: !1,
    value: composer.numberFormats.value
  });
}
__name(inspectComposer, "inspectComposer");
function getLocaleMessageValue(messages) {
  const value = {};
  return Object.keys(messages).forEach((key) => {
    const v = messages[key];
    isFunction(v) && "source" in v ? value[key] = getMessageFunctionDetails(v) : isMessageAST(v) && v.loc && v.loc.source ? value[key] = v.loc.source : isObject(v) ? value[key] = getLocaleMessageValue(v) : value[key] = v;
  }), value;
}
__name(getLocaleMessageValue, "getLocaleMessageValue");
const ESC = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function escape(s) {
  return s.replace(/[<>"&]/g, escapeChar);
}
__name(escape, "escape");
function escapeChar(a) {
  return ESC[a] || a;
}
__name(escapeChar, "escapeChar");
function getMessageFunctionDetails(func) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${func.source ? `("${escape(func.source)}")` : "(?)"}`
    }
  };
}
__name(getMessageFunctionDetails, "getMessageFunctionDetails");
function registerScope(payload, i18n) {
  payload.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const global2 = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
  for (const [keyInstance, instance] of i18n.__instances) {
    const composer = i18n.mode === "composition" ? instance : instance.__composer;
    global2 !== composer && payload.rootNodes.push({
      id: composer.id.toString(),
      label: `${getI18nScopeLable(keyInstance)} Scope`
    });
  }
}
__name(registerScope, "registerScope");
function getComponentInstance(nodeId, i18n) {
  let instance = null;
  if (nodeId !== "global") {
    for (const [component, composer] of i18n.__instances.entries())
      if (composer.id.toString() === nodeId) {
        instance = component;
        break;
      }
  }
  return instance;
}
__name(getComponentInstance, "getComponentInstance");
function getComposer$2(nodeId, i18n) {
  if (nodeId === "global")
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
  {
    const instance = Array.from(i18n.__instances.values()).find((item) => item.id.toString() === nodeId);
    return instance ? i18n.mode === "composition" ? instance : instance.__composer : null;
  }
}
__name(getComposer$2, "getComposer$2");
function inspectScope(payload, i18n) {
  const composer = getComposer$2(payload.nodeId, i18n);
  return composer && (payload.state = makeScopeInspectState(composer)), null;
}
__name(inspectScope, "inspectScope");
function makeScopeInspectState(composer) {
  const state = {}, localeType = "Locale related info", localeStates = [
    {
      type: localeType,
      key: "locale",
      editable: !0,
      value: composer.locale.value
    },
    {
      type: localeType,
      key: "fallbackLocale",
      editable: !0,
      value: composer.fallbackLocale.value
    },
    {
      type: localeType,
      key: "availableLocales",
      editable: !1,
      value: composer.availableLocales
    },
    {
      type: localeType,
      key: "inheritLocale",
      editable: !0,
      value: composer.inheritLocale
    }
  ];
  state[localeType] = localeStates;
  const localeMessagesType = "Locale messages info", localeMessagesStates = [
    {
      type: localeMessagesType,
      key: "messages",
      editable: !1,
      value: getLocaleMessageValue(composer.messages.value)
    }
  ];
  state[localeMessagesType] = localeMessagesStates;
  {
    const datetimeFormatsType = "Datetime formats info", datetimeFormatsStates = [
      {
        type: datetimeFormatsType,
        key: "datetimeFormats",
        editable: !1,
        value: composer.datetimeFormats.value
      }
    ];
    state[datetimeFormatsType] = datetimeFormatsStates;
    const numberFormatsType = "Datetime formats info", numberFormatsStates = [
      {
        type: numberFormatsType,
        key: "numberFormats",
        editable: !1,
        value: composer.numberFormats.value
      }
    ];
    state[numberFormatsType] = numberFormatsStates;
  }
  return state;
}
__name(makeScopeInspectState, "makeScopeInspectState");
function addTimelineEvent(event, payload) {
  if (devtoolsApi) {
    let groupId;
    payload && "groupId" in payload && (groupId = payload.groupId, delete payload.groupId), devtoolsApi.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: event,
        groupId,
        time: Date.now(),
        meta: {},
        data: payload || {},
        logType: event === "compile-error" ? "error" : event === "fallback" || event === "missing" ? "warning" : "default"
      }
    });
  }
}
__name(addTimelineEvent, "addTimelineEvent");
function editScope(payload, i18n) {
  const composer = getComposer$2(payload.nodeId, i18n);
  if (composer) {
    const [field] = payload.path;
    field === "locale" && isString(payload.state.value) ? composer.locale.value = payload.state.value : field === "fallbackLocale" && (isString(payload.state.value) || isArray(payload.state.value) || isObject(payload.state.value)) ? composer.fallbackLocale.value = payload.state.value : field === "inheritLocale" && isBoolean(payload.state.value) && (composer.inheritLocale = payload.state.value);
  }
}
__name(editScope, "editScope");
function convertComposerOptions(options) {
  const locale = isString(options.locale) ? options.locale : DEFAULT_LOCALE, fallbackLocale = isString(options.fallbackLocale) || isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || options.fallbackLocale === !1 ? options.fallbackLocale : locale, missing = isFunction(options.missing) ? options.missing : void 0, missingWarn = isBoolean(options.silentTranslationWarn) || isRegExp(options.silentTranslationWarn) ? !options.silentTranslationWarn : !0, fallbackWarn = isBoolean(options.silentFallbackWarn) || isRegExp(options.silentFallbackWarn) ? !options.silentFallbackWarn : !0, fallbackRoot = isBoolean(options.fallbackRoot) ? options.fallbackRoot : !0, fallbackFormat = !!options.formatFallbackMessages, modifiers = isPlainObject(options.modifiers) ? options.modifiers : {}, pluralizationRules = options.pluralizationRules, postTranslation = isFunction(options.postTranslation) ? options.postTranslation : void 0, warnHtmlMessage = isString(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : !0, escapeParameter = !!options.escapeParameterHtml, inheritLocale = isBoolean(options.sync) ? options.sync : !0;
  let messages = options.messages;
  if (isPlainObject(options.sharedMessages)) {
    const sharedMessages = options.sharedMessages;
    messages = Object.keys(sharedMessages).reduce((messages2, locale2) => {
      const message = messages2[locale2] || (messages2[locale2] = {});
      return assign(message, sharedMessages[locale2]), messages2;
    }, messages || {});
  }
  const { __i18n, __root, __injectWithOption } = options, datetimeFormats = options.datetimeFormats, numberFormats = options.numberFormats, flatJson = options.flatJson;
  return {
    locale,
    fallbackLocale,
    messages,
    flatJson,
    datetimeFormats,
    numberFormats,
    missing,
    missingWarn,
    fallbackWarn,
    fallbackRoot,
    fallbackFormat,
    modifiers,
    pluralRules: pluralizationRules,
    postTranslation,
    warnHtmlMessage,
    escapeParameter,
    messageResolver: options.messageResolver,
    inheritLocale,
    __i18n,
    __root,
    __injectWithOption
  };
}
__name(convertComposerOptions, "convertComposerOptions");
function createVueI18n(options = {}) {
  const composer = createComposer(convertComposerOptions(options)), { __extender } = options, vueI18n = {
    // id
    id: composer.id,
    // locale
    get locale() {
      return composer.locale.value;
    },
    set locale(val) {
      composer.locale.value = val;
    },
    // fallbackLocale
    get fallbackLocale() {
      return composer.fallbackLocale.value;
    },
    set fallbackLocale(val) {
      composer.fallbackLocale.value = val;
    },
    // messages
    get messages() {
      return composer.messages.value;
    },
    // datetimeFormats
    get datetimeFormats() {
      return composer.datetimeFormats.value;
    },
    // numberFormats
    get numberFormats() {
      return composer.numberFormats.value;
    },
    // availableLocales
    get availableLocales() {
      return composer.availableLocales;
    },
    // missing
    get missing() {
      return composer.getMissingHandler();
    },
    set missing(handler) {
      composer.setMissingHandler(handler);
    },
    // silentTranslationWarn
    get silentTranslationWarn() {
      return isBoolean(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
    },
    set silentTranslationWarn(val) {
      composer.missingWarn = isBoolean(val) ? !val : val;
    },
    // silentFallbackWarn
    get silentFallbackWarn() {
      return isBoolean(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
    },
    set silentFallbackWarn(val) {
      composer.fallbackWarn = isBoolean(val) ? !val : val;
    },
    // modifiers
    get modifiers() {
      return composer.modifiers;
    },
    // formatFallbackMessages
    get formatFallbackMessages() {
      return composer.fallbackFormat;
    },
    set formatFallbackMessages(val) {
      composer.fallbackFormat = val;
    },
    // postTranslation
    get postTranslation() {
      return composer.getPostTranslationHandler();
    },
    set postTranslation(handler) {
      composer.setPostTranslationHandler(handler);
    },
    // sync
    get sync() {
      return composer.inheritLocale;
    },
    set sync(val) {
      composer.inheritLocale = val;
    },
    // warnInHtmlMessage
    get warnHtmlInMessage() {
      return composer.warnHtmlMessage ? "warn" : "off";
    },
    set warnHtmlInMessage(val) {
      composer.warnHtmlMessage = val !== "off";
    },
    // escapeParameterHtml
    get escapeParameterHtml() {
      return composer.escapeParameter;
    },
    set escapeParameterHtml(val) {
      composer.escapeParameter = val;
    },
    // pluralizationRules
    get pluralizationRules() {
      return composer.pluralRules || {};
    },
    // for internal
    __composer: composer,
    // t
    t(...args) {
      return Reflect.apply(composer.t, composer, [...args]);
    },
    // rt
    rt(...args) {
      return Reflect.apply(composer.rt, composer, [...args]);
    },
    // te
    te(key, locale) {
      return composer.te(key, locale);
    },
    // tm
    tm(key) {
      return composer.tm(key);
    },
    // getLocaleMessage
    getLocaleMessage(locale) {
      return composer.getLocaleMessage(locale);
    },
    // setLocaleMessage
    setLocaleMessage(locale, message) {
      composer.setLocaleMessage(locale, message);
    },
    // mergeLocaleMessage
    mergeLocaleMessage(locale, message) {
      composer.mergeLocaleMessage(locale, message);
    },
    // d
    d(...args) {
      return Reflect.apply(composer.d, composer, [...args]);
    },
    // getDateTimeFormat
    getDateTimeFormat(locale) {
      return composer.getDateTimeFormat(locale);
    },
    // setDateTimeFormat
    setDateTimeFormat(locale, format2) {
      composer.setDateTimeFormat(locale, format2);
    },
    // mergeDateTimeFormat
    mergeDateTimeFormat(locale, format2) {
      composer.mergeDateTimeFormat(locale, format2);
    },
    // n
    n(...args) {
      return Reflect.apply(composer.n, composer, [...args]);
    },
    // getNumberFormat
    getNumberFormat(locale) {
      return composer.getNumberFormat(locale);
    },
    // setNumberFormat
    setNumberFormat(locale, format2) {
      composer.setNumberFormat(locale, format2);
    },
    // mergeNumberFormat
    mergeNumberFormat(locale, format2) {
      composer.mergeNumberFormat(locale, format2);
    }
  };
  return vueI18n.__extender = __extender, process.env.NODE_ENV !== "production" && (vueI18n.__enableEmitter = (emitter) => {
    const __composer = composer;
    __composer[EnableEmitter] && __composer[EnableEmitter](emitter);
  }, vueI18n.__disableEmitter = () => {
    const __composer = composer;
    __composer[DisableEmitter] && __composer[DisableEmitter]();
  }), vueI18n;
}
__name(createVueI18n, "createVueI18n");
function defineMixin(vuei18n, composer, i18n) {
  return {
    beforeCreate() {
      const instance = getCurrentInstance();
      if (!instance)
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      const options = this.$options;
      if (options.i18n) {
        const optionsI18n = options.i18n;
        if (options.__i18n && (optionsI18n.__i18n = options.__i18n), optionsI18n.__root = composer, this === this.$root)
          this.$i18n = mergeToGlobal(vuei18n, optionsI18n);
        else {
          optionsI18n.__injectWithOption = !0, optionsI18n.__extender = i18n.__vueI18nExtend, this.$i18n = createVueI18n(optionsI18n);
          const _vueI18n = this.$i18n;
          _vueI18n.__extender && (_vueI18n.__disposer = _vueI18n.__extender(this.$i18n));
        }
      } else if (options.__i18n)
        if (this === this.$root)
          this.$i18n = mergeToGlobal(vuei18n, options);
        else {
          this.$i18n = createVueI18n({
            __i18n: options.__i18n,
            __injectWithOption: !0,
            __extender: i18n.__vueI18nExtend,
            __root: composer
          });
          const _vueI18n = this.$i18n;
          _vueI18n.__extender && (_vueI18n.__disposer = _vueI18n.__extender(this.$i18n));
        }
      else
        this.$i18n = vuei18n;
      options.__i18nGlobal && adjustI18nResources(composer, options, options), this.$t = (...args) => this.$i18n.t(...args), this.$rt = (...args) => this.$i18n.rt(...args), this.$te = (key, locale) => this.$i18n.te(key, locale), this.$d = (...args) => this.$i18n.d(...args), this.$n = (...args) => this.$i18n.n(...args), this.$tm = (key) => this.$i18n.tm(key), i18n.__setInstance(instance, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const _vueI18n = this.$i18n;
        this.$el.__VUE_I18N__ = _vueI18n.__composer;
        const emitter = this.__v_emitter = createEmitter();
        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter), emitter.on("*", addTimelineEvent);
      }
    },
    unmounted() {
      const instance = getCurrentInstance();
      if (!instance)
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      const _vueI18n = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", addTimelineEvent), delete this.__v_emitter), this.$i18n && (_vueI18n.__disableEmitter && _vueI18n.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, _vueI18n.__disposer && (_vueI18n.__disposer(), delete _vueI18n.__disposer, delete _vueI18n.__extender), i18n.__deleteInstance(instance), delete this.$i18n;
    }
  };
}
__name(defineMixin, "defineMixin");
function mergeToGlobal(g, options) {
  g.locale = options.locale || g.locale, g.fallbackLocale = options.fallbackLocale || g.fallbackLocale, g.missing = options.missing || g.missing, g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn, g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn, g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages, g.postTranslation = options.postTranslation || g.postTranslation, g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage, g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml, g.sync = options.sync || g.sync, g.__composer[SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
  const messages = getLocaleMessages(g.locale, {
    messages: options.messages,
    __i18n: options.__i18n
  });
  return Object.keys(messages).forEach((locale) => g.mergeLocaleMessage(locale, messages[locale])), options.datetimeFormats && Object.keys(options.datetimeFormats).forEach((locale) => g.mergeDateTimeFormat(locale, options.datetimeFormats[locale])), options.numberFormats && Object.keys(options.numberFormats).forEach((locale) => g.mergeNumberFormat(locale, options.numberFormats[locale])), g;
}
__name(mergeToGlobal, "mergeToGlobal");
const baseFormatProps = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: /* @__PURE__ */ __name((val) => val === "parent" || val === "global", "validator"),
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function getInterpolateArg({ slots }, keys) {
  return keys.length === 1 && keys[0] === "default" ? (slots.default ? slots.default() : []).reduce((slot, current) => [
    ...slot,
    // prettier-ignore
    ...current.type === Fragment ? current.children : [current]
  ], []) : keys.reduce((arg, key) => {
    const slot = slots[key];
    return slot && (arg[key] = slot()), arg;
  }, create());
}
__name(getInterpolateArg, "getInterpolateArg");
function getFragmentableTag() {
  return Fragment;
}
__name(getFragmentableTag, "getFragmentableTag");
const TranslationImpl = /* @__PURE__ */ defineComponent({
  /* eslint-disable */
  name: "i18n-t",
  props: assign({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      validator: /* @__PURE__ */ __name((val) => isNumber(val) || !isNaN(val), "validator")
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(props, context) {
    const { slots, attrs } = context, i18n = props.i18n || useI18n({
      useScope: props.scope,
      __useComponent: !0
    });
    return () => {
      const keys = Object.keys(slots).filter((key) => key[0] !== "_"), options = create();
      props.locale && (options.locale = props.locale), props.plural !== void 0 && (options.plural = isString(props.plural) ? +props.plural : props.plural);
      const arg = getInterpolateArg(context, keys), children = i18n[TranslateVNodeSymbol](props.keypath, arg, options), assignedAttrs = assign(create(), attrs), tag = isString(props.tag) || isObject(props.tag) ? props.tag : getFragmentableTag();
      return h(tag, assignedAttrs, children);
    };
  }
}), Translation = TranslationImpl;
function isVNode(target) {
  return isArray(target) && !isString(target[0]);
}
__name(isVNode, "isVNode");
function renderFormatter(props, context, slotKeys, partFormatter) {
  const { slots, attrs } = context;
  return () => {
    const options = { part: !0 };
    let overrides = create();
    props.locale && (options.locale = props.locale), isString(props.format) ? options.key = props.format : isObject(props.format) && (isString(props.format.key) && (options.key = props.format.key), overrides = Object.keys(props.format).reduce((options2, prop) => slotKeys.includes(prop) ? assign(create(), options2, { [prop]: props.format[prop] }) : options2, create()));
    const parts = partFormatter(props.value, options, overrides);
    let children = [options.key];
    isArray(parts) ? children = parts.map((part, index) => {
      const slot = slots[part.type], node = slot ? slot({ [part.type]: part.value, index, parts }) : [part.value];
      return isVNode(node) && (node[0].key = `${part.type}-${index}`), node;
    }) : isString(parts) && (children = [parts]);
    const assignedAttrs = assign(create(), attrs), tag = isString(props.tag) || isObject(props.tag) ? props.tag : getFragmentableTag();
    return h(tag, assignedAttrs, children);
  };
}
__name(renderFormatter, "renderFormatter");
const NumberFormatImpl = /* @__PURE__ */ defineComponent({
  /* eslint-disable */
  name: "i18n-n",
  props: assign({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(props, context) {
    const i18n = props.i18n || useI18n({
      useScope: props.scope,
      __useComponent: !0
    });
    return renderFormatter(props, context, NUMBER_FORMAT_OPTIONS_KEYS, (...args) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      i18n[NumberPartsSymbol](...args)
    ));
  }
}), NumberFormat = NumberFormatImpl;
function getComposer$1(i18n, instance) {
  const i18nInternal = i18n;
  if (i18n.mode === "composition")
    return i18nInternal.__getInstance(instance) || i18n.global;
  {
    const vueI18n = i18nInternal.__getInstance(instance);
    return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
  }
}
__name(getComposer$1, "getComposer$1");
function vTDirective(i18n) {
  const _process = /* @__PURE__ */ __name((binding) => {
    process.env.NODE_ENV !== "production" && warnOnce(getWarnMessage(I18nWarnCodes.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE));
    const { instance, value } = binding;
    if (!instance || !instance.$)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    const composer = getComposer$1(i18n, instance.$), parsedValue = parseValue(value);
    return [
      Reflect.apply(composer.t, composer, [...makeParams(parsedValue)]),
      composer
    ];
  }, "_process");
  return {
    created: /* @__PURE__ */ __name((el, binding) => {
      const [textContent, composer] = _process(binding);
      inBrowser && i18n.global === composer && (el.__i18nWatcher = watch(composer.locale, () => {
        binding.instance && binding.instance.$forceUpdate();
      })), el.__composer = composer, el.textContent = textContent;
    }, "register"),
    unmounted: /* @__PURE__ */ __name((el) => {
      inBrowser && el.__i18nWatcher && (el.__i18nWatcher(), el.__i18nWatcher = void 0, delete el.__i18nWatcher), el.__composer && (el.__composer = void 0, delete el.__composer);
    }, "unregister"),
    beforeUpdate: /* @__PURE__ */ __name((el, { value }) => {
      if (el.__composer) {
        const composer = el.__composer, parsedValue = parseValue(value);
        el.textContent = Reflect.apply(composer.t, composer, [
          ...makeParams(parsedValue)
        ]);
      }
    }, "update"),
    getSSRProps: /* @__PURE__ */ __name((binding) => {
      const [textContent] = _process(binding);
      return { textContent };
    }, "getSSRProps")
  };
}
__name(vTDirective, "vTDirective");
function parseValue(value) {
  if (isString(value))
    return { path: value };
  if (isPlainObject(value)) {
    if (!("path" in value))
      throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, "path");
    return value;
  } else
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
}
__name(parseValue, "parseValue");
function makeParams(value) {
  const { path, locale, args, choice, plural } = value, options = {}, named = args || {};
  return isString(locale) && (options.locale = locale), isNumber(choice) && (options.plural = choice), isNumber(plural) && (options.plural = plural), [path, named, options];
}
__name(makeParams, "makeParams");
function apply(app, i18n, ...options) {
  const pluginOptions = isPlainObject(options[0]) ? options[0] : {};
  (isBoolean(pluginOptions.globalInstall) ? pluginOptions.globalInstall : !0) && ([Translation.name, "I18nT"].forEach((name) => app.component(name, Translation)), [NumberFormat.name, "I18nN"].forEach((name) => app.component(name, NumberFormat)), [DatetimeFormat.name, "I18nD"].forEach((name) => app.component(name, DatetimeFormat))), app.directive("t", vTDirective(i18n));
}
__name(apply, "apply");
const I18nInjectionKey = /* @__PURE__ */ makeSymbol("global-vue-i18n");
function createI18n(options = {}) {
  const __legacyMode = __VUE_I18N_LEGACY_API__ && isBoolean(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
  process.env.NODE_ENV !== "production" && __legacyMode && warnOnce(getWarnMessage(I18nWarnCodes.DEPRECATE_LEGACY_MODE));
  const __globalInjection = isBoolean(options.globalInjection) ? options.globalInjection : !0, __instances = /* @__PURE__ */ new Map(), [globalScope, __global] = createGlobal(options, __legacyMode), symbol = /* @__PURE__ */ makeSymbol(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  function __getInstance(component) {
    return __instances.get(component) || null;
  }
  __name(__getInstance, "__getInstance");
  function __setInstance(component, instance) {
    __instances.set(component, instance);
  }
  __name(__setInstance, "__setInstance");
  function __deleteInstance(component) {
    __instances.delete(component);
  }
  __name(__deleteInstance, "__deleteInstance");
  const i18n = {
    // mode
    get mode() {
      return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
    },
    // install plugin
    async install(app, ...options2) {
      if (process.env.NODE_ENV !== "production" && (app.__VUE_I18N__ = i18n), app.__VUE_I18N_SYMBOL__ = symbol, app.provide(app.__VUE_I18N_SYMBOL__, i18n), isPlainObject(options2[0])) {
        const opts = options2[0];
        i18n.__composerExtend = opts.__composerExtend, i18n.__vueI18nExtend = opts.__vueI18nExtend;
      }
      let globalReleaseHandler = null;
      !__legacyMode && __globalInjection && (globalReleaseHandler = injectGlobalFields(app, i18n.global)), __VUE_I18N_FULL_INSTALL__ && apply(app, i18n, ...options2), __VUE_I18N_LEGACY_API__ && __legacyMode && app.mixin(defineMixin(__global, __global.__composer, i18n));
      const unmountApp = app.unmount;
      if (app.unmount = () => {
        globalReleaseHandler && globalReleaseHandler(), i18n.dispose(), unmountApp();
      }, process.env.NODE_ENV !== "production") {
        if (!await enableDevTools(app, i18n))
          throw createI18nError(I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
        const emitter = createEmitter();
        if (__legacyMode) {
          const _vueI18n = __global;
          _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
        } else {
          const _composer = __global;
          _composer[EnableEmitter] && _composer[EnableEmitter](emitter);
        }
        emitter.on("*", addTimelineEvent);
      }
    },
    // global accessor
    get global() {
      return __global;
    },
    dispose() {
      globalScope.stop();
    },
    // @internal
    __instances,
    // @internal
    __getInstance,
    // @internal
    __setInstance,
    // @internal
    __deleteInstance
  };
  return i18n;
}
__name(createI18n, "createI18n");
function useI18n(options = {}) {
  const instance = getCurrentInstance();
  if (instance == null)
    throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
  if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__)
    throw createI18nError(I18nErrorCodes.NOT_INSTALLED);
  const i18n = getI18nInstance(instance), gl = getGlobalComposer(i18n), componentOptions = getComponentOptions(instance), scope = getScope(options, componentOptions);
  if (scope === "global")
    return adjustI18nResources(gl, options, componentOptions), gl;
  if (scope === "parent") {
    let composer2 = getComposer(i18n, instance, options.__useComponent);
    return composer2 == null && (process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_FOUND_PARENT_SCOPE)), composer2 = gl), composer2;
  }
  const i18nInternal = i18n;
  let composer = i18nInternal.__getInstance(instance);
  if (composer == null) {
    const composerOptions = assign({}, options);
    "__i18n" in componentOptions && (composerOptions.__i18n = componentOptions.__i18n), gl && (composerOptions.__root = gl), composer = createComposer(composerOptions), i18nInternal.__composerExtend && (composer[DisposeSymbol] = i18nInternal.__composerExtend(composer)), setupLifeCycle(i18nInternal, instance, composer), i18nInternal.__setInstance(instance, composer);
  } else if (process.env.NODE_ENV !== "production" && scope === "local")
    throw createI18nError(I18nErrorCodes.DUPLICATE_USE_I18N_CALLING);
  return composer;
}
__name(useI18n, "useI18n");
function createGlobal(options, legacyMode) {
  const scope = effectScope(), obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(() => createVueI18n(options)) : scope.run(() => createComposer(options));
  if (obj == null)
    throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
  return [scope, obj];
}
__name(createGlobal, "createGlobal");
function getI18nInstance(instance) {
  const i18n = inject(instance.isCE ? I18nInjectionKey : instance.appContext.app.__VUE_I18N_SYMBOL__);
  if (!i18n)
    throw createI18nError(instance.isCE ? I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE : I18nErrorCodes.UNEXPECTED_ERROR);
  return i18n;
}
__name(getI18nInstance, "getI18nInstance");
function getScope(options, componentOptions) {
  return isEmptyObject(options) ? "__i18n" in componentOptions ? "local" : "global" : options.useScope ? options.useScope : "local";
}
__name(getScope, "getScope");
function getGlobalComposer(i18n) {
  return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
__name(getGlobalComposer, "getGlobalComposer");
function getComposer(i18n, target, useComponent = !1) {
  let composer = null;
  const root = target.root;
  let current = getParentComponentInstance(target, useComponent);
  for (; current != null; ) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition")
      composer = i18nInternal.__getInstance(current);
    else if (__VUE_I18N_LEGACY_API__) {
      const vueI18n = i18nInternal.__getInstance(current);
      vueI18n != null && (composer = vueI18n.__composer, useComponent && composer && !composer[InejctWithOptionSymbol] && (composer = null));
    }
    if (composer != null || root === current)
      break;
    current = current.parent;
  }
  return composer;
}
__name(getComposer, "getComposer");
function getParentComponentInstance(target, useComponent = !1) {
  return target == null ? null : useComponent && target.vnode.ctx || target.parent;
}
__name(getParentComponentInstance, "getParentComponentInstance");
function setupLifeCycle(i18n, target, composer) {
  let emitter = null;
  onMounted(() => {
    if (process.env.NODE_ENV !== "production" && target.vnode.el) {
      target.vnode.el.__VUE_I18N__ = composer, emitter = createEmitter();
      const _composer = composer;
      _composer[EnableEmitter] && _composer[EnableEmitter](emitter), emitter.on("*", addTimelineEvent);
    }
  }, target), onUnmounted(() => {
    const _composer = composer;
    process.env.NODE_ENV !== "production" && target.vnode.el && target.vnode.el.__VUE_I18N__ && (emitter && emitter.off("*", addTimelineEvent), _composer[DisableEmitter] && _composer[DisableEmitter](), delete target.vnode.el.__VUE_I18N__), i18n.__deleteInstance(target);
    const dispose = _composer[DisposeSymbol];
    dispose && (dispose(), delete _composer[DisposeSymbol]);
  }, target);
}
__name(setupLifeCycle, "setupLifeCycle");
const globalExportProps = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], globalExportMethods = ["t", "rt", "d", "n", "tm", "te"];
function injectGlobalFields(app, composer) {
  const i18n = /* @__PURE__ */ Object.create(null);
  return globalExportProps.forEach((prop) => {
    const desc = Object.getOwnPropertyDescriptor(composer, prop);
    if (!desc)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    const wrap = isRef(desc.value) ? {
      get() {
        return desc.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(val) {
        desc.value.value = val;
      }
    } : {
      get() {
        return desc.get && desc.get();
      }
    };
    Object.defineProperty(i18n, prop, wrap);
  }), app.config.globalProperties.$i18n = i18n, globalExportMethods.forEach((method) => {
    const desc = Object.getOwnPropertyDescriptor(composer, method);
    if (!desc || !desc.value)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
  }), /* @__PURE__ */ __name(() => {
    delete app.config.globalProperties.$i18n, globalExportMethods.forEach((method) => {
      delete app.config.globalProperties[`$${method}`];
    });
  }, "dispose");
}
__name(injectGlobalFields, "injectGlobalFields");
const DatetimeFormatImpl = /* @__PURE__ */ defineComponent({
  /* eslint-disable */
  name: "i18n-d",
  props: assign({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(props, context) {
    const i18n = props.i18n || useI18n({
      useScope: props.scope,
      __useComponent: !0
    });
    return renderFormatter(props, context, DATETIME_FORMAT_OPTIONS_KEYS, (...args) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      i18n[DatetimePartsSymbol](...args)
    ));
  }
}), DatetimeFormat = DatetimeFormatImpl;
initFeatureFlags();
registerMessageCompiler(compile);
registerMessageResolver(resolveValue);
registerLocaleFallbacker(fallbackWithLocaleChain);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const target = getGlobalThis();
  target.__INTLIFY__ = !0, setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function setupSentry(vueApp, appName, signature) {
  let sentryId = getSentryId(), env = getEnvironment(), filteredBrowsers = getFilteredBrowsers();
  if (env == null || env == "dev" || sentryId == null)
    return;
  let release;
  appName && signature && (release = appName + "@" + signature), Sentry.init({
    dsn: sentryId,
    Vue: vueApp,
    attachProps: !0,
    logErrors: !0,
    environment: env,
    release,
    integrations: [Sentry.captureConsoleIntegration({ levels: ["error"] })],
    beforeSend(event, hint) {
      const error2 = hint.originalException;
      if (error2 && error2.message && error2.message.match(/variable height error, rows of wrong lengths/i))
        return null;
      if (event.contexts && event.contexts.browser) {
        let browser = event.contexts.browser.name.toLowercase();
        if (Array.isArray(filteredBrowsers) && filteredBrowsers.includes(browser))
          return null;
      }
      return event;
    }
  });
}
__name(setupSentry, "setupSentry");
function setupGoogleAnalytics(vueApp, router, useGTag = !1, config = {}) {
  let env = getEnvironment(), gaId = getGoogleAnalyticsId();
  if (!(env == null || env == "dev" || gaId == null) && useGTag) {
    let gtmConfig = Object.assign(
      {
        id: gaId,
        vueRouter: router,
        loadScript: !0,
        debug: !1
      },
      config
    ), gtm = createGtm(gtmConfig);
    vueApp.use(gtm);
  }
}
__name(setupGoogleAnalytics, "setupGoogleAnalytics");
function setupI18N(vueApp, messages, locale = "en", fallbackLocale = "en", dateFormats = {}) {
  const i18n = createI18n({
    locale,
    fallbackLocale,
    messages,
    datetimeFormats: dateFormats
  });
  return vueApp.config.globalProperties.$locale = {
    change(lang) {
      i18n.locale = lang;
    },
    current() {
      return i18n.locale;
    }
  }, vueApp.use(i18n), i18n;
}
__name(setupI18N, "setupI18N");
const appSupport = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setupGoogleAnalytics,
  setupI18N,
  setupSentry
}, Symbol.toStringTag, { value: "Module" })), baseSearchPage = {
  data() {
    return {
      /**
       * Array storing all of the facets to be rendered in the activeTab's facet browser
       */
      activeFacets: [],
      /**
       * Stores the fieldName of the active tab or undefined if there is no active tab
       */
      activeTab: void 0,
      /**
       * Whether to display an error message or not
       */
      displayError: !1,
      /**
       * Keeps track of the current facet filter prefix
       */
      facetFilterPrefix: void 0,
      /**
       * Stores the information for each facet which is passed to facetExplorer and used to render and disable
       * facet tabs
       */
      facetInfo: [],
      /**
       * Array of fieldnames used to initialize facetExplorer filterBar checkboxes
       */
      filterBarFilters: [],
      /**
       * Boolean indicating whether the search totals is visible
       */
      isHeaderVisible: !1,
      /**
       * Boolean indicating whether or not the search is loading
       */
      isLoading: !1,
      /**
       * Boolean indicating whether or not the screen width is < 768px
       */
      isMobile: !1,
      /**
       * The page size or number of hits to return in each search
       */
      pageSize: 0,
      /**
       * The maximum number of facets to return for an aggregated facet filter search
       */
      maxFacets: 500,
      /**
       * Filter map constants object
       */
      filterMap: {},
      /**
       * Filters that require translation
       */
      filterTranslationKeys: ["type"],
      /**
       * An object with the parameters of the current search
       */
      searchParams: {
        query: [],
        filters: {},
        from: 0,
        size: this.pageSize
      },
      /*
       * The suggestions from the autocomplete endpoint are stored here and passed to radAdvancedSearchBox for
       * rendering
       */
      suggestions: [],
      /**
       * Keeps track of the total number of search results for the facetExplorer
       */
      total: 0,
      /**
       * Keeps track of current search results
       */
      results: void 0,
      /**
       * Keeps track of current facet data based on current search params
       */
      facets: void 0,
      /**
       * Base url to be overwritten by parent for the API
       */
      apiPath: getApiPath()
    };
  },
  watch: {
    total() {
      this.updateHeaderVisibility(this.total);
    }
  },
  computed: {
    /**
     * The current/active page number for search results, passed to PaginationNav
     * @return number
     */
    currentPage() {
      return this.searchParams.from == 0 ? 1 : Math.floor(this.searchParams.from / this.searchParams.size) + 1;
    },
    /**
     * The current search query which will just be the same as the route in a desktop view, but
     * could represent the facets applied in a mobile overlay.
     */
    currentQuery() {
      return constructQueryObject(this.searchParams, {
        PAGE_SIZE: this.pageSize
      });
    },
    /**
     * Get the searchHash of the current results to be passed to the facetTabs
     * in the facetExplorer for use as keys so the tabs are re-rendered for every new search
     **/
    searchHash() {
      return getSearchHash(this.results);
    },
    /**
     * Error message to display if there's an error with the search
     */
    displayErrorMessage() {
      return this.results ? getErrorMessage(this.results) : void 0;
    },
    /**
     * In a mobile view this filters out all but the activeTab so that only the active tab is displayed
     **/
    mobileFacetInfo() {
      if (this.isMobile && this.activeTab)
        return [this.facetInfo.find((obj) => obj.fieldName == this.activeTab)];
    },
    /**
     * Whether the current search is empty or not
     *
     * @returns {boolean}
     */
    isEmptySearch() {
      return isEmptySearch(this.searchParams);
    },
    /**
     * Stores the title for the search page
     */
    pageTitle() {
      let filters = Object.assign({}, this.searchParams.filters);
      for (let key in filters)
        filters[key] == "true" && (filters[key] = !0), this.chipTerms && Array.isArray(filters[key]) && (filters[key] = filters[key].map((val) => {
          let filterVal = val;
          return this.chipTerms.forEach((chip) => {
            chip.qualifier == key && chip.termValue == val && (filterVal = chip.term);
          }), filterVal;
        }));
      return getSearchResultsTitle(
        this.translate,
        this.searchParams.query,
        this.filterMap,
        this.filterTranslationKeys,
        filters
      );
    },
    /**
     * The Search Input Text when the search input is a string and we're not using keyword chips
     * @returns {string}
     */
    searchInputText() {
      return getSearchInputText(this.searchParams);
    }
  },
  watch: {
    activeTab(prev, incoming) {
      prev != incoming && (this.facetFilterPrefix = void 0);
    }
  },
  methods: {
    /**
     * Default fetch facet function based on current search params
     *
     * @param {object} params - search params object
     *
     * @returns {object|undefined} response from facets api endpoint
     */
    fetchFacets(params) {
      return fetchFacets(params, this.apiPath);
    },
    /**
     * Default fetch search function based on current search params
     *
     * @param {object} params - search params object
     *
     * @returns {object|undefined} response from search api endpoint
     */
    fetchSearch(params) {
      return fetchSearch(params, this.apiPath);
    },
    /**
     * Stub function to be overridden by local helpers for fetching objects
     * based on search param ids
     */
    getSearchParams(_queryObject) {
      return this.searchParams;
    },
    /**
     * Get the max # of facets for a row, returns something different for a date
     *
     * @param {String} facetName
     *
     * @returns {Integer}
     */
    getMaxFacetSize(facetName) {
      return facetName != null && facetName.includes("range") ? 1e5 : this.maxFacets;
    },
    /**
     * Updates facetInfo according to the results of the search described by the search params and enables/disables
     * facet tabs accordingly
     */
    updateFacetInfo() {
      this.results && (this.facetInfo = getFacetInfo(
        this.facetInfo,
        this.results,
        this.activeTab
      ));
    },
    /**
     * Updates filterInfo according to the results of the search described by the search params and enables/disables
     * filter checkboxes accordingly
     */
    updateFilterInfo() {
      this.results && (this.filterInfo = getFilterInfo(
        this.filterInfo,
        this.searchParams,
        this.results
      ));
    },
    /**
     * Fills the activeFacets array when a facet browser is opened
     */
    updateActiveFacets(params) {
      let results = [];
      if (this.activeTab && this.facets) {
        let facetData = this.facets.facets[params.facet];
        facetData && (results = this.postProcessFacetResults(facetData)), this.activeFacets = results;
      }
    },
    /**
     * Processes an array of facet search results and returns an array of results with a label
     * for a result if there is a translation defined in the filterMap
     *
     * @param {Array} - An array of facet search results
     * @returns {Array} - An array of facet search results
     *
     * @example - [ { name: 'Example Name', label: "Example Label", val: 40 } ]
     */
    postProcessFacetResults(results) {
      if (this.filterTranslationKeys.includes(this.activeTab)) {
        let translationMap = this.filterMap[this.activeTab]?.values ? this.filterMap[this.activeTab].values : {};
        Object.keys(translationMap).forEach((key) => {
          let index = results.findIndex(
            (result) => result.name.toLowerCase() == key.toLowerCase()
          );
          if (index != -1) {
            let translation = this.facetTranslation(
              results[index].name.toLowerCase()
            );
            translation && (results[index].label = translation);
          }
        });
      }
      return results;
    },
    /**
     * Processes a name returned with a facet search result and returns a label if it is defined
     * in the filterMap and translation file
     *
     * @param {String} - A name from a facet search result
     * @returns {String} - A translated name
     */
    facetTranslation(term) {
      if (this.filterMap[this.activeTab]) {
        let translationKey = this.filterMap[this.activeTab].values[term];
        if (translationKey) {
          let base = "search_results_title." + this.filterMap.app;
          return this.translate(base + translationKey);
        }
      }
    },
    /**
     * Uses handleSearchEvent to update the route based on the event
     * @param {Object} - The search event fired by the search box, facet explorer, or filter bar
     * @param {Object} - The router object
     */
    updateSearch(event, router) {
      this.suggestions = [];
      let searchEvent = event;
      event.page !== void 0 && (searchEvent = { type: "page", name: "from", value: event.from }), handleSearchEvent(searchEvent, router, this.currentQuery);
    },
    /**
     * Based on tab fieldName, sets a new activeTab and fetches that tab's data
     * or toggles activeTab to undefined
     * @param {String} - The facet tab's fieldName
     */
    async fetchActiveTabData(event) {
      if (this.activeTab == event.fieldName && event.type == null)
        this.activeTab = void 0, this.activeFacets = [];
      else {
        this.activeTab != null && this.activeTab != event.fieldName && (this.facetFilterPrefix = void 0), event.type == "keypressChange" && (this.facetFilterPrefix = event.value), this.activeTab = event.fieldName;
        let params = {
          facet: this.activeTab,
          query: this.searchParams.query,
          filters: this.searchParams.filters,
          size: this.getMaxFacetSize(this.activeTab),
          filter_prefix: this.facetFilterPrefix
        };
        this.facets = await this.fetchFacets(params), this.updateActiveFacets(params);
      }
    },
    /**
     * On text facet panel keypress, fetches and filters active tab filter values
     */
    updateActiveTabFilters(event) {
      this.activeTab != null && this.fetchActiveTabData(event);
    },
    /**
     * Evaluates whether facet explorer header/count should be visible
     */
    updateHeaderVisibility(total) {
      total == 0 || this.isEmptySearch ? this.isHeaderVisible = !1 : this.isHeaderVisible = !0;
    },
    /**
     * For indexed id based filters in current search params, gets primary names from elastic search objects
     *
     * @param {object} params - search params object
     *
     * @returns {object} chipTermIdValues - { indexed_id: "primary_name" }
     */
    async getChipTermIdValues(params) {
      let chipTermIdValues = {}, idFilterValues = await getChipTermIds(params), esObjects = await fetchElasticSearchObjects(
        idFilterValues,
        this.apiPath
      );
      return esObjects?.length && (chipTermIdValues = Object.fromEntries(
        esObjects.map((doc) => [doc.id, doc.primary_name])
      )), chipTermIdValues;
    }
  }
}, useAnalytics = /* @__PURE__ */ __name(({
  appUrl = trimTrailingSlash(getAppUrl()),
  domain = getConfigValue("PLAUSIBLE_DOMAIN"),
  googleEventName = getConfigValue(
    "GOOGLE_EVENT_NAME",
    void 0,
    "event"
  ),
  /**
   * whether to log events to console
   */
  logEvents = getConfigValue("LOCATION_BANNER_LOCATION", void 0, "")
} = {}) => {
  logEvents = logEvents.trim() != "";
  const gtm = useGtm(), plausible = Plausible({
    // trackLocalhost: true,
    domain,
    apiHost: "https://static.getty.edu"
  });
  function sendEvent(event) {
    logEvents && console.log("analytics::", event), gtm && gtm.enabled() && gtm.trackEvent({
      action: event.action,
      event: googleEventName,
      category: event.category,
      label: event.label,
      noninteraction: !0
    }), domain != null && plausible.trackEvent("click", {
      props: {
        action: event.action,
        category: event.category,
        label: event.label
      }
    });
  }
  __name(sendEvent, "sendEvent");
  function getQueryString(route) {
    let qs = "";
    return Object.keys(route).sort().forEach((key) => {
      let values = route[key];
      Array.isArray(values) == !1 && (values = [values]), values.forEach((value) => {
        if (!(value == null || value == "" || typeof value == "string" && value.trim() == "")) {
          if (typeof value == "string" && value.includes("/"))
            try {
              value = value.replaceAll("/", "{slash}");
            } catch {
            }
          qs += `/${key}=${value}`;
        }
      });
    }), qs;
  }
  __name(getQueryString, "getQueryString");
  function sendPageview(title, route, extra = {}) {
    gtm && gtm.enabled() && gtm.trackView(title, route.fullPath);
    let query = {};
    route.query && (query = route.query);
    let props = JSON.parse(JSON.stringify(query)), qs = getQueryString(props);
    if (props.title = title, domain != null)
      try {
        plausible.trackPageview(
          {
            url: appUrl + route.path + qs
          },
          { props: { ...props, ...extra } }
        );
      } catch (e) {
        console.error(e);
      }
  }
  return __name(sendPageview, "sendPageview"), { sendEvent, sendPageview, getQueryString };
}, "useAnalytics"), useAutocomplete = /* @__PURE__ */ __name(function({ apiPath = getApiPath() } = {}) {
  let controller = null, currentSearch = null, isCancelled = null;
  function additionalNormalization(text) {
    return asciiMapText(text);
  }
  __name(additionalNormalization, "additionalNormalization");
  function fetchAutocompleteSuggestions$1(params) {
    return fetchAutocompleteSuggestions(params, apiPath);
  }
  __name(fetchAutocompleteSuggestions$1, "fetchAutocompleteSuggestions$1");
  async function fetchSuggestions(term) {
    let suggestions = [];
    controller && (isCancelled = !0, controller.abort()), currentSearch = term, controller = new AbortController(), isCancelled = !1;
    let newValues = await fetchAutocompleteSuggestions$1({
      prefix: term,
      signal: controller.signal
    });
    return currentSearch == term && newValues != null && isCancelled == !1 && (suggestions = newValues), suggestions;
  }
  __name(fetchSuggestions, "fetchSuggestions");
  function transformQuery(query, _isAutocomplete) {
    return [query];
  }
  return __name(transformQuery, "transformQuery"), {
    transformQuery,
    fetchAutocompleteSuggestions: fetchAutocompleteSuggestions$1,
    fetchSuggestions,
    additionalNormalization
  };
}, "useAutocomplete");
export {
  baseSearchPage as BaseSearchPage,
  addTrailingSlash$1 as addTrailingSlash,
  appSupport,
  ContentStackUtils as contentStackService,
  DataService as dataService,
  DataServiceUtils as dataServiceUtils,
  DateHelpers as dateHelpers,
  deepAssign,
  getIndexedId,
  getObjId,
  sanitize as htmlSanitize,
  idManagerService as idManager,
  Router as routerHelpers,
  SearchService as searchService,
  settings,
  testHelpers,
  toPascalCase,
  trimTrailingSlash,
  useAnalytics,
  useAutocomplete
};
